(function(modules) {
    var installedModules = {};

    function __webpack_require__(moduleId) {
        if (installedModules[moduleId]) {
            return installedModules[moduleId].exports
        }
        var module = installedModules[moduleId] = {
            i: moduleId,
            l: !1,
            exports: {}
        };
        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        module.l = !0;
        return module.exports
    }
    __webpack_require__.m = modules;
    __webpack_require__.c = installedModules;
    __webpack_require__.d = function(exports, name, getter) {
        if (!__webpack_require__.o(exports, name)) {
            Object.defineProperty(exports, name, {
                enumerable: !0,
                get: getter
            })
        }
    };
    __webpack_require__.r = function(exports) {
        if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
            Object.defineProperty(exports, Symbol.toStringTag, {
                value: 'Module'
            })
        }
        Object.defineProperty(exports, '__esModule', {
            value: !0
        })
    };
    __webpack_require__.t = function(value, mode) {
        if (mode & 1) value = __webpack_require__(value);
        if (mode & 8) return value;
        if ((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
        var ns = Object.create(null);
        __webpack_require__.r(ns);
        Object.defineProperty(ns, 'default', {
            enumerable: !0,
            value: value
        });
        if (mode & 2 && typeof value != 'string')
            for (var key in value) __webpack_require__.d(ns, key, function(key) {
                return value[key]
            }.bind(null, key));
        return ns
    };
    __webpack_require__.n = function(module) {
        var getter = module && module.__esModule ? function getDefault() {
            return module['default']
        } : function getModuleExports() {
            return module
        };
        __webpack_require__.d(getter, 'a', getter);
        return getter
    };
    __webpack_require__.o = function(object, property) {
        return Object.prototype.hasOwnProperty.call(object, property)
    };
    __webpack_require__.p = "";
    return __webpack_require__(__webpack_require__.s = "../src/assets/js/main.js")
})({
    "../node_modules/jquery/dist/jquery.js": (function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        (function(global, factory) {
            "use strict";
            if (!0 && typeof module.exports === "object") {
                module.exports = global.document ? factory(global, !0) : function(w) {
                    if (!w.document) {
                        throw new Error("jQuery requires a window with a document")
                    }
                    return factory(w)
                }
            } else {
                factory(global)
            }
        })(typeof window !== "undefined" ? window : this, function(window, noGlobal) {
            "use strict";
            var arr = [];
            var document = window.document;
            var getProto = Object.getPrototypeOf;
            var slice = arr.slice;
            var concat = arr.concat;
            var push = arr.push;
            var indexOf = arr.indexOf;
            var class2type = {};
            var toString = class2type.toString;
            var hasOwn = class2type.hasOwnProperty;
            var fnToString = hasOwn.toString;
            var ObjectFunctionString = fnToString.call(Object);
            var support = {};
            var isFunction = function isFunction(obj) {
                return typeof obj === "function" && typeof obj.nodeType !== "number"
            };
            var isWindow = function isWindow(obj) {
                return obj != null && obj === obj.window
            };
            var preservedScriptAttributes = {
                type: !0,
                src: !0,
                noModule: !0
            };

            function DOMEval(code, doc, node) {
                doc = doc || document;
                var i, script = doc.createElement("script");
                script.text = code;
                if (node) {
                    for (i in preservedScriptAttributes) {
                        if (node[i]) {
                            script[i] = node[i]
                        }
                    }
                }
                doc.head.appendChild(script).parentNode.removeChild(script)
            }

            function toType(obj) {
                if (obj == null) {
                    return obj + ""
                }
                return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj
            }
            var version = "3.3.1",
                jQuery = function(selector, context) {
                    return new jQuery.fn.init(selector, context)
                },
                rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
            jQuery.fn = jQuery.prototype = {
                jquery: version,
                constructor: jQuery,
                length: 0,
                toArray: function() {
                    return slice.call(this)
                },
                get: function(num) {
                    if (num == null) {
                        return slice.call(this)
                    }
                    return num < 0 ? this[num + this.length] : this[num]
                },
                pushStack: function(elems) {
                    var ret = jQuery.merge(this.constructor(), elems);
                    ret.prevObject = this;
                    return ret
                },
                each: function(callback) {
                    return jQuery.each(this, callback)
                },
                map: function(callback) {
                    return this.pushStack(jQuery.map(this, function(elem, i) {
                        return callback.call(elem, i, elem)
                    }))
                },
                slice: function() {
                    return this.pushStack(slice.apply(this, arguments))
                },
                first: function() {
                    return this.eq(0)
                },
                last: function() {
                    return this.eq(-1)
                },
                eq: function(i) {
                    var len = this.length,
                        j = +i + (i < 0 ? len : 0);
                    return this.pushStack(j >= 0 && j < len ? [this[j]] : [])
                },
                end: function() {
                    return this.prevObject || this.constructor()
                },
                push: push,
                sort: arr.sort,
                splice: arr.splice
            };
            jQuery.extend = jQuery.fn.extend = function() {
                var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {},
                    i = 1,
                    length = arguments.length,
                    deep = !1;
                if (typeof target === "boolean") {
                    deep = target;
                    target = arguments[i] || {};
                    i++
                }
                if (typeof target !== "object" && !isFunction(target)) {
                    target = {}
                }
                if (i === length) {
                    target = this;
                    i--
                }
                for (; i < length; i++) {
                    if ((options = arguments[i]) != null) {
                        for (name in options) {
                            src = target[name];
                            copy = options[name];
                            if (target === copy) {
                                continue
                            }
                            if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                                if (copyIsArray) {
                                    copyIsArray = !1;
                                    clone = src && Array.isArray(src) ? src : []
                                } else {
                                    clone = src && jQuery.isPlainObject(src) ? src : {}
                                }
                                target[name] = jQuery.extend(deep, clone, copy)
                            } else if (copy !== undefined) {
                                target[name] = copy
                            }
                        }
                    }
                }
                return target
            };
            jQuery.extend({
                expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
                isReady: !0,
                error: function(msg) {
                    throw new Error(msg)
                },
                noop: function() {},
                isPlainObject: function(obj) {
                    var proto, Ctor;
                    if (!obj || toString.call(obj) !== "[object Object]") {
                        return !1
                    }
                    proto = getProto(obj);
                    if (!proto) {
                        return !0
                    }
                    Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
                    return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString
                },
                isEmptyObject: function(obj) {
                    var name;
                    for (name in obj) {
                        return !1
                    }
                    return !0
                },
                globalEval: function(code) {
                    DOMEval(code)
                },
                each: function(obj, callback) {
                    var length, i = 0;
                    if (isArrayLike(obj)) {
                        length = obj.length;
                        for (; i < length; i++) {
                            if (callback.call(obj[i], i, obj[i]) === !1) {
                                break
                            }
                        }
                    } else {
                        for (i in obj) {
                            if (callback.call(obj[i], i, obj[i]) === !1) {
                                break
                            }
                        }
                    }
                    return obj
                },
                trim: function(text) {
                    return text == null ? "" : (text + "").replace(rtrim, "")
                },
                makeArray: function(arr, results) {
                    var ret = results || [];
                    if (arr != null) {
                        if (isArrayLike(Object(arr))) {
                            jQuery.merge(ret, typeof arr === "string" ? [arr] : arr)
                        } else {
                            push.call(ret, arr)
                        }
                    }
                    return ret
                },
                inArray: function(elem, arr, i) {
                    return arr == null ? -1 : indexOf.call(arr, elem, i)
                },
                merge: function(first, second) {
                    var len = +second.length,
                        j = 0,
                        i = first.length;
                    for (; j < len; j++) {
                        first[i++] = second[j]
                    }
                    first.length = i;
                    return first
                },
                grep: function(elems, callback, invert) {
                    var callbackInverse, matches = [],
                        i = 0,
                        length = elems.length,
                        callbackExpect = !invert;
                    for (; i < length; i++) {
                        callbackInverse = !callback(elems[i], i);
                        if (callbackInverse !== callbackExpect) {
                            matches.push(elems[i])
                        }
                    }
                    return matches
                },
                map: function(elems, callback, arg) {
                    var length, value, i = 0,
                        ret = [];
                    if (isArrayLike(elems)) {
                        length = elems.length;
                        for (; i < length; i++) {
                            value = callback(elems[i], i, arg);
                            if (value != null) {
                                ret.push(value)
                            }
                        }
                    } else {
                        for (i in elems) {
                            value = callback(elems[i], i, arg);
                            if (value != null) {
                                ret.push(value)
                            }
                        }
                    }
                    return concat.apply([], ret)
                },
                guid: 1,
                support: support
            });
            if (typeof Symbol === "function") {
                jQuery.fn[Symbol.iterator] = arr[Symbol.iterator]
            }
            jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(i, name) {
                class2type["[object " + name + "]"] = name.toLowerCase()
            });

            function isArrayLike(obj) {
                var length = !!obj && "length" in obj && obj.length,
                    type = toType(obj);
                if (isFunction(obj) || isWindow(obj)) {
                    return !1
                }
                return type === "array" || length === 0 || typeof length === "number" && length > 0 && (length - 1) in obj
            }
            var Sizzle = (function(window) {
                var i, support, Expr, getText, isXML, tokenize, compile, select, outermostContext, sortInput, hasDuplicate, setDocument, document, docElem, documentIsHTML, rbuggyQSA, rbuggyMatches, matches, contains, expando = "sizzle" + 1 * new Date(),
                    preferredDoc = window.document,
                    dirruns = 0,
                    done = 0,
                    classCache = createCache(),
                    tokenCache = createCache(),
                    compilerCache = createCache(),
                    sortOrder = function(a, b) {
                        if (a === b) {
                            hasDuplicate = !0
                        }
                        return 0
                    },
                    hasOwn = ({}).hasOwnProperty,
                    arr = [],
                    pop = arr.pop,
                    push_native = arr.push,
                    push = arr.push,
                    slice = arr.slice,
                    indexOf = function(list, elem) {
                        var i = 0,
                            len = list.length;
                        for (; i < len; i++) {
                            if (list[i] === elem) {
                                return i
                            }
                        }
                        return -1
                    },
                    booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
                    whitespace = "[\\x20\\t\\r\\n\\f]",
                    identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
                    attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + "*([*^$|!~]?=)" + whitespace + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]",
                    pseudos = ":(" + identifier + ")(?:\\((" + "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + ".*" + ")\\)|)",
                    rwhitespace = new RegExp(whitespace + "+", "g"),
                    rtrim = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g"),
                    rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"),
                    rcombinators = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"),
                    rattributeQuotes = new RegExp("=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g"),
                    rpseudo = new RegExp(pseudos),
                    ridentifier = new RegExp("^" + identifier + "$"),
                    matchExpr = {
                        "ID": new RegExp("^#(" + identifier + ")"),
                        "CLASS": new RegExp("^\\.(" + identifier + ")"),
                        "TAG": new RegExp("^(" + identifier + "|[*])"),
                        "ATTR": new RegExp("^" + attributes),
                        "PSEUDO": new RegExp("^" + pseudos),
                        "CHILD": new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
                        "bool": new RegExp("^(?:" + booleans + ")$", "i"),
                        "needsContext": new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
                    },
                    rinputs = /^(?:input|select|textarea|button)$/i,
                    rheader = /^h\d$/i,
                    rnative = /^[^{]+\{\s*\[native \w/,
                    rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
                    rsibling = /[+~]/,
                    runescape = new RegExp("\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig"),
                    funescape = function(_, escaped, escapedWhitespace) {
                        var high = "0x" + escaped - 0x10000;
                        return high !== high || escapedWhitespace ? escaped : high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00)
                    },
                    rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
                    fcssescape = function(ch, asCodePoint) {
                        if (asCodePoint) {
                            if (ch === "\0") {
                                return "\uFFFD"
                            }
                            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " "
                        }
                        return "\\" + ch
                    },
                    unloadHandler = function() {
                        setDocument()
                    },
                    disabledAncestor = addCombinator(function(elem) {
                        return elem.disabled === !0 && ("form" in elem || "label" in elem)
                    }, {
                        dir: "parentNode",
                        next: "legend"
                    });
                try {
                    push.apply((arr = slice.call(preferredDoc.childNodes)), preferredDoc.childNodes);
                    arr[preferredDoc.childNodes.length].nodeType
                } catch (e) {
                    push = {
                        apply: arr.length ? function(target, els) {
                            push_native.apply(target, slice.call(els))
                        } : function(target, els) {
                            var j = target.length,
                                i = 0;
                            while ((target[j++] = els[i++])) {}
                            target.length = j - 1
                        }
                    }
                }

                function Sizzle(selector, context, results, seed) {
                    var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument,
                        nodeType = context ? context.nodeType : 9;
                    results = results || [];
                    if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) {
                        return results
                    }
                    if (!seed) {
                        if ((context ? context.ownerDocument || context : preferredDoc) !== document) {
                            setDocument(context)
                        }
                        context = context || document;
                        if (documentIsHTML) {
                            if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                                if ((m = match[1])) {
                                    if (nodeType === 9) {
                                        if ((elem = context.getElementById(m))) {
                                            if (elem.id === m) {
                                                results.push(elem);
                                                return results
                                            }
                                        } else {
                                            return results
                                        }
                                    } else {
                                        if (newContext && (elem = newContext.getElementById(m)) && contains(context, elem) && elem.id === m) {
                                            results.push(elem);
                                            return results
                                        }
                                    }
                                } else if (match[2]) {
                                    push.apply(results, context.getElementsByTagName(selector));
                                    return results
                                } else if ((m = match[3]) && support.getElementsByClassName && context.getElementsByClassName) {
                                    push.apply(results, context.getElementsByClassName(m));
                                    return results
                                }
                            }
                            if (support.qsa && !compilerCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                                if (nodeType !== 1) {
                                    newContext = context;
                                    newSelector = selector
                                } else if (context.nodeName.toLowerCase() !== "object") {
                                    if ((nid = context.getAttribute("id"))) {
                                        nid = nid.replace(rcssescape, fcssescape)
                                    } else {
                                        context.setAttribute("id", (nid = expando))
                                    }
                                    groups = tokenize(selector);
                                    i = groups.length;
                                    while (i--) {
                                        groups[i] = "#" + nid + " " + toSelector(groups[i])
                                    }
                                    newSelector = groups.join(",");
                                    newContext = rsibling.test(selector) && testContext(context.parentNode) || context
                                }
                                if (newSelector) {
                                    try {
                                        push.apply(results, newContext.querySelectorAll(newSelector));
                                        return results
                                    } catch (qsaError) {} finally {
                                        if (nid === expando) {
                                            context.removeAttribute("id")
                                        }
                                    }
                                }
                            }
                        }
                    }
                    return select(selector.replace(rtrim, "$1"), context, results, seed)
                }

                function createCache() {
                    var keys = [];

                    function cache(key, value) {
                        if (keys.push(key + " ") > Expr.cacheLength) {
                            delete cache[keys.shift()]
                        }
                        return (cache[key + " "] = value)
                    }
                    return cache
                }

                function markFunction(fn) {
                    fn[expando] = !0;
                    return fn
                }

                function assert(fn) {
                    var el = document.createElement("fieldset");
                    try {
                        return !!fn(el)
                    } catch (e) {
                        return !1
                    } finally {
                        if (el.parentNode) {
                            el.parentNode.removeChild(el)
                        }
                        el = null
                    }
                }

                function addHandle(attrs, handler) {
                    var arr = attrs.split("|"),
                        i = arr.length;
                    while (i--) {
                        Expr.attrHandle[arr[i]] = handler
                    }
                }

                function siblingCheck(a, b) {
                    var cur = b && a,
                        diff = cur && a.nodeType === 1 && b.nodeType === 1 && a.sourceIndex - b.sourceIndex;
                    if (diff) {
                        return diff
                    }
                    if (cur) {
                        while ((cur = cur.nextSibling)) {
                            if (cur === b) {
                                return -1
                            }
                        }
                    }
                    return a ? 1 : -1
                }

                function createInputPseudo(type) {
                    return function(elem) {
                        var name = elem.nodeName.toLowerCase();
                        return name === "input" && elem.type === type
                    }
                }

                function createButtonPseudo(type) {
                    return function(elem) {
                        var name = elem.nodeName.toLowerCase();
                        return (name === "input" || name === "button") && elem.type === type
                    }
                }

                function createDisabledPseudo(disabled) {
                    return function(elem) {
                        if ("form" in elem) {
                            if (elem.parentNode && elem.disabled === !1) {
                                if ("label" in elem) {
                                    if ("label" in elem.parentNode) {
                                        return elem.parentNode.disabled === disabled
                                    } else {
                                        return elem.disabled === disabled
                                    }
                                }
                                return elem.isDisabled === disabled || elem.isDisabled !== !disabled && disabledAncestor(elem) === disabled
                            }
                            return elem.disabled === disabled
                        } else if ("label" in elem) {
                            return elem.disabled === disabled
                        }
                        return !1
                    }
                }

                function createPositionalPseudo(fn) {
                    return markFunction(function(argument) {
                        argument = +argument;
                        return markFunction(function(seed, matches) {
                            var j, matchIndexes = fn([], seed.length, argument),
                                i = matchIndexes.length;
                            while (i--) {
                                if (seed[(j = matchIndexes[i])]) {
                                    seed[j] = !(matches[j] = seed[j])
                                }
                            }
                        })
                    })
                }

                function testContext(context) {
                    return context && typeof context.getElementsByTagName !== "undefined" && context
                }
                support = Sizzle.support = {};
                isXML = Sizzle.isXML = function(elem) {
                    var documentElement = elem && (elem.ownerDocument || elem).documentElement;
                    return documentElement ? documentElement.nodeName !== "HTML" : !1
                };
                setDocument = Sizzle.setDocument = function(node) {
                    var hasCompare, subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
                    if (doc === document || doc.nodeType !== 9 || !doc.documentElement) {
                        return document
                    }
                    document = doc;
                    docElem = document.documentElement;
                    documentIsHTML = !isXML(document);
                    if (preferredDoc !== document && (subWindow = document.defaultView) && subWindow.top !== subWindow) {
                        if (subWindow.addEventListener) {
                            subWindow.addEventListener("unload", unloadHandler, !1)
                        } else if (subWindow.attachEvent) {
                            subWindow.attachEvent("onunload", unloadHandler)
                        }
                    }
                    support.attributes = assert(function(el) {
                        el.className = "i";
                        return !el.getAttribute("className")
                    });
                    support.getElementsByTagName = assert(function(el) {
                        el.appendChild(document.createComment(""));
                        return !el.getElementsByTagName("*").length
                    });
                    support.getElementsByClassName = rnative.test(document.getElementsByClassName);
                    support.getById = assert(function(el) {
                        docElem.appendChild(el).id = expando;
                        return !document.getElementsByName || !document.getElementsByName(expando).length
                    });
                    if (support.getById) {
                        Expr.filter.ID = function(id) {
                            var attrId = id.replace(runescape, funescape);
                            return function(elem) {
                                return elem.getAttribute("id") === attrId
                            }
                        };
                        Expr.find.ID = function(id, context) {
                            if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                                var elem = context.getElementById(id);
                                return elem ? [elem] : []
                            }
                        }
                    } else {
                        Expr.filter.ID = function(id) {
                            var attrId = id.replace(runescape, funescape);
                            return function(elem) {
                                var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                                return node && node.value === attrId
                            }
                        };
                        Expr.find.ID = function(id, context) {
                            if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                                var node, i, elems, elem = context.getElementById(id);
                                if (elem) {
                                    node = elem.getAttributeNode("id");
                                    if (node && node.value === id) {
                                        return [elem]
                                    }
                                    elems = context.getElementsByName(id);
                                    i = 0;
                                    while ((elem = elems[i++])) {
                                        node = elem.getAttributeNode("id");
                                        if (node && node.value === id) {
                                            return [elem]
                                        }
                                    }
                                }
                                return []
                            }
                        }
                    }
                    Expr.find.TAG = support.getElementsByTagName ? function(tag, context) {
                        if (typeof context.getElementsByTagName !== "undefined") {
                            return context.getElementsByTagName(tag)
                        } else if (support.qsa) {
                            return context.querySelectorAll(tag)
                        }
                    } : function(tag, context) {
                        var elem, tmp = [],
                            i = 0,
                            results = context.getElementsByTagName(tag);
                        if (tag === "*") {
                            while ((elem = results[i++])) {
                                if (elem.nodeType === 1) {
                                    tmp.push(elem)
                                }
                            }
                            return tmp
                        }
                        return results
                    };
                    Expr.find.CLASS = support.getElementsByClassName && function(className, context) {
                        if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) {
                            return context.getElementsByClassName(className)
                        }
                    };
                    rbuggyMatches = [];
                    rbuggyQSA = [];
                    if ((support.qsa = rnative.test(document.querySelectorAll))) {
                        assert(function(el) {
                            docElem.appendChild(el).innerHTML = "<a id='" + expando + "'></a>" + "<select id='" + expando + "-\r\\' msallowcapture=''>" + "<option selected=''></option></select>";
                            if (el.querySelectorAll("[msallowcapture^='']").length) {
                                rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")")
                            }
                            if (!el.querySelectorAll("[selected]").length) {
                                rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")")
                            }
                            if (!el.querySelectorAll("[id~=" + expando + "-]").length) {
                                rbuggyQSA.push("~=")
                            }
                            if (!el.querySelectorAll(":checked").length) {
                                rbuggyQSA.push(":checked")
                            }
                            if (!el.querySelectorAll("a#" + expando + "+*").length) {
                                rbuggyQSA.push(".#.+[+~]")
                            }
                        });
                        assert(function(el) {
                            el.innerHTML = "<a href='' disabled='disabled'></a>" + "<select disabled='disabled'><option/></select>";
                            var input = document.createElement("input");
                            input.setAttribute("type", "hidden");
                            el.appendChild(input).setAttribute("name", "D");
                            if (el.querySelectorAll("[name=d]").length) {
                                rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?=")
                            }
                            if (el.querySelectorAll(":enabled").length !== 2) {
                                rbuggyQSA.push(":enabled", ":disabled")
                            }
                            docElem.appendChild(el).disabled = !0;
                            if (el.querySelectorAll(":disabled").length !== 2) {
                                rbuggyQSA.push(":enabled", ":disabled")
                            }
                            el.querySelectorAll("*,:x");
                            rbuggyQSA.push(",.*:")
                        })
                    }
                    if ((support.matchesSelector = rnative.test((matches = docElem.matches || docElem.webkitMatchesSelector || docElem.mozMatchesSelector || docElem.oMatchesSelector || docElem.msMatchesSelector)))) {
                        assert(function(el) {
                            support.disconnectedMatch = matches.call(el, "*");
                            matches.call(el, "[s!='']:x");
                            rbuggyMatches.push("!=", pseudos)
                        })
                    }
                    rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
                    rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"));
                    hasCompare = rnative.test(docElem.compareDocumentPosition);
                    contains = hasCompare || rnative.test(docElem.contains) ? function(a, b) {
                        var adown = a.nodeType === 9 ? a.documentElement : a,
                            bup = b && b.parentNode;
                        return a === bup || !!(bup && bup.nodeType === 1 && (adown.contains ? adown.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16))
                    } : function(a, b) {
                        if (b) {
                            while ((b = b.parentNode)) {
                                if (b === a) {
                                    return !0
                                }
                            }
                        }
                        return !1
                    };
                    sortOrder = hasCompare ? function(a, b) {
                        if (a === b) {
                            hasDuplicate = !0;
                            return 0
                        }
                        var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                        if (compare) {
                            return compare
                        }
                        compare = (a.ownerDocument || a) === (b.ownerDocument || b) ? a.compareDocumentPosition(b) : 1;
                        if (compare & 1 || (!support.sortDetached && b.compareDocumentPosition(a) === compare)) {
                            if (a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a)) {
                                return -1
                            }
                            if (b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b)) {
                                return 1
                            }
                            return sortInput ? (indexOf(sortInput, a) - indexOf(sortInput, b)) : 0
                        }
                        return compare & 4 ? -1 : 1
                    } : function(a, b) {
                        if (a === b) {
                            hasDuplicate = !0;
                            return 0
                        }
                        var cur, i = 0,
                            aup = a.parentNode,
                            bup = b.parentNode,
                            ap = [a],
                            bp = [b];
                        if (!aup || !bup) {
                            return a === document ? -1 : b === document ? 1 : aup ? -1 : bup ? 1 : sortInput ? (indexOf(sortInput, a) - indexOf(sortInput, b)) : 0
                        } else if (aup === bup) {
                            return siblingCheck(a, b)
                        }
                        cur = a;
                        while ((cur = cur.parentNode)) {
                            ap.unshift(cur)
                        }
                        cur = b;
                        while ((cur = cur.parentNode)) {
                            bp.unshift(cur)
                        }
                        while (ap[i] === bp[i]) {
                            i++
                        }
                        return i ? siblingCheck(ap[i], bp[i]) : ap[i] === preferredDoc ? -1 : bp[i] === preferredDoc ? 1 : 0
                    };
                    return document
                };
                Sizzle.matches = function(expr, elements) {
                    return Sizzle(expr, null, null, elements)
                };
                Sizzle.matchesSelector = function(elem, expr) {
                    if ((elem.ownerDocument || elem) !== document) {
                        setDocument(elem)
                    }
                    expr = expr.replace(rattributeQuotes, "='$1']");
                    if (support.matchesSelector && documentIsHTML && !compilerCache[expr + " "] && (!rbuggyMatches || !rbuggyMatches.test(expr)) && (!rbuggyQSA || !rbuggyQSA.test(expr))) {
                        try {
                            var ret = matches.call(elem, expr);
                            if (ret || support.disconnectedMatch || elem.document && elem.document.nodeType !== 11) {
                                return ret
                            }
                        } catch (e) {}
                    }
                    return Sizzle(expr, document, null, [elem]).length > 0
                };
                Sizzle.contains = function(context, elem) {
                    if ((context.ownerDocument || context) !== document) {
                        setDocument(context)
                    }
                    return contains(context, elem)
                };
                Sizzle.attr = function(elem, name) {
                    if ((elem.ownerDocument || elem) !== document) {
                        setDocument(elem)
                    }
                    var fn = Expr.attrHandle[name.toLowerCase()],
                        val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
                    return val !== undefined ? val : support.attributes || !documentIsHTML ? elem.getAttribute(name) : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null
                };
                Sizzle.escape = function(sel) {
                    return (sel + "").replace(rcssescape, fcssescape)
                };
                Sizzle.error = function(msg) {
                    throw new Error("Syntax error, unrecognized expression: " + msg)
                };
                Sizzle.uniqueSort = function(results) {
                    var elem, duplicates = [],
                        j = 0,
                        i = 0;
                    hasDuplicate = !support.detectDuplicates;
                    sortInput = !support.sortStable && results.slice(0);
                    results.sort(sortOrder);
                    if (hasDuplicate) {
                        while ((elem = results[i++])) {
                            if (elem === results[i]) {
                                j = duplicates.push(i)
                            }
                        }
                        while (j--) {
                            results.splice(duplicates[j], 1)
                        }
                    }
                    sortInput = null;
                    return results
                };
                getText = Sizzle.getText = function(elem) {
                    var node, ret = "",
                        i = 0,
                        nodeType = elem.nodeType;
                    if (!nodeType) {
                        while ((node = elem[i++])) {
                            ret += getText(node)
                        }
                    } else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
                        if (typeof elem.textContent === "string") {
                            return elem.textContent
                        } else {
                            for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
                                ret += getText(elem)
                            }
                        }
                    } else if (nodeType === 3 || nodeType === 4) {
                        return elem.nodeValue
                    }
                    return ret
                };
                Expr = Sizzle.selectors = {
                    cacheLength: 50,
                    createPseudo: markFunction,
                    match: matchExpr,
                    attrHandle: {},
                    find: {},
                    relative: {
                        ">": {
                            dir: "parentNode",
                            first: !0
                        },
                        " ": {
                            dir: "parentNode"
                        },
                        "+": {
                            dir: "previousSibling",
                            first: !0
                        },
                        "~": {
                            dir: "previousSibling"
                        }
                    },
                    preFilter: {
                        "ATTR": function(match) {
                            match[1] = match[1].replace(runescape, funescape);
                            match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                            if (match[2] === "~=") {
                                match[3] = " " + match[3] + " "
                            }
                            return match.slice(0, 4)
                        },
                        "CHILD": function(match) {
                            match[1] = match[1].toLowerCase();
                            if (match[1].slice(0, 3) === "nth") {
                                if (!match[3]) {
                                    Sizzle.error(match[0])
                                }
                                match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                                match[5] = +((match[7] + match[8]) || match[3] === "odd")
                            } else if (match[3]) {
                                Sizzle.error(match[0])
                            }
                            return match
                        },
                        "PSEUDO": function(match) {
                            var excess, unquoted = !match[6] && match[2];
                            if (matchExpr.CHILD.test(match[0])) {
                                return null
                            }
                            if (match[3]) {
                                match[2] = match[4] || match[5] || ""
                            } else if (unquoted && rpseudo.test(unquoted) && (excess = tokenize(unquoted, !0)) && (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                                match[0] = match[0].slice(0, excess);
                                match[2] = unquoted.slice(0, excess)
                            }
                            return match.slice(0, 3)
                        }
                    },
                    filter: {
                        "TAG": function(nodeNameSelector) {
                            var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                            return nodeNameSelector === "*" ? function() {
                                return !0
                            } : function(elem) {
                                return elem.nodeName && elem.nodeName.toLowerCase() === nodeName
                            }
                        },
                        "CLASS": function(className) {
                            var pattern = classCache[className + " "];
                            return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)")) && classCache(className, function(elem) {
                                return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "")
                            })
                        },
                        "ATTR": function(name, operator, check) {
                            return function(elem) {
                                var result = Sizzle.attr(elem, name);
                                if (result == null) {
                                    return operator === "!="
                                }
                                if (!operator) {
                                    return !0
                                }
                                result += "";
                                return operator === "=" ? result === check : operator === "!=" ? result !== check : operator === "^=" ? check && result.indexOf(check) === 0 : operator === "*=" ? check && result.indexOf(check) > -1 : operator === "$=" ? check && result.slice(-check.length) === check : operator === "~=" ? (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1 : operator === "|=" ? result === check || result.slice(0, check.length + 1) === check + "-" : !1
                            }
                        },
                        "CHILD": function(type, what, argument, first, last) {
                            var simple = type.slice(0, 3) !== "nth",
                                forward = type.slice(-4) !== "last",
                                ofType = what === "of-type";
                            return first === 1 && last === 0 ? function(elem) {
                                return !!elem.parentNode
                            } : function(elem, context, xml) {
                                var cache, uniqueCache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling",
                                    parent = elem.parentNode,
                                    name = ofType && elem.nodeName.toLowerCase(),
                                    useCache = !xml && !ofType,
                                    diff = !1;
                                if (parent) {
                                    if (simple) {
                                        while (dir) {
                                            node = elem;
                                            while ((node = node[dir])) {
                                                if (ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) {
                                                    return !1
                                                }
                                            }
                                            start = dir = type === "only" && !start && "nextSibling"
                                        }
                                        return !0
                                    }
                                    start = [forward ? parent.firstChild : parent.lastChild];
                                    if (forward && useCache) {
                                        node = parent;
                                        outerCache = node[expando] || (node[expando] = {});
                                        uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                        cache = uniqueCache[type] || [];
                                        nodeIndex = cache[0] === dirruns && cache[1];
                                        diff = nodeIndex && cache[2];
                                        node = nodeIndex && parent.childNodes[nodeIndex];
                                        while ((node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())) {
                                            if (node.nodeType === 1 && ++diff && node === elem) {
                                                uniqueCache[type] = [dirruns, nodeIndex, diff];
                                                break
                                            }
                                        }
                                    } else {
                                        if (useCache) {
                                            node = elem;
                                            outerCache = node[expando] || (node[expando] = {});
                                            uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                            cache = uniqueCache[type] || [];
                                            nodeIndex = cache[0] === dirruns && cache[1];
                                            diff = nodeIndex
                                        }
                                        if (diff === !1) {
                                            while ((node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())) {
                                                if ((ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) && ++diff) {
                                                    if (useCache) {
                                                        outerCache = node[expando] || (node[expando] = {});
                                                        uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                                        uniqueCache[type] = [dirruns, diff]
                                                    }
                                                    if (node === elem) {
                                                        break
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    diff -= last;
                                    return diff === first || (diff % first === 0 && diff / first >= 0)
                                }
                            }
                        },
                        "PSEUDO": function(pseudo, argument) {
                            var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || Sizzle.error("unsupported pseudo: " + pseudo);
                            if (fn[expando]) {
                                return fn(argument)
                            }
                            if (fn.length > 1) {
                                args = [pseudo, pseudo, "", argument];
                                return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                                    var idx, matched = fn(seed, argument),
                                        i = matched.length;
                                    while (i--) {
                                        idx = indexOf(seed, matched[i]);
                                        seed[idx] = !(matches[idx] = matched[i])
                                    }
                                }) : function(elem) {
                                    return fn(elem, 0, args)
                                }
                            }
                            return fn
                        }
                    },
                    pseudos: {
                        "not": markFunction(function(selector) {
                            var input = [],
                                results = [],
                                matcher = compile(selector.replace(rtrim, "$1"));
                            return matcher[expando] ? markFunction(function(seed, matches, context, xml) {
                                var elem, unmatched = matcher(seed, null, xml, []),
                                    i = seed.length;
                                while (i--) {
                                    if ((elem = unmatched[i])) {
                                        seed[i] = !(matches[i] = elem)
                                    }
                                }
                            }) : function(elem, context, xml) {
                                input[0] = elem;
                                matcher(input, null, xml, results);
                                input[0] = null;
                                return !results.pop()
                            }
                        }),
                        "has": markFunction(function(selector) {
                            return function(elem) {
                                return Sizzle(selector, elem).length > 0
                            }
                        }),
                        "contains": markFunction(function(text) {
                            text = text.replace(runescape, funescape);
                            return function(elem) {
                                return (elem.textContent || elem.innerText || getText(elem)).indexOf(text) > -1
                            }
                        }),
                        "lang": markFunction(function(lang) {
                            if (!ridentifier.test(lang || "")) {
                                Sizzle.error("unsupported lang: " + lang)
                            }
                            lang = lang.replace(runescape, funescape).toLowerCase();
                            return function(elem) {
                                var elemLang;
                                do {
                                    if ((elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang"))) {
                                        elemLang = elemLang.toLowerCase();
                                        return elemLang === lang || elemLang.indexOf(lang + "-") === 0
                                    }
                                } while ((elem = elem.parentNode) && elem.nodeType === 1);
                                return !1
                            }
                        }),
                        "target": function(elem) {
                            var hash = window.location && window.location.hash;
                            return hash && hash.slice(1) === elem.id
                        },
                        "root": function(elem) {
                            return elem === docElem
                        },
                        "focus": function(elem) {
                            return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex)
                        },
                        "enabled": createDisabledPseudo(!1),
                        "disabled": createDisabledPseudo(!0),
                        "checked": function(elem) {
                            var nodeName = elem.nodeName.toLowerCase();
                            return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected)
                        },
                        "selected": function(elem) {
                            if (elem.parentNode) {
                                elem.parentNode.selectedIndex
                            }
                            return elem.selected === !0
                        },
                        "empty": function(elem) {
                            for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
                                if (elem.nodeType < 6) {
                                    return !1
                                }
                            }
                            return !0
                        },
                        "parent": function(elem) {
                            return !Expr.pseudos.empty(elem)
                        },
                        "header": function(elem) {
                            return rheader.test(elem.nodeName)
                        },
                        "input": function(elem) {
                            return rinputs.test(elem.nodeName)
                        },
                        "button": function(elem) {
                            var name = elem.nodeName.toLowerCase();
                            return name === "input" && elem.type === "button" || name === "button"
                        },
                        "text": function(elem) {
                            var attr;
                            return elem.nodeName.toLowerCase() === "input" && elem.type === "text" && ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text")
                        },
                        "first": createPositionalPseudo(function() {
                            return [0]
                        }),
                        "last": createPositionalPseudo(function(matchIndexes, length) {
                            return [length - 1]
                        }),
                        "eq": createPositionalPseudo(function(matchIndexes, length, argument) {
                            return [argument < 0 ? argument + length : argument]
                        }),
                        "even": createPositionalPseudo(function(matchIndexes, length) {
                            var i = 0;
                            for (; i < length; i += 2) {
                                matchIndexes.push(i)
                            }
                            return matchIndexes
                        }),
                        "odd": createPositionalPseudo(function(matchIndexes, length) {
                            var i = 1;
                            for (; i < length; i += 2) {
                                matchIndexes.push(i)
                            }
                            return matchIndexes
                        }),
                        "lt": createPositionalPseudo(function(matchIndexes, length, argument) {
                            var i = argument < 0 ? argument + length : argument;
                            for (; --i >= 0;) {
                                matchIndexes.push(i)
                            }
                            return matchIndexes
                        }),
                        "gt": createPositionalPseudo(function(matchIndexes, length, argument) {
                            var i = argument < 0 ? argument + length : argument;
                            for (; ++i < length;) {
                                matchIndexes.push(i)
                            }
                            return matchIndexes
                        })
                    }
                };
                Expr.pseudos.nth = Expr.pseudos.eq;
                for (i in {
                        radio: !0,
                        checkbox: !0,
                        file: !0,
                        password: !0,
                        image: !0
                    }) {
                    Expr.pseudos[i] = createInputPseudo(i)
                }
                for (i in {
                        submit: !0,
                        reset: !0
                    }) {
                    Expr.pseudos[i] = createButtonPseudo(i)
                }

                function setFilters() {}
                setFilters.prototype = Expr.filters = Expr.pseudos;
                Expr.setFilters = new setFilters();
                tokenize = Sizzle.tokenize = function(selector, parseOnly) {
                    var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
                    if (cached) {
                        return parseOnly ? 0 : cached.slice(0)
                    }
                    soFar = selector;
                    groups = [];
                    preFilters = Expr.preFilter;
                    while (soFar) {
                        if (!matched || (match = rcomma.exec(soFar))) {
                            if (match) {
                                soFar = soFar.slice(match[0].length) || soFar
                            }
                            groups.push((tokens = []))
                        }
                        matched = !1;
                        if ((match = rcombinators.exec(soFar))) {
                            matched = match.shift();
                            tokens.push({
                                value: matched,
                                type: match[0].replace(rtrim, " ")
                            });
                            soFar = soFar.slice(matched.length)
                        }
                        for (type in Expr.filter) {
                            if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                                matched = match.shift();
                                tokens.push({
                                    value: matched,
                                    type: type,
                                    matches: match
                                });
                                soFar = soFar.slice(matched.length)
                            }
                        }
                        if (!matched) {
                            break
                        }
                    }
                    return parseOnly ? soFar.length : soFar ? Sizzle.error(selector) : tokenCache(selector, groups).slice(0)
                };

                function toSelector(tokens) {
                    var i = 0,
                        len = tokens.length,
                        selector = "";
                    for (; i < len; i++) {
                        selector += tokens[i].value
                    }
                    return selector
                }

                function addCombinator(matcher, combinator, base) {
                    var dir = combinator.dir,
                        skip = combinator.next,
                        key = skip || dir,
                        checkNonElements = base && key === "parentNode",
                        doneName = done++;
                    return combinator.first ? function(elem, context, xml) {
                        while ((elem = elem[dir])) {
                            if (elem.nodeType === 1 || checkNonElements) {
                                return matcher(elem, context, xml)
                            }
                        }
                        return !1
                    } : function(elem, context, xml) {
                        var oldCache, uniqueCache, outerCache, newCache = [dirruns, doneName];
                        if (xml) {
                            while ((elem = elem[dir])) {
                                if (elem.nodeType === 1 || checkNonElements) {
                                    if (matcher(elem, context, xml)) {
                                        return !0
                                    }
                                }
                            }
                        } else {
                            while ((elem = elem[dir])) {
                                if (elem.nodeType === 1 || checkNonElements) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    uniqueCache = outerCache[elem.uniqueID] || (outerCache[elem.uniqueID] = {});
                                    if (skip && skip === elem.nodeName.toLowerCase()) {
                                        elem = elem[dir] || elem
                                    } else if ((oldCache = uniqueCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) {
                                        return (newCache[2] = oldCache[2])
                                    } else {
                                        uniqueCache[key] = newCache;
                                        if ((newCache[2] = matcher(elem, context, xml))) {
                                            return !0
                                        }
                                    }
                                }
                            }
                        }
                        return !1
                    }
                }

                function elementMatcher(matchers) {
                    return matchers.length > 1 ? function(elem, context, xml) {
                        var i = matchers.length;
                        while (i--) {
                            if (!matchers[i](elem, context, xml)) {
                                return !1
                            }
                        }
                        return !0
                    } : matchers[0]
                }

                function multipleContexts(selector, contexts, results) {
                    var i = 0,
                        len = contexts.length;
                    for (; i < len; i++) {
                        Sizzle(selector, contexts[i], results)
                    }
                    return results
                }

                function condense(unmatched, map, filter, context, xml) {
                    var elem, newUnmatched = [],
                        i = 0,
                        len = unmatched.length,
                        mapped = map != null;
                    for (; i < len; i++) {
                        if ((elem = unmatched[i])) {
                            if (!filter || filter(elem, context, xml)) {
                                newUnmatched.push(elem);
                                if (mapped) {
                                    map.push(i)
                                }
                            }
                        }
                    }
                    return newUnmatched
                }

                function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
                    if (postFilter && !postFilter[expando]) {
                        postFilter = setMatcher(postFilter)
                    }
                    if (postFinder && !postFinder[expando]) {
                        postFinder = setMatcher(postFinder, postSelector)
                    }
                    return markFunction(function(seed, results, context, xml) {
                        var temp, i, elem, preMap = [],
                            postMap = [],
                            preexisting = results.length,
                            elems = seed || multipleContexts(selector || "*", context.nodeType ? [context] : context, []),
                            matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems,
                            matcherOut = matcher ? postFinder || (seed ? preFilter : preexisting || postFilter) ? [] : results : matcherIn;
                        if (matcher) {
                            matcher(matcherIn, matcherOut, context, xml)
                        }
                        if (postFilter) {
                            temp = condense(matcherOut, postMap);
                            postFilter(temp, [], context, xml);
                            i = temp.length;
                            while (i--) {
                                if ((elem = temp[i])) {
                                    matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem)
                                }
                            }
                        }
                        if (seed) {
                            if (postFinder || preFilter) {
                                if (postFinder) {
                                    temp = [];
                                    i = matcherOut.length;
                                    while (i--) {
                                        if ((elem = matcherOut[i])) {
                                            temp.push((matcherIn[i] = elem))
                                        }
                                    }
                                    postFinder(null, (matcherOut = []), temp, xml)
                                }
                                i = matcherOut.length;
                                while (i--) {
                                    if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf(seed, elem) : preMap[i]) > -1) {
                                        seed[temp] = !(results[temp] = elem)
                                    }
                                }
                            }
                        } else {
                            matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                            if (postFinder) {
                                postFinder(null, results, matcherOut, xml)
                            } else {
                                push.apply(results, matcherOut)
                            }
                        }
                    })
                }

                function matcherFromTokens(tokens) {
                    var checkContext, matcher, j, len = tokens.length,
                        leadingRelative = Expr.relative[tokens[0].type],
                        implicitRelative = leadingRelative || Expr.relative[" "],
                        i = leadingRelative ? 1 : 0,
                        matchContext = addCombinator(function(elem) {
                            return elem === checkContext
                        }, implicitRelative, !0),
                        matchAnyContext = addCombinator(function(elem) {
                            return indexOf(checkContext, elem) > -1
                        }, implicitRelative, !0),
                        matchers = [function(elem, context, xml) {
                            var ret = (!leadingRelative && (xml || context !== outermostContext)) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                            checkContext = null;
                            return ret
                        }];
                    for (; i < len; i++) {
                        if ((matcher = Expr.relative[tokens[i].type])) {
                            matchers = [addCombinator(elementMatcher(matchers), matcher)]
                        } else {
                            matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                            if (matcher[expando]) {
                                j = ++i;
                                for (; j < len; j++) {
                                    if (Expr.relative[tokens[j].type]) {
                                        break
                                    }
                                }
                                return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(tokens.slice(0, i - 1).concat({
                                    value: tokens[i - 2].type === " " ? "*" : ""
                                })).replace(rtrim, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens((tokens = tokens.slice(j))), j < len && toSelector(tokens))
                            }
                            matchers.push(matcher)
                        }
                    }
                    return elementMatcher(matchers)
                }

                function matcherFromGroupMatchers(elementMatchers, setMatchers) {
                    var bySet = setMatchers.length > 0,
                        byElement = elementMatchers.length > 0,
                        superMatcher = function(seed, context, xml, results, outermost) {
                            var elem, j, matcher, matchedCount = 0,
                                i = "0",
                                unmatched = seed && [],
                                setMatched = [],
                                contextBackup = outermostContext,
                                elems = seed || byElement && Expr.find.TAG("*", outermost),
                                dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
                                len = elems.length;
                            if (outermost) {
                                outermostContext = context === document || context || outermost
                            }
                            for (; i !== len && (elem = elems[i]) != null; i++) {
                                if (byElement && elem) {
                                    j = 0;
                                    if (!context && elem.ownerDocument !== document) {
                                        setDocument(elem);
                                        xml = !documentIsHTML
                                    }
                                    while ((matcher = elementMatchers[j++])) {
                                        if (matcher(elem, context || document, xml)) {
                                            results.push(elem);
                                            break
                                        }
                                    }
                                    if (outermost) {
                                        dirruns = dirrunsUnique
                                    }
                                }
                                if (bySet) {
                                    if ((elem = !matcher && elem)) {
                                        matchedCount--
                                    }
                                    if (seed) {
                                        unmatched.push(elem)
                                    }
                                }
                            }
                            matchedCount += i;
                            if (bySet && i !== matchedCount) {
                                j = 0;
                                while ((matcher = setMatchers[j++])) {
                                    matcher(unmatched, setMatched, context, xml)
                                }
                                if (seed) {
                                    if (matchedCount > 0) {
                                        while (i--) {
                                            if (!(unmatched[i] || setMatched[i])) {
                                                setMatched[i] = pop.call(results)
                                            }
                                        }
                                    }
                                    setMatched = condense(setMatched)
                                }
                                push.apply(results, setMatched);
                                if (outermost && !seed && setMatched.length > 0 && (matchedCount + setMatchers.length) > 1) {
                                    Sizzle.uniqueSort(results)
                                }
                            }
                            if (outermost) {
                                dirruns = dirrunsUnique;
                                outermostContext = contextBackup
                            }
                            return unmatched
                        };
                    return bySet ? markFunction(superMatcher) : superMatcher
                }
                compile = Sizzle.compile = function(selector, match) {
                    var i, setMatchers = [],
                        elementMatchers = [],
                        cached = compilerCache[selector + " "];
                    if (!cached) {
                        if (!match) {
                            match = tokenize(selector)
                        }
                        i = match.length;
                        while (i--) {
                            cached = matcherFromTokens(match[i]);
                            if (cached[expando]) {
                                setMatchers.push(cached)
                            } else {
                                elementMatchers.push(cached)
                            }
                        }
                        cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                        cached.selector = selector
                    }
                    return cached
                };
                select = Sizzle.select = function(selector, context, results, seed) {
                    var i, tokens, token, type, find, compiled = typeof selector === "function" && selector,
                        match = !seed && tokenize((selector = compiled.selector || selector));
                    results = results || [];
                    if (match.length === 1) {
                        tokens = match[0] = match[0].slice(0);
                        if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                            context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                            if (!context) {
                                return results
                            } else if (compiled) {
                                context = context.parentNode
                            }
                            selector = selector.slice(tokens.shift().value.length)
                        }
                        i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                        while (i--) {
                            token = tokens[i];
                            if (Expr.relative[(type = token.type)]) {
                                break
                            }
                            if ((find = Expr.find[type])) {
                                if ((seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context))) {
                                    tokens.splice(i, 1);
                                    selector = seed.length && toSelector(tokens);
                                    if (!selector) {
                                        push.apply(results, seed);
                                        return results
                                    }
                                    break
                                }
                            }
                        }
                    }(compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
                    return results
                };
                support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
                support.detectDuplicates = !!hasDuplicate;
                setDocument();
                support.sortDetached = assert(function(el) {
                    return el.compareDocumentPosition(document.createElement("fieldset")) & 1
                });
                if (!assert(function(el) {
                        el.innerHTML = "<a href='#'></a>";
                        return el.firstChild.getAttribute("href") === "#"
                    })) {
                    addHandle("type|href|height|width", function(elem, name, isXML) {
                        if (!isXML) {
                            return elem.getAttribute(name, name.toLowerCase() === "type" ? 1 : 2)
                        }
                    })
                }
                if (!support.attributes || !assert(function(el) {
                        el.innerHTML = "<input/>";
                        el.firstChild.setAttribute("value", "");
                        return el.firstChild.getAttribute("value") === ""
                    })) {
                    addHandle("value", function(elem, name, isXML) {
                        if (!isXML && elem.nodeName.toLowerCase() === "input") {
                            return elem.defaultValue
                        }
                    })
                }
                if (!assert(function(el) {
                        return el.getAttribute("disabled") == null
                    })) {
                    addHandle(booleans, function(elem, name, isXML) {
                        var val;
                        if (!isXML) {
                            return elem[name] === !0 ? name.toLowerCase() : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null
                        }
                    })
                }
                return Sizzle
            })(window);
            jQuery.find = Sizzle;
            jQuery.expr = Sizzle.selectors;
            jQuery.expr[":"] = jQuery.expr.pseudos;
            jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
            jQuery.text = Sizzle.getText;
            jQuery.isXMLDoc = Sizzle.isXML;
            jQuery.contains = Sizzle.contains;
            jQuery.escapeSelector = Sizzle.escape;
            var dir = function(elem, dir, until) {
                var matched = [],
                    truncate = until !== undefined;
                while ((elem = elem[dir]) && elem.nodeType !== 9) {
                    if (elem.nodeType === 1) {
                        if (truncate && jQuery(elem).is(until)) {
                            break
                        }
                        matched.push(elem)
                    }
                }
                return matched
            };
            var siblings = function(n, elem) {
                var matched = [];
                for (; n; n = n.nextSibling) {
                    if (n.nodeType === 1 && n !== elem) {
                        matched.push(n)
                    }
                }
                return matched
            };
            var rneedsContext = jQuery.expr.match.needsContext;

            function nodeName(elem, name) {
                return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase()
            };
            var rsingleTag = (/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i);

            function winnow(elements, qualifier, not) {
                if (isFunction(qualifier)) {
                    return jQuery.grep(elements, function(elem, i) {
                        return !!qualifier.call(elem, i, elem) !== not
                    })
                }
                if (qualifier.nodeType) {
                    return jQuery.grep(elements, function(elem) {
                        return (elem === qualifier) !== not
                    })
                }
                if (typeof qualifier !== "string") {
                    return jQuery.grep(elements, function(elem) {
                        return (indexOf.call(qualifier, elem) > -1) !== not
                    })
                }
                return jQuery.filter(qualifier, elements, not)
            }
            jQuery.filter = function(expr, elems, not) {
                var elem = elems[0];
                if (not) {
                    expr = ":not(" + expr + ")"
                }
                if (elems.length === 1 && elem.nodeType === 1) {
                    return jQuery.find.matchesSelector(elem, expr) ? [elem] : []
                }
                return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
                    return elem.nodeType === 1
                }))
            };
            jQuery.fn.extend({
                find: function(selector) {
                    var i, ret, len = this.length,
                        self = this;
                    if (typeof selector !== "string") {
                        return this.pushStack(jQuery(selector).filter(function() {
                            for (i = 0; i < len; i++) {
                                if (jQuery.contains(self[i], this)) {
                                    return !0
                                }
                            }
                        }))
                    }
                    ret = this.pushStack([]);
                    for (i = 0; i < len; i++) {
                        jQuery.find(selector, self[i], ret)
                    }
                    return len > 1 ? jQuery.uniqueSort(ret) : ret
                },
                filter: function(selector) {
                    return this.pushStack(winnow(this, selector || [], !1))
                },
                not: function(selector) {
                    return this.pushStack(winnow(this, selector || [], !0))
                },
                is: function(selector) {
                    return !!winnow(this, typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], !1).length
                }
            });
            var rootjQuery, rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
                init = jQuery.fn.init = function(selector, context, root) {
                    var match, elem;
                    if (!selector) {
                        return this
                    }
                    root = root || rootjQuery;
                    if (typeof selector === "string") {
                        if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) {
                            match = [null, selector, null]
                        } else {
                            match = rquickExpr.exec(selector)
                        }
                        if (match && (match[1] || !context)) {
                            if (match[1]) {
                                context = context instanceof jQuery ? context[0] : context;
                                jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, !0));
                                if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                                    for (match in context) {
                                        if (isFunction(this[match])) {
                                            this[match](context[match])
                                        } else {
                                            this.attr(match, context[match])
                                        }
                                    }
                                }
                                return this
                            } else {
                                elem = document.getElementById(match[2]);
                                if (elem) {
                                    this[0] = elem;
                                    this.length = 1
                                }
                                return this
                            }
                        } else if (!context || context.jquery) {
                            return (context || root).find(selector)
                        } else {
                            return this.constructor(context).find(selector)
                        }
                    } else if (selector.nodeType) {
                        this[0] = selector;
                        this.length = 1;
                        return this
                    } else if (isFunction(selector)) {
                        return root.ready !== undefined ? root.ready(selector) : selector(jQuery)
                    }
                    return jQuery.makeArray(selector, this)
                };
            init.prototype = jQuery.fn;
            rootjQuery = jQuery(document);
            var rparentsprev = /^(?:parents|prev(?:Until|All))/,
                guaranteedUnique = {
                    children: !0,
                    contents: !0,
                    next: !0,
                    prev: !0
                };
            jQuery.fn.extend({
                has: function(target) {
                    var targets = jQuery(target, this),
                        l = targets.length;
                    return this.filter(function() {
                        var i = 0;
                        for (; i < l; i++) {
                            if (jQuery.contains(this, targets[i])) {
                                return !0
                            }
                        }
                    })
                },
                closest: function(selectors, context) {
                    var cur, i = 0,
                        l = this.length,
                        matched = [],
                        targets = typeof selectors !== "string" && jQuery(selectors);
                    if (!rneedsContext.test(selectors)) {
                        for (; i < l; i++) {
                            for (cur = this[i]; cur && cur !== context; cur = cur.parentNode) {
                                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                                    matched.push(cur);
                                    break
                                }
                            }
                        }
                    }
                    return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched)
                },
                index: function(elem) {
                    if (!elem) {
                        return (this[0] && this[0].parentNode) ? this.first().prevAll().length : -1
                    }
                    if (typeof elem === "string") {
                        return indexOf.call(jQuery(elem), this[0])
                    }
                    return indexOf.call(this, elem.jquery ? elem[0] : elem)
                },
                add: function(selector, context) {
                    return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))))
                },
                addBack: function(selector) {
                    return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector))
                }
            });

            function sibling(cur, dir) {
                while ((cur = cur[dir]) && cur.nodeType !== 1) {}
                return cur
            }
            jQuery.each({
                parent: function(elem) {
                    var parent = elem.parentNode;
                    return parent && parent.nodeType !== 11 ? parent : null
                },
                parents: function(elem) {
                    return dir(elem, "parentNode")
                },
                parentsUntil: function(elem, i, until) {
                    return dir(elem, "parentNode", until)
                },
                next: function(elem) {
                    return sibling(elem, "nextSibling")
                },
                prev: function(elem) {
                    return sibling(elem, "previousSibling")
                },
                nextAll: function(elem) {
                    return dir(elem, "nextSibling")
                },
                prevAll: function(elem) {
                    return dir(elem, "previousSibling")
                },
                nextUntil: function(elem, i, until) {
                    return dir(elem, "nextSibling", until)
                },
                prevUntil: function(elem, i, until) {
                    return dir(elem, "previousSibling", until)
                },
                siblings: function(elem) {
                    return siblings((elem.parentNode || {}).firstChild, elem)
                },
                children: function(elem) {
                    return siblings(elem.firstChild)
                },
                contents: function(elem) {
                    if (nodeName(elem, "iframe")) {
                        return elem.contentDocument
                    }
                    if (nodeName(elem, "template")) {
                        elem = elem.content || elem
                    }
                    return jQuery.merge([], elem.childNodes)
                }
            }, function(name, fn) {
                jQuery.fn[name] = function(until, selector) {
                    var matched = jQuery.map(this, fn, until);
                    if (name.slice(-5) !== "Until") {
                        selector = until
                    }
                    if (selector && typeof selector === "string") {
                        matched = jQuery.filter(selector, matched)
                    }
                    if (this.length > 1) {
                        if (!guaranteedUnique[name]) {
                            jQuery.uniqueSort(matched)
                        }
                        if (rparentsprev.test(name)) {
                            matched.reverse()
                        }
                    }
                    return this.pushStack(matched)
                }
            });
            var rnothtmlwhite = (/[^\x20\t\r\n\f]+/g);

            function createOptions(options) {
                var object = {};
                jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
                    object[flag] = !0
                });
                return object
            }
            jQuery.Callbacks = function(options) {
                options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
                var firing, memory, fired, locked, list = [],
                    queue = [],
                    firingIndex = -1,
                    fire = function() {
                        locked = locked || options.once;
                        fired = firing = !0;
                        for (; queue.length; firingIndex = -1) {
                            memory = queue.shift();
                            while (++firingIndex < list.length) {
                                if (list[firingIndex].apply(memory[0], memory[1]) === !1 && options.stopOnFalse) {
                                    firingIndex = list.length;
                                    memory = !1
                                }
                            }
                        }
                        if (!options.memory) {
                            memory = !1
                        }
                        firing = !1;
                        if (locked) {
                            if (memory) {
                                list = []
                            } else {
                                list = ""
                            }
                        }
                    },
                    self = {
                        add: function() {
                            if (list) {
                                if (memory && !firing) {
                                    firingIndex = list.length - 1;
                                    queue.push(memory)
                                }(function add(args) {
                                    jQuery.each(args, function(_, arg) {
                                        if (isFunction(arg)) {
                                            if (!options.unique || !self.has(arg)) {
                                                list.push(arg)
                                            }
                                        } else if (arg && arg.length && toType(arg) !== "string") {
                                            add(arg)
                                        }
                                    })
                                })(arguments);
                                if (memory && !firing) {
                                    fire()
                                }
                            }
                            return this
                        },
                        remove: function() {
                            jQuery.each(arguments, function(_, arg) {
                                var index;
                                while ((index = jQuery.inArray(arg, list, index)) > -1) {
                                    list.splice(index, 1);
                                    if (index <= firingIndex) {
                                        firingIndex--
                                    }
                                }
                            });
                            return this
                        },
                        has: function(fn) {
                            return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0
                        },
                        empty: function() {
                            if (list) {
                                list = []
                            }
                            return this
                        },
                        disable: function() {
                            locked = queue = [];
                            list = memory = "";
                            return this
                        },
                        disabled: function() {
                            return !list
                        },
                        lock: function() {
                            locked = queue = [];
                            if (!memory && !firing) {
                                list = memory = ""
                            }
                            return this
                        },
                        locked: function() {
                            return !!locked
                        },
                        fireWith: function(context, args) {
                            if (!locked) {
                                args = args || [];
                                args = [context, args.slice ? args.slice() : args];
                                queue.push(args);
                                if (!firing) {
                                    fire()
                                }
                            }
                            return this
                        },
                        fire: function() {
                            self.fireWith(this, arguments);
                            return this
                        },
                        fired: function() {
                            return !!fired
                        }
                    };
                return self
            };

            function Identity(v) {
                return v
            }

            function Thrower(ex) {
                throw ex
            }

            function adoptValue(value, resolve, reject, noValue) {
                var method;
                try {
                    if (value && isFunction((method = value.promise))) {
                        method.call(value).done(resolve).fail(reject)
                    } else if (value && isFunction((method = value.then))) {
                        method.call(value, resolve, reject)
                    } else {
                        resolve.apply(undefined, [value].slice(noValue))
                    }
                } catch (value) {
                    reject.apply(undefined, [value])
                }
            }
            jQuery.extend({
                Deferred: function(func) {
                    var tuples = [
                            ["notify", "progress", jQuery.Callbacks("memory"), jQuery.Callbacks("memory"), 2],
                            ["resolve", "done", jQuery.Callbacks("once memory"), jQuery.Callbacks("once memory"), 0, "resolved"],
                            ["reject", "fail", jQuery.Callbacks("once memory"), jQuery.Callbacks("once memory"), 1, "rejected"]
                        ],
                        state = "pending",
                        promise = {
                            state: function() {
                                return state
                            },
                            always: function() {
                                deferred.done(arguments).fail(arguments);
                                return this
                            },
                            "catch": function(fn) {
                                return promise.then(null, fn)
                            },
                            pipe: function() {
                                var fns = arguments;
                                return jQuery.Deferred(function(newDefer) {
                                    jQuery.each(tuples, function(i, tuple) {
                                        var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                                        deferred[tuple[1]](function() {
                                            var returned = fn && fn.apply(this, arguments);
                                            if (returned && isFunction(returned.promise)) {
                                                returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject)
                                            } else {
                                                newDefer[tuple[0] + "With"](this, fn ? [returned] : arguments)
                                            }
                                        })
                                    });
                                    fns = null
                                }).promise()
                            },
                            then: function(onFulfilled, onRejected, onProgress) {
                                var maxDepth = 0;

                                function resolve(depth, deferred, handler, special) {
                                    return function() {
                                        var that = this,
                                            args = arguments,
                                            mightThrow = function() {
                                                var returned, then;
                                                if (depth < maxDepth) {
                                                    return
                                                }
                                                returned = handler.apply(that, args);
                                                if (returned === deferred.promise()) {
                                                    throw new TypeError("Thenable self-resolution")
                                                }
                                                then = returned && (typeof returned === "object" || typeof returned === "function") && returned.then;
                                                if (isFunction(then)) {
                                                    if (special) {
                                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special))
                                                    } else {
                                                        maxDepth++;
                                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith))
                                                    }
                                                } else {
                                                    if (handler !== Identity) {
                                                        that = undefined;
                                                        args = [returned]
                                                    }(special || deferred.resolveWith)(that, args)
                                                }
                                            },
                                            process = special ? mightThrow : function() {
                                                try {
                                                    mightThrow()
                                                } catch (e) {
                                                    if (jQuery.Deferred.exceptionHook) {
                                                        jQuery.Deferred.exceptionHook(e, process.stackTrace)
                                                    }
                                                    if (depth + 1 >= maxDepth) {
                                                        if (handler !== Thrower) {
                                                            that = undefined;
                                                            args = [e]
                                                        }
                                                        deferred.rejectWith(that, args)
                                                    }
                                                }
                                            };
                                        if (depth) {
                                            process()
                                        } else {
                                            if (jQuery.Deferred.getStackHook) {
                                                process.stackTrace = jQuery.Deferred.getStackHook()
                                            }
                                            window.setTimeout(process)
                                        }
                                    }
                                }
                                return jQuery.Deferred(function(newDefer) {
                                    tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                                    tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                                    tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower))
                                }).promise()
                            },
                            promise: function(obj) {
                                return obj != null ? jQuery.extend(obj, promise) : promise
                            }
                        },
                        deferred = {};
                    jQuery.each(tuples, function(i, tuple) {
                        var list = tuple[2],
                            stateString = tuple[5];
                        promise[tuple[1]] = list.add;
                        if (stateString) {
                            list.add(function() {
                                state = stateString
                            }, tuples[3 - i][2].disable, tuples[3 - i][3].disable, tuples[0][2].lock, tuples[0][3].lock)
                        }
                        list.add(tuple[3].fire);
                        deferred[tuple[0]] = function() {
                            deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                            return this
                        };
                        deferred[tuple[0] + "With"] = list.fireWith
                    });
                    promise.promise(deferred);
                    if (func) {
                        func.call(deferred, deferred)
                    }
                    return deferred
                },
                when: function(singleValue) {
                    var
                        remaining = arguments.length,
                        i = remaining,
                        resolveContexts = Array(i),
                        resolveValues = slice.call(arguments),
                        master = jQuery.Deferred(),
                        updateFunc = function(i) {
                            return function(value) {
                                resolveContexts[i] = this;
                                resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                                if (!(--remaining)) {
                                    master.resolveWith(resolveContexts, resolveValues)
                                }
                            }
                        };
                    if (remaining <= 1) {
                        adoptValue(singleValue, master.done(updateFunc(i)).resolve, master.reject, !remaining);
                        if (master.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) {
                            return master.then()
                        }
                    }
                    while (i--) {
                        adoptValue(resolveValues[i], updateFunc(i), master.reject)
                    }
                    return master.promise()
                }
            });
            var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
            jQuery.Deferred.exceptionHook = function(error, stack) {
                if (window.console && window.console.warn && error && rerrorNames.test(error.name)) {
                    window.console.warn("jQuery.Deferred exception: " + error.message, error.stack, stack)
                }
            };
            jQuery.readyException = function(error) {
                window.setTimeout(function() {
                    throw error
                })
            };
            var readyList = jQuery.Deferred();
            jQuery.fn.ready = function(fn) {
                readyList.then(fn).catch(function(error) {
                    jQuery.readyException(error)
                });
                return this
            };
            jQuery.extend({
                isReady: !1,
                readyWait: 1,
                ready: function(wait) {
                    if (wait === !0 ? --jQuery.readyWait : jQuery.isReady) {
                        return
                    }
                    jQuery.isReady = !0;
                    if (wait !== !0 && --jQuery.readyWait > 0) {
                        return
                    }
                    readyList.resolveWith(document, [jQuery])
                }
            });
            jQuery.ready.then = readyList.then;

            function completed() {
                document.removeEventListener("DOMContentLoaded", completed);
                window.removeEventListener("load", completed);
                jQuery.ready()
            }
            if (document.readyState === "complete" || (document.readyState !== "loading" && !document.documentElement.doScroll)) {
                window.setTimeout(jQuery.ready)
            } else {
                document.addEventListener("DOMContentLoaded", completed);
                window.addEventListener("load", completed)
            }
            var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
                var i = 0,
                    len = elems.length,
                    bulk = key == null;
                if (toType(key) === "object") {
                    chainable = !0;
                    for (i in key) {
                        access(elems, fn, i, key[i], !0, emptyGet, raw)
                    }
                } else if (value !== undefined) {
                    chainable = !0;
                    if (!isFunction(value)) {
                        raw = !0
                    }
                    if (bulk) {
                        if (raw) {
                            fn.call(elems, value);
                            fn = null
                        } else {
                            bulk = fn;
                            fn = function(elem, key, value) {
                                return bulk.call(jQuery(elem), value)
                            }
                        }
                    }
                    if (fn) {
                        for (; i < len; i++) {
                            fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)))
                        }
                    }
                }
                if (chainable) {
                    return elems
                }
                if (bulk) {
                    return fn.call(elems)
                }
                return len ? fn(elems[0], key) : emptyGet
            };
            var rmsPrefix = /^-ms-/,
                rdashAlpha = /-([a-z])/g;

            function fcamelCase(all, letter) {
                return letter.toUpperCase()
            }

            function camelCase(string) {
                return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase)
            }
            var acceptData = function(owner) {
                return owner.nodeType === 1 || owner.nodeType === 9 || !(+owner.nodeType)
            };

            function Data() {
                this.expando = jQuery.expando + Data.uid++
            }
            Data.uid = 1;
            Data.prototype = {
                cache: function(owner) {
                    var value = owner[this.expando];
                    if (!value) {
                        value = {};
                        if (acceptData(owner)) {
                            if (owner.nodeType) {
                                owner[this.expando] = value
                            } else {
                                Object.defineProperty(owner, this.expando, {
                                    value: value,
                                    configurable: !0
                                })
                            }
                        }
                    }
                    return value
                },
                set: function(owner, data, value) {
                    var prop, cache = this.cache(owner);
                    if (typeof data === "string") {
                        cache[camelCase(data)] = value
                    } else {
                        for (prop in data) {
                            cache[camelCase(prop)] = data[prop]
                        }
                    }
                    return cache
                },
                get: function(owner, key) {
                    return key === undefined ? this.cache(owner) : owner[this.expando] && owner[this.expando][camelCase(key)]
                },
                access: function(owner, key, value) {
                    if (key === undefined || ((key && typeof key === "string") && value === undefined)) {
                        return this.get(owner, key)
                    }
                    this.set(owner, key, value);
                    return value !== undefined ? value : key
                },
                remove: function(owner, key) {
                    var i, cache = owner[this.expando];
                    if (cache === undefined) {
                        return
                    }
                    if (key !== undefined) {
                        if (Array.isArray(key)) {
                            key = key.map(camelCase)
                        } else {
                            key = camelCase(key);
                            key = key in cache ? [key] : (key.match(rnothtmlwhite) || [])
                        }
                        i = key.length;
                        while (i--) {
                            delete cache[key[i]]
                        }
                    }
                    if (key === undefined || jQuery.isEmptyObject(cache)) {
                        if (owner.nodeType) {
                            owner[this.expando] = undefined
                        } else {
                            delete owner[this.expando]
                        }
                    }
                },
                hasData: function(owner) {
                    var cache = owner[this.expando];
                    return cache !== undefined && !jQuery.isEmptyObject(cache)
                }
            };
            var dataPriv = new Data();
            var dataUser = new Data();
            var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
                rmultiDash = /[A-Z]/g;

            function getData(data) {
                if (data === "true") {
                    return !0
                }
                if (data === "false") {
                    return !1
                }
                if (data === "null") {
                    return null
                }
                if (data === +data + "") {
                    return +data
                }
                if (rbrace.test(data)) {
                    return JSON.parse(data)
                }
                return data
            }

            function dataAttr(elem, key, data) {
                var name;
                if (data === undefined && elem.nodeType === 1) {
                    name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
                    data = elem.getAttribute(name);
                    if (typeof data === "string") {
                        try {
                            data = getData(data)
                        } catch (e) {}
                        dataUser.set(elem, key, data)
                    } else {
                        data = undefined
                    }
                }
                return data
            }
            jQuery.extend({
                hasData: function(elem) {
                    return dataUser.hasData(elem) || dataPriv.hasData(elem)
                },
                data: function(elem, name, data) {
                    return dataUser.access(elem, name, data)
                },
                removeData: function(elem, name) {
                    dataUser.remove(elem, name)
                },
                _data: function(elem, name, data) {
                    return dataPriv.access(elem, name, data)
                },
                _removeData: function(elem, name) {
                    dataPriv.remove(elem, name)
                }
            });
            jQuery.fn.extend({
                data: function(key, value) {
                    var i, name, data, elem = this[0],
                        attrs = elem && elem.attributes;
                    if (key === undefined) {
                        if (this.length) {
                            data = dataUser.get(elem);
                            if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                                i = attrs.length;
                                while (i--) {
                                    if (attrs[i]) {
                                        name = attrs[i].name;
                                        if (name.indexOf("data-") === 0) {
                                            name = camelCase(name.slice(5));
                                            dataAttr(elem, name, data[name])
                                        }
                                    }
                                }
                                dataPriv.set(elem, "hasDataAttrs", !0)
                            }
                        }
                        return data
                    }
                    if (typeof key === "object") {
                        return this.each(function() {
                            dataUser.set(this, key)
                        })
                    }
                    return access(this, function(value) {
                        var data;
                        if (elem && value === undefined) {
                            data = dataUser.get(elem, key);
                            if (data !== undefined) {
                                return data
                            }
                            data = dataAttr(elem, key);
                            if (data !== undefined) {
                                return data
                            }
                            return
                        }
                        this.each(function() {
                            dataUser.set(this, key, value)
                        })
                    }, null, value, arguments.length > 1, null, !0)
                },
                removeData: function(key) {
                    return this.each(function() {
                        dataUser.remove(this, key)
                    })
                }
            });
            jQuery.extend({
                queue: function(elem, type, data) {
                    var queue;
                    if (elem) {
                        type = (type || "fx") + "queue";
                        queue = dataPriv.get(elem, type);
                        if (data) {
                            if (!queue || Array.isArray(data)) {
                                queue = dataPriv.access(elem, type, jQuery.makeArray(data))
                            } else {
                                queue.push(data)
                            }
                        }
                        return queue || []
                    }
                },
                dequeue: function(elem, type) {
                    type = type || "fx";
                    var queue = jQuery.queue(elem, type),
                        startLength = queue.length,
                        fn = queue.shift(),
                        hooks = jQuery._queueHooks(elem, type),
                        next = function() {
                            jQuery.dequeue(elem, type)
                        };
                    if (fn === "inprogress") {
                        fn = queue.shift();
                        startLength--
                    }
                    if (fn) {
                        if (type === "fx") {
                            queue.unshift("inprogress")
                        }
                        delete hooks.stop;
                        fn.call(elem, next, hooks)
                    }
                    if (!startLength && hooks) {
                        hooks.empty.fire()
                    }
                },
                _queueHooks: function(elem, type) {
                    var key = type + "queueHooks";
                    return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                        empty: jQuery.Callbacks("once memory").add(function() {
                            dataPriv.remove(elem, [type + "queue", key])
                        })
                    })
                }
            });
            jQuery.fn.extend({
                queue: function(type, data) {
                    var setter = 2;
                    if (typeof type !== "string") {
                        data = type;
                        type = "fx";
                        setter--
                    }
                    if (arguments.length < setter) {
                        return jQuery.queue(this[0], type)
                    }
                    return data === undefined ? this : this.each(function() {
                        var queue = jQuery.queue(this, type, data);
                        jQuery._queueHooks(this, type);
                        if (type === "fx" && queue[0] !== "inprogress") {
                            jQuery.dequeue(this, type)
                        }
                    })
                },
                dequeue: function(type) {
                    return this.each(function() {
                        jQuery.dequeue(this, type)
                    })
                },
                clearQueue: function(type) {
                    return this.queue(type || "fx", [])
                },
                promise: function(type, obj) {
                    var tmp, count = 1,
                        defer = jQuery.Deferred(),
                        elements = this,
                        i = this.length,
                        resolve = function() {
                            if (!(--count)) {
                                defer.resolveWith(elements, [elements])
                            }
                        };
                    if (typeof type !== "string") {
                        obj = type;
                        type = undefined
                    }
                    type = type || "fx";
                    while (i--) {
                        tmp = dataPriv.get(elements[i], type + "queueHooks");
                        if (tmp && tmp.empty) {
                            count++;
                            tmp.empty.add(resolve)
                        }
                    }
                    resolve();
                    return defer.promise(obj)
                }
            });
            var pnum = (/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/).source;
            var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
            var cssExpand = ["Top", "Right", "Bottom", "Left"];
            var isHiddenWithinTree = function(elem, el) {
                elem = el || elem;
                return elem.style.display === "none" || elem.style.display === "" && jQuery.contains(elem.ownerDocument, elem) && jQuery.css(elem, "display") === "none"
            };
            var swap = function(elem, options, callback, args) {
                var ret, name, old = {};
                for (name in options) {
                    old[name] = elem.style[name];
                    elem.style[name] = options[name]
                }
                ret = callback.apply(elem, args || []);
                for (name in options) {
                    elem.style[name] = old[name]
                }
                return ret
            };

            function adjustCSS(elem, prop, valueParts, tween) {
                var adjusted, scale, maxIterations = 20,
                    currentValue = tween ? function() {
                        return tween.cur()
                    } : function() {
                        return jQuery.css(elem, prop, "")
                    },
                    initial = currentValue(),
                    unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"),
                    initialInUnit = (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
                if (initialInUnit && initialInUnit[3] !== unit) {
                    initial = initial / 2;
                    unit = unit || initialInUnit[3];
                    initialInUnit = +initial || 1;
                    while (maxIterations--) {
                        jQuery.style(elem, prop, initialInUnit + unit);
                        if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) {
                            maxIterations = 0
                        }
                        initialInUnit = initialInUnit / scale
                    }
                    initialInUnit = initialInUnit * 2;
                    jQuery.style(elem, prop, initialInUnit + unit);
                    valueParts = valueParts || []
                }
                if (valueParts) {
                    initialInUnit = +initialInUnit || +initial || 0;
                    adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
                    if (tween) {
                        tween.unit = unit;
                        tween.start = initialInUnit;
                        tween.end = adjusted
                    }
                }
                return adjusted
            }
            var defaultDisplayMap = {};

            function getDefaultDisplay(elem) {
                var temp, doc = elem.ownerDocument,
                    nodeName = elem.nodeName,
                    display = defaultDisplayMap[nodeName];
                if (display) {
                    return display
                }
                temp = doc.body.appendChild(doc.createElement(nodeName));
                display = jQuery.css(temp, "display");
                temp.parentNode.removeChild(temp);
                if (display === "none") {
                    display = "block"
                }
                defaultDisplayMap[nodeName] = display;
                return display
            }

            function showHide(elements, show) {
                var display, elem, values = [],
                    index = 0,
                    length = elements.length;
                for (; index < length; index++) {
                    elem = elements[index];
                    if (!elem.style) {
                        continue
                    }
                    display = elem.style.display;
                    if (show) {
                        if (display === "none") {
                            values[index] = dataPriv.get(elem, "display") || null;
                            if (!values[index]) {
                                elem.style.display = ""
                            }
                        }
                        if (elem.style.display === "" && isHiddenWithinTree(elem)) {
                            values[index] = getDefaultDisplay(elem)
                        }
                    } else {
                        if (display !== "none") {
                            values[index] = "none";
                            dataPriv.set(elem, "display", display)
                        }
                    }
                }
                for (index = 0; index < length; index++) {
                    if (values[index] != null) {
                        elements[index].style.display = values[index]
                    }
                }
                return elements
            }
            jQuery.fn.extend({
                show: function() {
                    return showHide(this, !0)
                },
                hide: function() {
                    return showHide(this)
                },
                toggle: function(state) {
                    if (typeof state === "boolean") {
                        return state ? this.show() : this.hide()
                    }
                    return this.each(function() {
                        if (isHiddenWithinTree(this)) {
                            jQuery(this).show()
                        } else {
                            jQuery(this).hide()
                        }
                    })
                }
            });
            var rcheckableType = (/^(?:checkbox|radio)$/i);
            var rtagName = (/<([a-z][^\/\0>\x20\t\r\n\f]+)/i);
            var rscriptType = (/^$|^module$|\/(?:java|ecma)script/i);
            var wrapMap = {
                option: [1, "<select multiple='multiple'>", "</select>"],
                thead: [1, "<table>", "</table>"],
                col: [2, "<table><colgroup>", "</colgroup></table>"],
                tr: [2, "<table><tbody>", "</tbody></table>"],
                td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
                _default: [0, "", ""]
            };
            wrapMap.optgroup = wrapMap.option;
            wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
            wrapMap.th = wrapMap.td;

            function getAll(context, tag) {
                var ret;
                if (typeof context.getElementsByTagName !== "undefined") {
                    ret = context.getElementsByTagName(tag || "*")
                } else if (typeof context.querySelectorAll !== "undefined") {
                    ret = context.querySelectorAll(tag || "*")
                } else {
                    ret = []
                }
                if (tag === undefined || tag && nodeName(context, tag)) {
                    return jQuery.merge([context], ret)
                }
                return ret
            }

            function setGlobalEval(elems, refElements) {
                var i = 0,
                    l = elems.length;
                for (; i < l; i++) {
                    dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"))
                }
            }
            var rhtml = /<|&#?\w+;/;

            function buildFragment(elems, context, scripts, selection, ignored) {
                var elem, tmp, tag, wrap, contains, j, fragment = context.createDocumentFragment(),
                    nodes = [],
                    i = 0,
                    l = elems.length;
                for (; i < l; i++) {
                    elem = elems[i];
                    if (elem || elem === 0) {
                        if (toType(elem) === "object") {
                            jQuery.merge(nodes, elem.nodeType ? [elem] : elem)
                        } else if (!rhtml.test(elem)) {
                            nodes.push(context.createTextNode(elem))
                        } else {
                            tmp = tmp || fragment.appendChild(context.createElement("div"));
                            tag = (rtagName.exec(elem) || ["", ""])[1].toLowerCase();
                            wrap = wrapMap[tag] || wrapMap._default;
                            tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                            j = wrap[0];
                            while (j--) {
                                tmp = tmp.lastChild
                            }
                            jQuery.merge(nodes, tmp.childNodes);
                            tmp = fragment.firstChild;
                            tmp.textContent = ""
                        }
                    }
                }
                fragment.textContent = "";
                i = 0;
                while ((elem = nodes[i++])) {
                    if (selection && jQuery.inArray(elem, selection) > -1) {
                        if (ignored) {
                            ignored.push(elem)
                        }
                        continue
                    }
                    contains = jQuery.contains(elem.ownerDocument, elem);
                    tmp = getAll(fragment.appendChild(elem), "script");
                    if (contains) {
                        setGlobalEval(tmp)
                    }
                    if (scripts) {
                        j = 0;
                        while ((elem = tmp[j++])) {
                            if (rscriptType.test(elem.type || "")) {
                                scripts.push(elem)
                            }
                        }
                    }
                }
                return fragment
            }(function() {
                var fragment = document.createDocumentFragment(),
                    div = fragment.appendChild(document.createElement("div")),
                    input = document.createElement("input");
                input.setAttribute("type", "radio");
                input.setAttribute("checked", "checked");
                input.setAttribute("name", "t");
                div.appendChild(input);
                support.checkClone = div.cloneNode(!0).cloneNode(!0).lastChild.checked;
                div.innerHTML = "<textarea>x</textarea>";
                support.noCloneChecked = !!div.cloneNode(!0).lastChild.defaultValue
            })();
            var documentElement = document.documentElement;
            var rkeyEvent = /^key/,
                rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
                rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

            function returnTrue() {
                return !0
            }

            function returnFalse() {
                return !1
            }

            function safeActiveElement() {
                try {
                    return document.activeElement
                } catch (err) {}
            }

            function on(elem, types, selector, data, fn, one) {
                var origFn, type;
                if (typeof types === "object") {
                    if (typeof selector !== "string") {
                        data = data || selector;
                        selector = undefined
                    }
                    for (type in types) {
                        on(elem, type, selector, data, types[type], one)
                    }
                    return elem
                }
                if (data == null && fn == null) {
                    fn = selector;
                    data = selector = undefined
                } else if (fn == null) {
                    if (typeof selector === "string") {
                        fn = data;
                        data = undefined
                    } else {
                        fn = data;
                        data = selector;
                        selector = undefined
                    }
                }
                if (fn === !1) {
                    fn = returnFalse
                } else if (!fn) {
                    return elem
                }
                if (one === 1) {
                    origFn = fn;
                    fn = function(event) {
                        jQuery().off(event);
                        return origFn.apply(this, arguments)
                    };
                    fn.guid = origFn.guid || (origFn.guid = jQuery.guid++)
                }
                return elem.each(function() {
                    jQuery.event.add(this, types, fn, data, selector)
                })
            }
            jQuery.event = {
                global: {},
                add: function(elem, types, handler, data, selector) {
                    var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
                    if (!elemData) {
                        return
                    }
                    if (handler.handler) {
                        handleObjIn = handler;
                        handler = handleObjIn.handler;
                        selector = handleObjIn.selector
                    }
                    if (selector) {
                        jQuery.find.matchesSelector(documentElement, selector)
                    }
                    if (!handler.guid) {
                        handler.guid = jQuery.guid++
                    }
                    if (!(events = elemData.events)) {
                        events = elemData.events = {}
                    }
                    if (!(eventHandle = elemData.handle)) {
                        eventHandle = elemData.handle = function(e) {
                            return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined
                        }
                    }
                    types = (types || "").match(rnothtmlwhite) || [""];
                    t = types.length;
                    while (t--) {
                        tmp = rtypenamespace.exec(types[t]) || [];
                        type = origType = tmp[1];
                        namespaces = (tmp[2] || "").split(".").sort();
                        if (!type) {
                            continue
                        }
                        special = jQuery.event.special[type] || {};
                        type = (selector ? special.delegateType : special.bindType) || type;
                        special = jQuery.event.special[type] || {};
                        handleObj = jQuery.extend({
                            type: type,
                            origType: origType,
                            data: data,
                            handler: handler,
                            guid: handler.guid,
                            selector: selector,
                            needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                            namespace: namespaces.join(".")
                        }, handleObjIn);
                        if (!(handlers = events[type])) {
                            handlers = events[type] = [];
                            handlers.delegateCount = 0;
                            if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === !1) {
                                if (elem.addEventListener) {
                                    elem.addEventListener(type, eventHandle)
                                }
                            }
                        }
                        if (special.add) {
                            special.add.call(elem, handleObj);
                            if (!handleObj.handler.guid) {
                                handleObj.handler.guid = handler.guid
                            }
                        }
                        if (selector) {
                            handlers.splice(handlers.delegateCount++, 0, handleObj)
                        } else {
                            handlers.push(handleObj)
                        }
                        jQuery.event.global[type] = !0
                    }
                },
                remove: function(elem, types, handler, selector, mappedTypes) {
                    var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
                    if (!elemData || !(events = elemData.events)) {
                        return
                    }
                    types = (types || "").match(rnothtmlwhite) || [""];
                    t = types.length;
                    while (t--) {
                        tmp = rtypenamespace.exec(types[t]) || [];
                        type = origType = tmp[1];
                        namespaces = (tmp[2] || "").split(".").sort();
                        if (!type) {
                            for (type in events) {
                                jQuery.event.remove(elem, type + types[t], handler, selector, !0)
                            }
                            continue
                        }
                        special = jQuery.event.special[type] || {};
                        type = (selector ? special.delegateType : special.bindType) || type;
                        handlers = events[type] || [];
                        tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                        origCount = j = handlers.length;
                        while (j--) {
                            handleObj = handlers[j];
                            if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                                handlers.splice(j, 1);
                                if (handleObj.selector) {
                                    handlers.delegateCount--
                                }
                                if (special.remove) {
                                    special.remove.call(elem, handleObj)
                                }
                            }
                        }
                        if (origCount && !handlers.length) {
                            if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === !1) {
                                jQuery.removeEvent(elem, type, elemData.handle)
                            }
                            delete events[type]
                        }
                    }
                    if (jQuery.isEmptyObject(events)) {
                        dataPriv.remove(elem, "handle events")
                    }
                },
                dispatch: function(nativeEvent) {
                    var event = jQuery.event.fix(nativeEvent);
                    var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length),
                        handlers = (dataPriv.get(this, "events") || {})[event.type] || [],
                        special = jQuery.event.special[event.type] || {};
                    args[0] = event;
                    for (i = 1; i < arguments.length; i++) {
                        args[i] = arguments[i]
                    }
                    event.delegateTarget = this;
                    if (special.preDispatch && special.preDispatch.call(this, event) === !1) {
                        return
                    }
                    handlerQueue = jQuery.event.handlers.call(this, event, handlers);
                    i = 0;
                    while ((matched = handlerQueue[i++]) && !event.isPropagationStopped()) {
                        event.currentTarget = matched.elem;
                        j = 0;
                        while ((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped()) {
                            if (!event.rnamespace || event.rnamespace.test(handleObj.namespace)) {
                                event.handleObj = handleObj;
                                event.data = handleObj.data;
                                ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                                if (ret !== undefined) {
                                    if ((event.result = ret) === !1) {
                                        event.preventDefault();
                                        event.stopPropagation()
                                    }
                                }
                            }
                        }
                    }
                    if (special.postDispatch) {
                        special.postDispatch.call(this, event)
                    }
                    return event.result
                },
                handlers: function(event, handlers) {
                    var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [],
                        delegateCount = handlers.delegateCount,
                        cur = event.target;
                    if (delegateCount && cur.nodeType && !(event.type === "click" && event.button >= 1)) {
                        for (; cur !== this; cur = cur.parentNode || this) {
                            if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === !0)) {
                                matchedHandlers = [];
                                matchedSelectors = {};
                                for (i = 0; i < delegateCount; i++) {
                                    handleObj = handlers[i];
                                    sel = handleObj.selector + " ";
                                    if (matchedSelectors[sel] === undefined) {
                                        matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [cur]).length
                                    }
                                    if (matchedSelectors[sel]) {
                                        matchedHandlers.push(handleObj)
                                    }
                                }
                                if (matchedHandlers.length) {
                                    handlerQueue.push({
                                        elem: cur,
                                        handlers: matchedHandlers
                                    })
                                }
                            }
                        }
                    }
                    cur = this;
                    if (delegateCount < handlers.length) {
                        handlerQueue.push({
                            elem: cur,
                            handlers: handlers.slice(delegateCount)
                        })
                    }
                    return handlerQueue
                },
                addProp: function(name, hook) {
                    Object.defineProperty(jQuery.Event.prototype, name, {
                        enumerable: !0,
                        configurable: !0,
                        get: isFunction(hook) ? function() {
                            if (this.originalEvent) {
                                return hook(this.originalEvent)
                            }
                        } : function() {
                            if (this.originalEvent) {
                                return this.originalEvent[name]
                            }
                        },
                        set: function(value) {
                            Object.defineProperty(this, name, {
                                enumerable: !0,
                                configurable: !0,
                                writable: !0,
                                value: value
                            })
                        }
                    })
                },
                fix: function(originalEvent) {
                    return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent)
                },
                special: {
                    load: {
                        noBubble: !0
                    },
                    focus: {
                        trigger: function() {
                            if (this !== safeActiveElement() && this.focus) {
                                this.focus();
                                return !1
                            }
                        },
                        delegateType: "focusin"
                    },
                    blur: {
                        trigger: function() {
                            if (this === safeActiveElement() && this.blur) {
                                this.blur();
                                return !1
                            }
                        },
                        delegateType: "focusout"
                    },
                    click: {
                        trigger: function() {
                            if (this.type === "checkbox" && this.click && nodeName(this, "input")) {
                                this.click();
                                return !1
                            }
                        },
                        _default: function(event) {
                            return nodeName(event.target, "a")
                        }
                    },
                    beforeunload: {
                        postDispatch: function(event) {
                            if (event.result !== undefined && event.originalEvent) {
                                event.originalEvent.returnValue = event.result
                            }
                        }
                    }
                }
            };
            jQuery.removeEvent = function(elem, type, handle) {
                if (elem.removeEventListener) {
                    elem.removeEventListener(type, handle)
                }
            };
            jQuery.Event = function(src, props) {
                if (!(this instanceof jQuery.Event)) {
                    return new jQuery.Event(src, props)
                }
                if (src && src.type) {
                    this.originalEvent = src;
                    this.type = src.type;
                    this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && src.returnValue === !1 ? returnTrue : returnFalse;
                    this.target = (src.target && src.target.nodeType === 3) ? src.target.parentNode : src.target;
                    this.currentTarget = src.currentTarget;
                    this.relatedTarget = src.relatedTarget
                } else {
                    this.type = src
                }
                if (props) {
                    jQuery.extend(this, props)
                }
                this.timeStamp = src && src.timeStamp || Date.now();
                this[jQuery.expando] = !0
            };
            jQuery.Event.prototype = {
                constructor: jQuery.Event,
                isDefaultPrevented: returnFalse,
                isPropagationStopped: returnFalse,
                isImmediatePropagationStopped: returnFalse,
                isSimulated: !1,
                preventDefault: function() {
                    var e = this.originalEvent;
                    this.isDefaultPrevented = returnTrue;
                    if (e && !this.isSimulated) {
                        e.preventDefault()
                    }
                },
                stopPropagation: function() {
                    var e = this.originalEvent;
                    this.isPropagationStopped = returnTrue;
                    if (e && !this.isSimulated) {
                        e.stopPropagation()
                    }
                },
                stopImmediatePropagation: function() {
                    var e = this.originalEvent;
                    this.isImmediatePropagationStopped = returnTrue;
                    if (e && !this.isSimulated) {
                        e.stopImmediatePropagation()
                    }
                    this.stopPropagation()
                }
            };
            jQuery.each({
                altKey: !0,
                bubbles: !0,
                cancelable: !0,
                changedTouches: !0,
                ctrlKey: !0,
                detail: !0,
                eventPhase: !0,
                metaKey: !0,
                pageX: !0,
                pageY: !0,
                shiftKey: !0,
                view: !0,
                "char": !0,
                charCode: !0,
                key: !0,
                keyCode: !0,
                button: !0,
                buttons: !0,
                clientX: !0,
                clientY: !0,
                offsetX: !0,
                offsetY: !0,
                pointerId: !0,
                pointerType: !0,
                screenX: !0,
                screenY: !0,
                targetTouches: !0,
                toElement: !0,
                touches: !0,
                which: function(event) {
                    var button = event.button;
                    if (event.which == null && rkeyEvent.test(event.type)) {
                        return event.charCode != null ? event.charCode : event.keyCode
                    }
                    if (!event.which && button !== undefined && rmouseEvent.test(event.type)) {
                        if (button & 1) {
                            return 1
                        }
                        if (button & 2) {
                            return 3
                        }
                        if (button & 4) {
                            return 2
                        }
                        return 0
                    }
                    return event.which
                }
            }, jQuery.event.addProp);
            jQuery.each({
                mouseenter: "mouseover",
                mouseleave: "mouseout",
                pointerenter: "pointerover",
                pointerleave: "pointerout"
            }, function(orig, fix) {
                jQuery.event.special[orig] = {
                    delegateType: fix,
                    bindType: fix,
                    handle: function(event) {
                        var ret, target = this,
                            related = event.relatedTarget,
                            handleObj = event.handleObj;
                        if (!related || (related !== target && !jQuery.contains(target, related))) {
                            event.type = handleObj.origType;
                            ret = handleObj.handler.apply(this, arguments);
                            event.type = fix
                        }
                        return ret
                    }
                }
            });
            jQuery.fn.extend({
                on: function(types, selector, data, fn) {
                    return on(this, types, selector, data, fn)
                },
                one: function(types, selector, data, fn) {
                    return on(this, types, selector, data, fn, 1)
                },
                off: function(types, selector, fn) {
                    var handleObj, type;
                    if (types && types.preventDefault && types.handleObj) {
                        handleObj = types.handleObj;
                        jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                        return this
                    }
                    if (typeof types === "object") {
                        for (type in types) {
                            this.off(type, selector, types[type])
                        }
                        return this
                    }
                    if (selector === !1 || typeof selector === "function") {
                        fn = selector;
                        selector = undefined
                    }
                    if (fn === !1) {
                        fn = returnFalse
                    }
                    return this.each(function() {
                        jQuery.event.remove(this, types, fn, selector)
                    })
                }
            });
            var rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
                rnoInnerhtml = /<script|<style|<link/i,
                rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
                rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

            function manipulationTarget(elem, content) {
                if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) {
                    return jQuery(elem).children("tbody")[0] || elem
                }
                return elem
            }

            function disableScript(elem) {
                elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
                return elem
            }

            function restoreScript(elem) {
                if ((elem.type || "").slice(0, 5) === "true/") {
                    elem.type = elem.type.slice(5)
                } else {
                    elem.removeAttribute("type")
                }
                return elem
            }

            function cloneCopyEvent(src, dest) {
                var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
                if (dest.nodeType !== 1) {
                    return
                }
                if (dataPriv.hasData(src)) {
                    pdataOld = dataPriv.access(src);
                    pdataCur = dataPriv.set(dest, pdataOld);
                    events = pdataOld.events;
                    if (events) {
                        delete pdataCur.handle;
                        pdataCur.events = {};
                        for (type in events) {
                            for (i = 0, l = events[type].length; i < l; i++) {
                                jQuery.event.add(dest, type, events[type][i])
                            }
                        }
                    }
                }
                if (dataUser.hasData(src)) {
                    udataOld = dataUser.access(src);
                    udataCur = jQuery.extend({}, udataOld);
                    dataUser.set(dest, udataCur)
                }
            }

            function fixInput(src, dest) {
                var nodeName = dest.nodeName.toLowerCase();
                if (nodeName === "input" && rcheckableType.test(src.type)) {
                    dest.checked = src.checked
                } else if (nodeName === "input" || nodeName === "textarea") {
                    dest.defaultValue = src.defaultValue
                }
            }

            function domManip(collection, args, callback, ignored) {
                args = concat.apply([], args);
                var fragment, first, scripts, hasScripts, node, doc, i = 0,
                    l = collection.length,
                    iNoClone = l - 1,
                    value = args[0],
                    valueIsFunction = isFunction(value);
                if (valueIsFunction || (l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value))) {
                    return collection.each(function(index) {
                        var self = collection.eq(index);
                        if (valueIsFunction) {
                            args[0] = value.call(this, index, self.html())
                        }
                        domManip(self, args, callback, ignored)
                    })
                }
                if (l) {
                    fragment = buildFragment(args, collection[0].ownerDocument, !1, collection, ignored);
                    first = fragment.firstChild;
                    if (fragment.childNodes.length === 1) {
                        fragment = first
                    }
                    if (first || ignored) {
                        scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                        hasScripts = scripts.length;
                        for (; i < l; i++) {
                            node = fragment;
                            if (i !== iNoClone) {
                                node = jQuery.clone(node, !0, !0);
                                if (hasScripts) {
                                    jQuery.merge(scripts, getAll(node, "script"))
                                }
                            }
                            callback.call(collection[i], node, i)
                        }
                        if (hasScripts) {
                            doc = scripts[scripts.length - 1].ownerDocument;
                            jQuery.map(scripts, restoreScript);
                            for (i = 0; i < hasScripts; i++) {
                                node = scripts[i];
                                if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                                    if (node.src && (node.type || "").toLowerCase() !== "module") {
                                        if (jQuery._evalUrl) {
                                            jQuery._evalUrl(node.src)
                                        }
                                    } else {
                                        DOMEval(node.textContent.replace(rcleanScript, ""), doc, node)
                                    }
                                }
                            }
                        }
                    }
                }
                return collection
            }

            function remove(elem, selector, keepData) {
                var node, nodes = selector ? jQuery.filter(selector, elem) : elem,
                    i = 0;
                for (;
                    (node = nodes[i]) != null; i++) {
                    if (!keepData && node.nodeType === 1) {
                        jQuery.cleanData(getAll(node))
                    }
                    if (node.parentNode) {
                        if (keepData && jQuery.contains(node.ownerDocument, node)) {
                            setGlobalEval(getAll(node, "script"))
                        }
                        node.parentNode.removeChild(node)
                    }
                }
                return elem
            }
            jQuery.extend({
                htmlPrefilter: function(html) {
                    return html.replace(rxhtmlTag, "<$1></$2>")
                },
                clone: function(elem, dataAndEvents, deepDataAndEvents) {
                    var i, l, srcElements, destElements, clone = elem.cloneNode(!0),
                        inPage = jQuery.contains(elem.ownerDocument, elem);
                    if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                        destElements = getAll(clone);
                        srcElements = getAll(elem);
                        for (i = 0, l = srcElements.length; i < l; i++) {
                            fixInput(srcElements[i], destElements[i])
                        }
                    }
                    if (dataAndEvents) {
                        if (deepDataAndEvents) {
                            srcElements = srcElements || getAll(elem);
                            destElements = destElements || getAll(clone);
                            for (i = 0, l = srcElements.length; i < l; i++) {
                                cloneCopyEvent(srcElements[i], destElements[i])
                            }
                        } else {
                            cloneCopyEvent(elem, clone)
                        }
                    }
                    destElements = getAll(clone, "script");
                    if (destElements.length > 0) {
                        setGlobalEval(destElements, !inPage && getAll(elem, "script"))
                    }
                    return clone
                },
                cleanData: function(elems) {
                    var data, elem, type, special = jQuery.event.special,
                        i = 0;
                    for (;
                        (elem = elems[i]) !== undefined; i++) {
                        if (acceptData(elem)) {
                            if ((data = elem[dataPriv.expando])) {
                                if (data.events) {
                                    for (type in data.events) {
                                        if (special[type]) {
                                            jQuery.event.remove(elem, type)
                                        } else {
                                            jQuery.removeEvent(elem, type, data.handle)
                                        }
                                    }
                                }
                                elem[dataPriv.expando] = undefined
                            }
                            if (elem[dataUser.expando]) {
                                elem[dataUser.expando] = undefined
                            }
                        }
                    }
                }
            });
            jQuery.fn.extend({
                detach: function(selector) {
                    return remove(this, selector, !0)
                },
                remove: function(selector) {
                    return remove(this, selector)
                },
                text: function(value) {
                    return access(this, function(value) {
                        return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                            if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                                this.textContent = value
                            }
                        })
                    }, null, value, arguments.length)
                },
                append: function() {
                    return domManip(this, arguments, function(elem) {
                        if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                            var target = manipulationTarget(this, elem);
                            target.appendChild(elem)
                        }
                    })
                },
                prepend: function() {
                    return domManip(this, arguments, function(elem) {
                        if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                            var target = manipulationTarget(this, elem);
                            target.insertBefore(elem, target.firstChild)
                        }
                    })
                },
                before: function() {
                    return domManip(this, arguments, function(elem) {
                        if (this.parentNode) {
                            this.parentNode.insertBefore(elem, this)
                        }
                    })
                },
                after: function() {
                    return domManip(this, arguments, function(elem) {
                        if (this.parentNode) {
                            this.parentNode.insertBefore(elem, this.nextSibling)
                        }
                    })
                },
                empty: function() {
                    var elem, i = 0;
                    for (;
                        (elem = this[i]) != null; i++) {
                        if (elem.nodeType === 1) {
                            jQuery.cleanData(getAll(elem, !1));
                            elem.textContent = ""
                        }
                    }
                    return this
                },
                clone: function(dataAndEvents, deepDataAndEvents) {
                    dataAndEvents = dataAndEvents == null ? !1 : dataAndEvents;
                    deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
                    return this.map(function() {
                        return jQuery.clone(this, dataAndEvents, deepDataAndEvents)
                    })
                },
                html: function(value) {
                    return access(this, function(value) {
                        var elem = this[0] || {},
                            i = 0,
                            l = this.length;
                        if (value === undefined && elem.nodeType === 1) {
                            return elem.innerHTML
                        }
                        if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || ["", ""])[1].toLowerCase()]) {
                            value = jQuery.htmlPrefilter(value);
                            try {
                                for (; i < l; i++) {
                                    elem = this[i] || {};
                                    if (elem.nodeType === 1) {
                                        jQuery.cleanData(getAll(elem, !1));
                                        elem.innerHTML = value
                                    }
                                }
                                elem = 0
                            } catch (e) {}
                        }
                        if (elem) {
                            this.empty().append(value)
                        }
                    }, null, value, arguments.length)
                },
                replaceWith: function() {
                    var ignored = [];
                    return domManip(this, arguments, function(elem) {
                        var parent = this.parentNode;
                        if (jQuery.inArray(this, ignored) < 0) {
                            jQuery.cleanData(getAll(this));
                            if (parent) {
                                parent.replaceChild(elem, this)
                            }
                        }
                    }, ignored)
                }
            });
            jQuery.each({
                appendTo: "append",
                prependTo: "prepend",
                insertBefore: "before",
                insertAfter: "after",
                replaceAll: "replaceWith"
            }, function(name, original) {
                jQuery.fn[name] = function(selector) {
                    var elems, ret = [],
                        insert = jQuery(selector),
                        last = insert.length - 1,
                        i = 0;
                    for (; i <= last; i++) {
                        elems = i === last ? this : this.clone(!0);
                        jQuery(insert[i])[original](elems);
                        push.apply(ret, elems.get())
                    }
                    return this.pushStack(ret)
                }
            });
            var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
            var getStyles = function(elem) {
                var view = elem.ownerDocument.defaultView;
                if (!view || !view.opener) {
                    view = window
                }
                return view.getComputedStyle(elem)
            };
            var rboxStyle = new RegExp(cssExpand.join("|"), "i");
            (function() {
                function computeStyleTests() {
                    if (!div) {
                        return
                    }
                    container.style.cssText = "position:absolute;left:-11111px;width:60px;" + "margin-top:1px;padding:0;border:0";
                    div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;" + "margin:auto;border:1px;padding:1px;" + "width:60%;top:1%";
                    documentElement.appendChild(container).appendChild(div);
                    var divStyle = window.getComputedStyle(div);
                    pixelPositionVal = divStyle.top !== "1%";
                    reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
                    div.style.right = "60%";
                    pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
                    boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
                    div.style.position = "absolute";
                    scrollboxSizeVal = div.offsetWidth === 36 || "absolute";
                    documentElement.removeChild(container);
                    div = null
                }

                function roundPixelMeasures(measure) {
                    return Math.round(parseFloat(measure))
                }
                var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableMarginLeftVal, container = document.createElement("div"),
                    div = document.createElement("div");
                if (!div.style) {
                    return
                }
                div.style.backgroundClip = "content-box";
                div.cloneNode(!0).style.backgroundClip = "";
                support.clearCloneStyle = div.style.backgroundClip === "content-box";
                jQuery.extend(support, {
                    boxSizingReliable: function() {
                        computeStyleTests();
                        return boxSizingReliableVal
                    },
                    pixelBoxStyles: function() {
                        computeStyleTests();
                        return pixelBoxStylesVal
                    },
                    pixelPosition: function() {
                        computeStyleTests();
                        return pixelPositionVal
                    },
                    reliableMarginLeft: function() {
                        computeStyleTests();
                        return reliableMarginLeftVal
                    },
                    scrollboxSize: function() {
                        computeStyleTests();
                        return scrollboxSizeVal
                    }
                })
            })();

            function curCSS(elem, name, computed) {
                var width, minWidth, maxWidth, ret, style = elem.style;
                computed = computed || getStyles(elem);
                if (computed) {
                    ret = computed.getPropertyValue(name) || computed[name];
                    if (ret === "" && !jQuery.contains(elem.ownerDocument, elem)) {
                        ret = jQuery.style(elem, name)
                    }
                    if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                        width = style.width;
                        minWidth = style.minWidth;
                        maxWidth = style.maxWidth;
                        style.minWidth = style.maxWidth = style.width = ret;
                        ret = computed.width;
                        style.width = width;
                        style.minWidth = minWidth;
                        style.maxWidth = maxWidth
                    }
                }
                return ret !== undefined ? ret + "" : ret
            }

            function addGetHookIf(conditionFn, hookFn) {
                return {
                    get: function() {
                        if (conditionFn()) {
                            delete this.get;
                            return
                        }
                        return (this.get = hookFn).apply(this, arguments)
                    }
                }
            }
            var rdisplayswap = /^(none|table(?!-c[ea]).+)/,
                rcustomProp = /^--/,
                cssShow = {
                    position: "absolute",
                    visibility: "hidden",
                    display: "block"
                },
                cssNormalTransform = {
                    letterSpacing: "0",
                    fontWeight: "400"
                },
                cssPrefixes = ["Webkit", "Moz", "ms"],
                emptyStyle = document.createElement("div").style;

            function vendorPropName(name) {
                if (name in emptyStyle) {
                    return name
                }
                var capName = name[0].toUpperCase() + name.slice(1),
                    i = cssPrefixes.length;
                while (i--) {
                    name = cssPrefixes[i] + capName;
                    if (name in emptyStyle) {
                        return name
                    }
                }
            }

            function finalPropName(name) {
                var ret = jQuery.cssProps[name];
                if (!ret) {
                    ret = jQuery.cssProps[name] = vendorPropName(name) || name
                }
                return ret
            }

            function setPositiveNumber(elem, value, subtract) {
                var matches = rcssNum.exec(value);
                return matches ? Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value
            }

            function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
                var i = dimension === "width" ? 1 : 0,
                    extra = 0,
                    delta = 0;
                if (box === (isBorderBox ? "border" : "content")) {
                    return 0
                }
                for (; i < 4; i += 2) {
                    if (box === "margin") {
                        delta += jQuery.css(elem, box + cssExpand[i], !0, styles)
                    }
                    if (!isBorderBox) {
                        delta += jQuery.css(elem, "padding" + cssExpand[i], !0, styles);
                        if (box !== "padding") {
                            delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", !0, styles)
                        } else {
                            extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", !0, styles)
                        }
                    } else {
                        if (box === "content") {
                            delta -= jQuery.css(elem, "padding" + cssExpand[i], !0, styles)
                        }
                        if (box !== "margin") {
                            delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", !0, styles)
                        }
                    }
                }
                if (!isBorderBox && computedVal >= 0) {
                    delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5))
                }
                return delta
            }

            function getWidthOrHeight(elem, dimension, extra) {
                var styles = getStyles(elem),
                    val = curCSS(elem, dimension, styles),
                    isBorderBox = jQuery.css(elem, "boxSizing", !1, styles) === "border-box",
                    valueIsBorderBox = isBorderBox;
                if (rnumnonpx.test(val)) {
                    if (!extra) {
                        return val
                    }
                    val = "auto"
                }
                valueIsBorderBox = valueIsBorderBox && (support.boxSizingReliable() || val === elem.style[dimension]);
                if (val === "auto" || !parseFloat(val) && jQuery.css(elem, "display", !1, styles) === "inline") {
                    val = elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)];
                    valueIsBorderBox = !0
                }
                val = parseFloat(val) || 0;
                return (val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, val)) + "px"
            }
            jQuery.extend({
                cssHooks: {
                    opacity: {
                        get: function(elem, computed) {
                            if (computed) {
                                var ret = curCSS(elem, "opacity");
                                return ret === "" ? "1" : ret
                            }
                        }
                    }
                },
                cssNumber: {
                    "animationIterationCount": !0,
                    "columnCount": !0,
                    "fillOpacity": !0,
                    "flexGrow": !0,
                    "flexShrink": !0,
                    "fontWeight": !0,
                    "lineHeight": !0,
                    "opacity": !0,
                    "order": !0,
                    "orphans": !0,
                    "widows": !0,
                    "zIndex": !0,
                    "zoom": !0
                },
                cssProps: {},
                style: function(elem, name, value, extra) {
                    if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) {
                        return
                    }
                    var ret, type, hooks, origName = camelCase(name),
                        isCustomProp = rcustomProp.test(name),
                        style = elem.style;
                    if (!isCustomProp) {
                        name = finalPropName(origName)
                    }
                    hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
                    if (value !== undefined) {
                        type = typeof value;
                        if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                            value = adjustCSS(elem, name, ret);
                            type = "number"
                        }
                        if (value == null || value !== value) {
                            return
                        }
                        if (type === "number") {
                            value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px")
                        }
                        if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) {
                            style[name] = "inherit"
                        }
                        if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                            if (isCustomProp) {
                                style.setProperty(name, value)
                            } else {
                                style[name] = value
                            }
                        }
                    } else {
                        if (hooks && "get" in hooks && (ret = hooks.get(elem, !1, extra)) !== undefined) {
                            return ret
                        }
                        return style[name]
                    }
                },
                css: function(elem, name, extra, styles) {
                    var val, num, hooks, origName = camelCase(name),
                        isCustomProp = rcustomProp.test(name);
                    if (!isCustomProp) {
                        name = finalPropName(origName)
                    }
                    hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
                    if (hooks && "get" in hooks) {
                        val = hooks.get(elem, !0, extra)
                    }
                    if (val === undefined) {
                        val = curCSS(elem, name, styles)
                    }
                    if (val === "normal" && name in cssNormalTransform) {
                        val = cssNormalTransform[name]
                    }
                    if (extra === "" || extra) {
                        num = parseFloat(val);
                        return extra === !0 || isFinite(num) ? num || 0 : val
                    }
                    return val
                }
            });
            jQuery.each(["height", "width"], function(i, dimension) {
                jQuery.cssHooks[dimension] = {
                    get: function(elem, computed, extra) {
                        if (computed) {
                            return rdisplayswap.test(jQuery.css(elem, "display")) && (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                                return getWidthOrHeight(elem, dimension, extra)
                            }) : getWidthOrHeight(elem, dimension, extra)
                        }
                    },
                    set: function(elem, value, extra) {
                        var matches, styles = getStyles(elem),
                            isBorderBox = jQuery.css(elem, "boxSizing", !1, styles) === "border-box",
                            subtract = extra && boxModelAdjustment(elem, dimension, extra, isBorderBox, styles);
                        if (isBorderBox && support.scrollboxSize() === styles.position) {
                            subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", !1, styles) - 0.5)
                        }
                        if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                            elem.style[dimension] = value;
                            value = jQuery.css(elem, dimension)
                        }
                        return setPositiveNumber(elem, value, subtract)
                    }
                }
            });
            jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
                if (computed) {
                    return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
                        marginLeft: 0
                    }, function() {
                        return elem.getBoundingClientRect().left
                    })) + "px"
                }
            });
            jQuery.each({
                margin: "",
                padding: "",
                border: "Width"
            }, function(prefix, suffix) {
                jQuery.cssHooks[prefix + suffix] = {
                    expand: function(value) {
                        var i = 0,
                            expanded = {},
                            parts = typeof value === "string" ? value.split(" ") : [value];
                        for (; i < 4; i++) {
                            expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0]
                        }
                        return expanded
                    }
                };
                if (prefix !== "margin") {
                    jQuery.cssHooks[prefix + suffix].set = setPositiveNumber
                }
            });
            jQuery.fn.extend({
                css: function(name, value) {
                    return access(this, function(elem, name, value) {
                        var styles, len, map = {},
                            i = 0;
                        if (Array.isArray(name)) {
                            styles = getStyles(elem);
                            len = name.length;
                            for (; i < len; i++) {
                                map[name[i]] = jQuery.css(elem, name[i], !1, styles)
                            }
                            return map
                        }
                        return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name)
                    }, name, value, arguments.length > 1)
                }
            });

            function Tween(elem, options, prop, end, easing) {
                return new Tween.prototype.init(elem, options, prop, end, easing)
            }
            jQuery.Tween = Tween;
            Tween.prototype = {
                constructor: Tween,
                init: function(elem, options, prop, end, easing, unit) {
                    this.elem = elem;
                    this.prop = prop;
                    this.easing = easing || jQuery.easing._default;
                    this.options = options;
                    this.start = this.now = this.cur();
                    this.end = end;
                    this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px")
                },
                cur: function() {
                    var hooks = Tween.propHooks[this.prop];
                    return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this)
                },
                run: function(percent) {
                    var eased, hooks = Tween.propHooks[this.prop];
                    if (this.options.duration) {
                        this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration)
                    } else {
                        this.pos = eased = percent
                    }
                    this.now = (this.end - this.start) * eased + this.start;
                    if (this.options.step) {
                        this.options.step.call(this.elem, this.now, this)
                    }
                    if (hooks && hooks.set) {
                        hooks.set(this)
                    } else {
                        Tween.propHooks._default.set(this)
                    }
                    return this
                }
            };
            Tween.prototype.init.prototype = Tween.prototype;
            Tween.propHooks = {
                _default: {
                    get: function(tween) {
                        var result;
                        if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) {
                            return tween.elem[tween.prop]
                        }
                        result = jQuery.css(tween.elem, tween.prop, "");
                        return !result || result === "auto" ? 0 : result
                    },
                    set: function(tween) {
                        if (jQuery.fx.step[tween.prop]) {
                            jQuery.fx.step[tween.prop](tween)
                        } else if (tween.elem.nodeType === 1 && (tween.elem.style[jQuery.cssProps[tween.prop]] != null || jQuery.cssHooks[tween.prop])) {
                            jQuery.style(tween.elem, tween.prop, tween.now + tween.unit)
                        } else {
                            tween.elem[tween.prop] = tween.now
                        }
                    }
                }
            };
            Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
                set: function(tween) {
                    if (tween.elem.nodeType && tween.elem.parentNode) {
                        tween.elem[tween.prop] = tween.now
                    }
                }
            };
            jQuery.easing = {
                linear: function(p) {
                    return p
                },
                swing: function(p) {
                    return 0.5 - Math.cos(p * Math.PI) / 2
                },
                _default: "swing"
            };
            jQuery.fx = Tween.prototype.init;
            jQuery.fx.step = {};
            var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/,
                rrun = /queueHooks$/;

            function schedule() {
                if (inProgress) {
                    if (document.hidden === !1 && window.requestAnimationFrame) {
                        window.requestAnimationFrame(schedule)
                    } else {
                        window.setTimeout(schedule, jQuery.fx.interval)
                    }
                    jQuery.fx.tick()
                }
            }

            function createFxNow() {
                window.setTimeout(function() {
                    fxNow = undefined
                });
                return (fxNow = Date.now())
            }

            function genFx(type, includeWidth) {
                var which, i = 0,
                    attrs = {
                        height: type
                    };
                includeWidth = includeWidth ? 1 : 0;
                for (; i < 4; i += 2 - includeWidth) {
                    which = cssExpand[i];
                    attrs["margin" + which] = attrs["padding" + which] = type
                }
                if (includeWidth) {
                    attrs.opacity = attrs.width = type
                }
                return attrs
            }

            function createTween(value, prop, animation) {
                var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]),
                    index = 0,
                    length = collection.length;
                for (; index < length; index++) {
                    if ((tween = collection[index].call(animation, prop, value))) {
                        return tween
                    }
                }
            }

            function defaultPrefilter(elem, props, opts) {
                var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props,
                    anim = this,
                    orig = {},
                    style = elem.style,
                    hidden = elem.nodeType && isHiddenWithinTree(elem),
                    dataShow = dataPriv.get(elem, "fxshow");
                if (!opts.queue) {
                    hooks = jQuery._queueHooks(elem, "fx");
                    if (hooks.unqueued == null) {
                        hooks.unqueued = 0;
                        oldfire = hooks.empty.fire;
                        hooks.empty.fire = function() {
                            if (!hooks.unqueued) {
                                oldfire()
                            }
                        }
                    }
                    hooks.unqueued++;
                    anim.always(function() {
                        anim.always(function() {
                            hooks.unqueued--;
                            if (!jQuery.queue(elem, "fx").length) {
                                hooks.empty.fire()
                            }
                        })
                    })
                }
                for (prop in props) {
                    value = props[prop];
                    if (rfxtypes.test(value)) {
                        delete props[prop];
                        toggle = toggle || value === "toggle";
                        if (value === (hidden ? "hide" : "show")) {
                            if (value === "show" && dataShow && dataShow[prop] !== undefined) {
                                hidden = !0
                            } else {
                                continue
                            }
                        }
                        orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop)
                    }
                }
                propTween = !jQuery.isEmptyObject(props);
                if (!propTween && jQuery.isEmptyObject(orig)) {
                    return
                }
                if (isBox && elem.nodeType === 1) {
                    opts.overflow = [style.overflow, style.overflowX, style.overflowY];
                    restoreDisplay = dataShow && dataShow.display;
                    if (restoreDisplay == null) {
                        restoreDisplay = dataPriv.get(elem, "display")
                    }
                    display = jQuery.css(elem, "display");
                    if (display === "none") {
                        if (restoreDisplay) {
                            display = restoreDisplay
                        } else {
                            showHide([elem], !0);
                            restoreDisplay = elem.style.display || restoreDisplay;
                            display = jQuery.css(elem, "display");
                            showHide([elem])
                        }
                    }
                    if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                        if (jQuery.css(elem, "float") === "none") {
                            if (!propTween) {
                                anim.done(function() {
                                    style.display = restoreDisplay
                                });
                                if (restoreDisplay == null) {
                                    display = style.display;
                                    restoreDisplay = display === "none" ? "" : display
                                }
                            }
                            style.display = "inline-block"
                        }
                    }
                }
                if (opts.overflow) {
                    style.overflow = "hidden";
                    anim.always(function() {
                        style.overflow = opts.overflow[0];
                        style.overflowX = opts.overflow[1];
                        style.overflowY = opts.overflow[2]
                    })
                }
                propTween = !1;
                for (prop in orig) {
                    if (!propTween) {
                        if (dataShow) {
                            if ("hidden" in dataShow) {
                                hidden = dataShow.hidden
                            }
                        } else {
                            dataShow = dataPriv.access(elem, "fxshow", {
                                display: restoreDisplay
                            })
                        }
                        if (toggle) {
                            dataShow.hidden = !hidden
                        }
                        if (hidden) {
                            showHide([elem], !0)
                        }
                        anim.done(function() {
                            if (!hidden) {
                                showHide([elem])
                            }
                            dataPriv.remove(elem, "fxshow");
                            for (prop in orig) {
                                jQuery.style(elem, prop, orig[prop])
                            }
                        })
                    }
                    propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
                    if (!(prop in dataShow)) {
                        dataShow[prop] = propTween.start;
                        if (hidden) {
                            propTween.end = propTween.start;
                            propTween.start = 0
                        }
                    }
                }
            }

            function propFilter(props, specialEasing) {
                var index, name, easing, value, hooks;
                for (index in props) {
                    name = camelCase(index);
                    easing = specialEasing[name];
                    value = props[index];
                    if (Array.isArray(value)) {
                        easing = value[1];
                        value = props[index] = value[0]
                    }
                    if (index !== name) {
                        props[name] = value;
                        delete props[index]
                    }
                    hooks = jQuery.cssHooks[name];
                    if (hooks && "expand" in hooks) {
                        value = hooks.expand(value);
                        delete props[name];
                        for (index in value) {
                            if (!(index in props)) {
                                props[index] = value[index];
                                specialEasing[index] = easing
                            }
                        }
                    } else {
                        specialEasing[name] = easing
                    }
                }
            }

            function Animation(elem, properties, options) {
                var result, stopped, index = 0,
                    length = Animation.prefilters.length,
                    deferred = jQuery.Deferred().always(function() {
                        delete tick.elem
                    }),
                    tick = function() {
                        if (stopped) {
                            return !1
                        }
                        var currentTime = fxNow || createFxNow(),
                            remaining = Math.max(0, animation.startTime + animation.duration - currentTime),
                            temp = remaining / animation.duration || 0,
                            percent = 1 - temp,
                            index = 0,
                            length = animation.tweens.length;
                        for (; index < length; index++) {
                            animation.tweens[index].run(percent)
                        }
                        deferred.notifyWith(elem, [animation, percent, remaining]);
                        if (percent < 1 && length) {
                            return remaining
                        }
                        if (!length) {
                            deferred.notifyWith(elem, [animation, 1, 0])
                        }
                        deferred.resolveWith(elem, [animation]);
                        return !1
                    },
                    animation = deferred.promise({
                        elem: elem,
                        props: jQuery.extend({}, properties),
                        opts: jQuery.extend(!0, {
                            specialEasing: {},
                            easing: jQuery.easing._default
                        }, options),
                        originalProperties: properties,
                        originalOptions: options,
                        startTime: fxNow || createFxNow(),
                        duration: options.duration,
                        tweens: [],
                        createTween: function(prop, end) {
                            var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                            animation.tweens.push(tween);
                            return tween
                        },
                        stop: function(gotoEnd) {
                            var index = 0,
                                length = gotoEnd ? animation.tweens.length : 0;
                            if (stopped) {
                                return this
                            }
                            stopped = !0;
                            for (; index < length; index++) {
                                animation.tweens[index].run(1)
                            }
                            if (gotoEnd) {
                                deferred.notifyWith(elem, [animation, 1, 0]);
                                deferred.resolveWith(elem, [animation, gotoEnd])
                            } else {
                                deferred.rejectWith(elem, [animation, gotoEnd])
                            }
                            return this
                        }
                    }),
                    props = animation.props;
                propFilter(props, animation.opts.specialEasing);
                for (; index < length; index++) {
                    result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
                    if (result) {
                        if (isFunction(result.stop)) {
                            jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result)
                        }
                        return result
                    }
                }
                jQuery.map(props, createTween, animation);
                if (isFunction(animation.opts.start)) {
                    animation.opts.start.call(elem, animation)
                }
                animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
                jQuery.fx.timer(jQuery.extend(tick, {
                    elem: elem,
                    anim: animation,
                    queue: animation.opts.queue
                }));
                return animation
            }
            jQuery.Animation = jQuery.extend(Animation, {
                tweeners: {
                    "*": [function(prop, value) {
                        var tween = this.createTween(prop, value);
                        adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                        return tween
                    }]
                },
                tweener: function(props, callback) {
                    if (isFunction(props)) {
                        callback = props;
                        props = ["*"]
                    } else {
                        props = props.match(rnothtmlwhite)
                    }
                    var prop, index = 0,
                        length = props.length;
                    for (; index < length; index++) {
                        prop = props[index];
                        Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                        Animation.tweeners[prop].unshift(callback)
                    }
                },
                prefilters: [defaultPrefilter],
                prefilter: function(callback, prepend) {
                    if (prepend) {
                        Animation.prefilters.unshift(callback)
                    } else {
                        Animation.prefilters.push(callback)
                    }
                }
            });
            jQuery.speed = function(speed, easing, fn) {
                var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
                    complete: fn || !fn && easing || isFunction(speed) && speed,
                    duration: speed,
                    easing: fn && easing || easing && !isFunction(easing) && easing
                };
                if (jQuery.fx.off) {
                    opt.duration = 0
                } else {
                    if (typeof opt.duration !== "number") {
                        if (opt.duration in jQuery.fx.speeds) {
                            opt.duration = jQuery.fx.speeds[opt.duration]
                        } else {
                            opt.duration = jQuery.fx.speeds._default
                        }
                    }
                }
                if (opt.queue == null || opt.queue === !0) {
                    opt.queue = "fx"
                }
                opt.old = opt.complete;
                opt.complete = function() {
                    if (isFunction(opt.old)) {
                        opt.old.call(this)
                    }
                    if (opt.queue) {
                        jQuery.dequeue(this, opt.queue)
                    }
                };
                return opt
            };
            jQuery.fn.extend({
                fadeTo: function(speed, to, easing, callback) {
                    return this.filter(isHiddenWithinTree).css("opacity", 0).show().end().animate({
                        opacity: to
                    }, speed, easing, callback)
                },
                animate: function(prop, speed, easing, callback) {
                    var empty = jQuery.isEmptyObject(prop),
                        optall = jQuery.speed(speed, easing, callback),
                        doAnimation = function() {
                            var anim = Animation(this, jQuery.extend({}, prop), optall);
                            if (empty || dataPriv.get(this, "finish")) {
                                anim.stop(!0)
                            }
                        };
                    doAnimation.finish = doAnimation;
                    return empty || optall.queue === !1 ? this.each(doAnimation) : this.queue(optall.queue, doAnimation)
                },
                stop: function(type, clearQueue, gotoEnd) {
                    var stopQueue = function(hooks) {
                        var stop = hooks.stop;
                        delete hooks.stop;
                        stop(gotoEnd)
                    };
                    if (typeof type !== "string") {
                        gotoEnd = clearQueue;
                        clearQueue = type;
                        type = undefined
                    }
                    if (clearQueue && type !== !1) {
                        this.queue(type || "fx", [])
                    }
                    return this.each(function() {
                        var dequeue = !0,
                            index = type != null && type + "queueHooks",
                            timers = jQuery.timers,
                            data = dataPriv.get(this);
                        if (index) {
                            if (data[index] && data[index].stop) {
                                stopQueue(data[index])
                            }
                        } else {
                            for (index in data) {
                                if (data[index] && data[index].stop && rrun.test(index)) {
                                    stopQueue(data[index])
                                }
                            }
                        }
                        for (index = timers.length; index--;) {
                            if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                                timers[index].anim.stop(gotoEnd);
                                dequeue = !1;
                                timers.splice(index, 1)
                            }
                        }
                        if (dequeue || !gotoEnd) {
                            jQuery.dequeue(this, type)
                        }
                    })
                },
                finish: function(type) {
                    if (type !== !1) {
                        type = type || "fx"
                    }
                    return this.each(function() {
                        var index, data = dataPriv.get(this),
                            queue = data[type + "queue"],
                            hooks = data[type + "queueHooks"],
                            timers = jQuery.timers,
                            length = queue ? queue.length : 0;
                        data.finish = !0;
                        jQuery.queue(this, type, []);
                        if (hooks && hooks.stop) {
                            hooks.stop.call(this, !0)
                        }
                        for (index = timers.length; index--;) {
                            if (timers[index].elem === this && timers[index].queue === type) {
                                timers[index].anim.stop(!0);
                                timers.splice(index, 1)
                            }
                        }
                        for (index = 0; index < length; index++) {
                            if (queue[index] && queue[index].finish) {
                                queue[index].finish.call(this)
                            }
                        }
                        delete data.finish
                    })
                }
            });
            jQuery.each(["toggle", "show", "hide"], function(i, name) {
                var cssFn = jQuery.fn[name];
                jQuery.fn[name] = function(speed, easing, callback) {
                    return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, !0), speed, easing, callback)
                }
            });
            jQuery.each({
                slideDown: genFx("show"),
                slideUp: genFx("hide"),
                slideToggle: genFx("toggle"),
                fadeIn: {
                    opacity: "show"
                },
                fadeOut: {
                    opacity: "hide"
                },
                fadeToggle: {
                    opacity: "toggle"
                }
            }, function(name, props) {
                jQuery.fn[name] = function(speed, easing, callback) {
                    return this.animate(props, speed, easing, callback)
                }
            });
            jQuery.timers = [];
            jQuery.fx.tick = function() {
                var timer, i = 0,
                    timers = jQuery.timers;
                fxNow = Date.now();
                for (; i < timers.length; i++) {
                    timer = timers[i];
                    if (!timer() && timers[i] === timer) {
                        timers.splice(i--, 1)
                    }
                }
                if (!timers.length) {
                    jQuery.fx.stop()
                }
                fxNow = undefined
            };
            jQuery.fx.timer = function(timer) {
                jQuery.timers.push(timer);
                jQuery.fx.start()
            };
            jQuery.fx.interval = 13;
            jQuery.fx.start = function() {
                if (inProgress) {
                    return
                }
                inProgress = !0;
                schedule()
            };
            jQuery.fx.stop = function() {
                inProgress = null
            };
            jQuery.fx.speeds = {
                slow: 600,
                fast: 200,
                _default: 400
            };
            jQuery.fn.delay = function(time, type) {
                time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
                type = type || "fx";
                return this.queue(type, function(next, hooks) {
                    var timeout = window.setTimeout(next, time);
                    hooks.stop = function() {
                        window.clearTimeout(timeout)
                    }
                })
            };
            (function() {
                var input = document.createElement("input"),
                    select = document.createElement("select"),
                    opt = select.appendChild(document.createElement("option"));
                input.type = "checkbox";
                support.checkOn = input.value !== "";
                support.optSelected = opt.selected;
                input = document.createElement("input");
                input.value = "t";
                input.type = "radio";
                support.radioValue = input.value === "t"
            })();
            var boolHook, attrHandle = jQuery.expr.attrHandle;
            jQuery.fn.extend({
                attr: function(name, value) {
                    return access(this, jQuery.attr, name, value, arguments.length > 1)
                },
                removeAttr: function(name) {
                    return this.each(function() {
                        jQuery.removeAttr(this, name)
                    })
                }
            });
            jQuery.extend({
                attr: function(elem, name, value) {
                    var ret, hooks, nType = elem.nodeType;
                    if (nType === 3 || nType === 8 || nType === 2) {
                        return
                    }
                    if (typeof elem.getAttribute === "undefined") {
                        return jQuery.prop(elem, name, value)
                    }
                    if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                        hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined)
                    }
                    if (value !== undefined) {
                        if (value === null) {
                            jQuery.removeAttr(elem, name);
                            return
                        }
                        if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
                            return ret
                        }
                        elem.setAttribute(name, value + "");
                        return value
                    }
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
                        return ret
                    }
                    ret = jQuery.find.attr(elem, name);
                    return ret == null ? undefined : ret
                },
                attrHooks: {
                    type: {
                        set: function(elem, value) {
                            if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                                var val = elem.value;
                                elem.setAttribute("type", value);
                                if (val) {
                                    elem.value = val
                                }
                                return value
                            }
                        }
                    }
                },
                removeAttr: function(elem, value) {
                    var name, i = 0,
                        attrNames = value && value.match(rnothtmlwhite);
                    if (attrNames && elem.nodeType === 1) {
                        while ((name = attrNames[i++])) {
                            elem.removeAttribute(name)
                        }
                    }
                }
            });
            boolHook = {
                set: function(elem, value, name) {
                    if (value === !1) {
                        jQuery.removeAttr(elem, name)
                    } else {
                        elem.setAttribute(name, name)
                    }
                    return name
                }
            };
            jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(i, name) {
                var getter = attrHandle[name] || jQuery.find.attr;
                attrHandle[name] = function(elem, name, isXML) {
                    var ret, handle, lowercaseName = name.toLowerCase();
                    if (!isXML) {
                        handle = attrHandle[lowercaseName];
                        attrHandle[lowercaseName] = ret;
                        ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                        attrHandle[lowercaseName] = handle
                    }
                    return ret
                }
            });
            var rfocusable = /^(?:input|select|textarea|button)$/i,
                rclickable = /^(?:a|area)$/i;
            jQuery.fn.extend({
                prop: function(name, value) {
                    return access(this, jQuery.prop, name, value, arguments.length > 1)
                },
                removeProp: function(name) {
                    return this.each(function() {
                        delete this[jQuery.propFix[name] || name]
                    })
                }
            });
            jQuery.extend({
                prop: function(elem, name, value) {
                    var ret, hooks, nType = elem.nodeType;
                    if (nType === 3 || nType === 8 || nType === 2) {
                        return
                    }
                    if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                        name = jQuery.propFix[name] || name;
                        hooks = jQuery.propHooks[name]
                    }
                    if (value !== undefined) {
                        if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
                            return ret
                        }
                        return (elem[name] = value)
                    }
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
                        return ret
                    }
                    return elem[name]
                },
                propHooks: {
                    tabIndex: {
                        get: function(elem) {
                            var tabindex = jQuery.find.attr(elem, "tabindex");
                            if (tabindex) {
                                return parseInt(tabindex, 10)
                            }
                            if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) {
                                return 0
                            }
                            return -1
                        }
                    }
                },
                propFix: {
                    "for": "htmlFor",
                    "class": "className"
                }
            });
            if (!support.optSelected) {
                jQuery.propHooks.selected = {
                    get: function(elem) {
                        var parent = elem.parentNode;
                        if (parent && parent.parentNode) {
                            parent.parentNode.selectedIndex
                        }
                        return null
                    },
                    set: function(elem) {
                        var parent = elem.parentNode;
                        if (parent) {
                            parent.selectedIndex;
                            if (parent.parentNode) {
                                parent.parentNode.selectedIndex
                            }
                        }
                    }
                }
            }
            jQuery.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
                jQuery.propFix[this.toLowerCase()] = this
            });

            function stripAndCollapse(value) {
                var tokens = value.match(rnothtmlwhite) || [];
                return tokens.join(" ")
            }

            function getClass(elem) {
                return elem.getAttribute && elem.getAttribute("class") || ""
            }

            function classesToArray(value) {
                if (Array.isArray(value)) {
                    return value
                }
                if (typeof value === "string") {
                    return value.match(rnothtmlwhite) || []
                }
                return []
            }
            jQuery.fn.extend({
                addClass: function(value) {
                    var classes, elem, cur, curValue, clazz, j, finalValue, i = 0;
                    if (isFunction(value)) {
                        return this.each(function(j) {
                            jQuery(this).addClass(value.call(this, j, getClass(this)))
                        })
                    }
                    classes = classesToArray(value);
                    if (classes.length) {
                        while ((elem = this[i++])) {
                            curValue = getClass(elem);
                            cur = elem.nodeType === 1 && (" " + stripAndCollapse(curValue) + " ");
                            if (cur) {
                                j = 0;
                                while ((clazz = classes[j++])) {
                                    if (cur.indexOf(" " + clazz + " ") < 0) {
                                        cur += clazz + " "
                                    }
                                }
                                finalValue = stripAndCollapse(cur);
                                if (curValue !== finalValue) {
                                    elem.setAttribute("class", finalValue)
                                }
                            }
                        }
                    }
                    return this
                },
                removeClass: function(value) {
                    var classes, elem, cur, curValue, clazz, j, finalValue, i = 0;
                    if (isFunction(value)) {
                        return this.each(function(j) {
                            jQuery(this).removeClass(value.call(this, j, getClass(this)))
                        })
                    }
                    if (!arguments.length) {
                        return this.attr("class", "")
                    }
                    classes = classesToArray(value);
                    if (classes.length) {
                        while ((elem = this[i++])) {
                            curValue = getClass(elem);
                            cur = elem.nodeType === 1 && (" " + stripAndCollapse(curValue) + " ");
                            if (cur) {
                                j = 0;
                                while ((clazz = classes[j++])) {
                                    while (cur.indexOf(" " + clazz + " ") > -1) {
                                        cur = cur.replace(" " + clazz + " ", " ")
                                    }
                                }
                                finalValue = stripAndCollapse(cur);
                                if (curValue !== finalValue) {
                                    elem.setAttribute("class", finalValue)
                                }
                            }
                        }
                    }
                    return this
                },
                toggleClass: function(value, stateVal) {
                    var type = typeof value,
                        isValidValue = type === "string" || Array.isArray(value);
                    if (typeof stateVal === "boolean" && isValidValue) {
                        return stateVal ? this.addClass(value) : this.removeClass(value)
                    }
                    if (isFunction(value)) {
                        return this.each(function(i) {
                            jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal)
                        })
                    }
                    return this.each(function() {
                        var className, i, self, classNames;
                        if (isValidValue) {
                            i = 0;
                            self = jQuery(this);
                            classNames = classesToArray(value);
                            while ((className = classNames[i++])) {
                                if (self.hasClass(className)) {
                                    self.removeClass(className)
                                } else {
                                    self.addClass(className)
                                }
                            }
                        } else if (value === undefined || type === "boolean") {
                            className = getClass(this);
                            if (className) {
                                dataPriv.set(this, "__className__", className)
                            }
                            if (this.setAttribute) {
                                this.setAttribute("class", className || value === !1 ? "" : dataPriv.get(this, "__className__") || "")
                            }
                        }
                    })
                },
                hasClass: function(selector) {
                    var className, elem, i = 0;
                    className = " " + selector + " ";
                    while ((elem = this[i++])) {
                        if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) {
                            return !0
                        }
                    }
                    return !1
                }
            });
            var rreturn = /\r/g;
            jQuery.fn.extend({
                val: function(value) {
                    var hooks, ret, valueIsFunction, elem = this[0];
                    if (!arguments.length) {
                        if (elem) {
                            hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                            if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) {
                                return ret
                            }
                            ret = elem.value;
                            if (typeof ret === "string") {
                                return ret.replace(rreturn, "")
                            }
                            return ret == null ? "" : ret
                        }
                        return
                    }
                    valueIsFunction = isFunction(value);
                    return this.each(function(i) {
                        var val;
                        if (this.nodeType !== 1) {
                            return
                        }
                        if (valueIsFunction) {
                            val = value.call(this, i, jQuery(this).val())
                        } else {
                            val = value
                        }
                        if (val == null) {
                            val = ""
                        } else if (typeof val === "number") {
                            val += ""
                        } else if (Array.isArray(val)) {
                            val = jQuery.map(val, function(value) {
                                return value == null ? "" : value + ""
                            })
                        }
                        hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                        if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) {
                            this.value = val
                        }
                    })
                }
            });
            jQuery.extend({
                valHooks: {
                    option: {
                        get: function(elem) {
                            var val = jQuery.find.attr(elem, "value");
                            return val != null ? val : stripAndCollapse(jQuery.text(elem))
                        }
                    },
                    select: {
                        get: function(elem) {
                            var value, option, i, options = elem.options,
                                index = elem.selectedIndex,
                                one = elem.type === "select-one",
                                values = one ? null : [],
                                max = one ? index + 1 : options.length;
                            if (index < 0) {
                                i = max
                            } else {
                                i = one ? index : 0
                            }
                            for (; i < max; i++) {
                                option = options[i];
                                if ((option.selected || i === index) && !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                                    value = jQuery(option).val();
                                    if (one) {
                                        return value
                                    }
                                    values.push(value)
                                }
                            }
                            return values
                        },
                        set: function(elem, value) {
                            var optionSet, option, options = elem.options,
                                values = jQuery.makeArray(value),
                                i = options.length;
                            while (i--) {
                                option = options[i];
                                if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) {
                                    optionSet = !0
                                }
                            }
                            if (!optionSet) {
                                elem.selectedIndex = -1
                            }
                            return values
                        }
                    }
                }
            });
            jQuery.each(["radio", "checkbox"], function() {
                jQuery.valHooks[this] = {
                    set: function(elem, value) {
                        if (Array.isArray(value)) {
                            return (elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1)
                        }
                    }
                };
                if (!support.checkOn) {
                    jQuery.valHooks[this].get = function(elem) {
                        return elem.getAttribute("value") === null ? "on" : elem.value
                    }
                }
            });
            support.focusin = "onfocusin" in window;
            var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
                stopPropagationCallback = function(e) {
                    e.stopPropagation()
                };
            jQuery.extend(jQuery.event, {
                trigger: function(event, data, elem, onlyHandlers) {
                    var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [elem || document],
                        type = hasOwn.call(event, "type") ? event.type : event,
                        namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
                    cur = lastElement = tmp = elem = elem || document;
                    if (elem.nodeType === 3 || elem.nodeType === 8) {
                        return
                    }
                    if (rfocusMorph.test(type + jQuery.event.triggered)) {
                        return
                    }
                    if (type.indexOf(".") > -1) {
                        namespaces = type.split(".");
                        type = namespaces.shift();
                        namespaces.sort()
                    }
                    ontype = type.indexOf(":") < 0 && "on" + type;
                    event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
                    event.isTrigger = onlyHandlers ? 2 : 3;
                    event.namespace = namespaces.join(".");
                    event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
                    event.result = undefined;
                    if (!event.target) {
                        event.target = elem
                    }
                    data = data == null ? [event] : jQuery.makeArray(data, [event]);
                    special = jQuery.event.special[type] || {};
                    if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === !1) {
                        return
                    }
                    if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                        bubbleType = special.delegateType || type;
                        if (!rfocusMorph.test(bubbleType + type)) {
                            cur = cur.parentNode
                        }
                        for (; cur; cur = cur.parentNode) {
                            eventPath.push(cur);
                            tmp = cur
                        }
                        if (tmp === (elem.ownerDocument || document)) {
                            eventPath.push(tmp.defaultView || tmp.parentWindow || window)
                        }
                    }
                    i = 0;
                    while ((cur = eventPath[i++]) && !event.isPropagationStopped()) {
                        lastElement = cur;
                        event.type = i > 1 ? bubbleType : special.bindType || type;
                        handle = (dataPriv.get(cur, "events") || {})[event.type] && dataPriv.get(cur, "handle");
                        if (handle) {
                            handle.apply(cur, data)
                        }
                        handle = ontype && cur[ontype];
                        if (handle && handle.apply && acceptData(cur)) {
                            event.result = handle.apply(cur, data);
                            if (event.result === !1) {
                                event.preventDefault()
                            }
                        }
                    }
                    event.type = type;
                    if (!onlyHandlers && !event.isDefaultPrevented()) {
                        if ((!special._default || special._default.apply(eventPath.pop(), data) === !1) && acceptData(elem)) {
                            if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                                tmp = elem[ontype];
                                if (tmp) {
                                    elem[ontype] = null
                                }
                                jQuery.event.triggered = type;
                                if (event.isPropagationStopped()) {
                                    lastElement.addEventListener(type, stopPropagationCallback)
                                }
                                elem[type]();
                                if (event.isPropagationStopped()) {
                                    lastElement.removeEventListener(type, stopPropagationCallback)
                                }
                                jQuery.event.triggered = undefined;
                                if (tmp) {
                                    elem[ontype] = tmp
                                }
                            }
                        }
                    }
                    return event.result
                },
                simulate: function(type, elem, event) {
                    var e = jQuery.extend(new jQuery.Event(), event, {
                        type: type,
                        isSimulated: !0
                    });
                    jQuery.event.trigger(e, null, elem)
                }
            });
            jQuery.fn.extend({
                trigger: function(type, data) {
                    return this.each(function() {
                        jQuery.event.trigger(type, data, this)
                    })
                },
                triggerHandler: function(type, data) {
                    var elem = this[0];
                    if (elem) {
                        return jQuery.event.trigger(type, data, elem, !0)
                    }
                }
            });
            if (!support.focusin) {
                jQuery.each({
                    focus: "focusin",
                    blur: "focusout"
                }, function(orig, fix) {
                    var handler = function(event) {
                        jQuery.event.simulate(fix, event.target, jQuery.event.fix(event))
                    };
                    jQuery.event.special[fix] = {
                        setup: function() {
                            var doc = this.ownerDocument || this,
                                attaches = dataPriv.access(doc, fix);
                            if (!attaches) {
                                doc.addEventListener(orig, handler, !0)
                            }
                            dataPriv.access(doc, fix, (attaches || 0) + 1)
                        },
                        teardown: function() {
                            var doc = this.ownerDocument || this,
                                attaches = dataPriv.access(doc, fix) - 1;
                            if (!attaches) {
                                doc.removeEventListener(orig, handler, !0);
                                dataPriv.remove(doc, fix)
                            } else {
                                dataPriv.access(doc, fix, attaches)
                            }
                        }
                    }
                })
            }
            var location = window.location;
            var nonce = Date.now();
            var rquery = (/\?/);
            jQuery.parseXML = function(data) {
                var xml;
                if (!data || typeof data !== "string") {
                    return null
                }
                try {
                    xml = (new window.DOMParser()).parseFromString(data, "text/xml")
                } catch (e) {
                    xml = undefined
                }
                if (!xml || xml.getElementsByTagName("parsererror").length) {
                    jQuery.error("Invalid XML: " + data)
                }
                return xml
            };
            var rbracket = /\[\]$/,
                rCRLF = /\r?\n/g,
                rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
                rsubmittable = /^(?:input|select|textarea|keygen)/i;

            function buildParams(prefix, obj, traditional, add) {
                var name;
                if (Array.isArray(obj)) {
                    jQuery.each(obj, function(i, v) {
                        if (traditional || rbracket.test(prefix)) {
                            add(prefix, v)
                        } else {
                            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add)
                        }
                    })
                } else if (!traditional && toType(obj) === "object") {
                    for (name in obj) {
                        buildParams(prefix + "[" + name + "]", obj[name], traditional, add)
                    }
                } else {
                    add(prefix, obj)
                }
            }
            jQuery.param = function(a, traditional) {
                var prefix, s = [],
                    add = function(key, valueOrFunction) {
                        var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
                        s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value)
                    };
                if (Array.isArray(a) || (a.jquery && !jQuery.isPlainObject(a))) {
                    jQuery.each(a, function() {
                        add(this.name, this.value)
                    })
                } else {
                    for (prefix in a) {
                        buildParams(prefix, a[prefix], traditional, add)
                    }
                }
                return s.join("&")
            };
            jQuery.fn.extend({
                serialize: function() {
                    return jQuery.param(this.serializeArray())
                },
                serializeArray: function() {
                    return this.map(function() {
                        var elements = jQuery.prop(this, "elements");
                        return elements ? jQuery.makeArray(elements) : this
                    }).filter(function() {
                        var type = this.type;
                        return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type))
                    }).map(function(i, elem) {
                        var val = jQuery(this).val();
                        if (val == null) {
                            return null
                        }
                        if (Array.isArray(val)) {
                            return jQuery.map(val, function(val) {
                                return {
                                    name: elem.name,
                                    value: val.replace(rCRLF, "\r\n")
                                }
                            })
                        }
                        return {
                            name: elem.name,
                            value: val.replace(rCRLF, "\r\n")
                        }
                    }).get()
                }
            });
            var r20 = /%20/g,
                rhash = /#.*$/,
                rantiCache = /([?&])_=[^&]*/,
                rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
                rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
                rnoContent = /^(?:GET|HEAD)$/,
                rprotocol = /^\/\//,
                prefilters = {},
                transports = {},
                allTypes = "*/".concat("*"),
                originAnchor = document.createElement("a");
            originAnchor.href = location.href;

            function addToPrefiltersOrTransports(structure) {
                return function(dataTypeExpression, func) {
                    if (typeof dataTypeExpression !== "string") {
                        func = dataTypeExpression;
                        dataTypeExpression = "*"
                    }
                    var dataType, i = 0,
                        dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
                    if (isFunction(func)) {
                        while ((dataType = dataTypes[i++])) {
                            if (dataType[0] === "+") {
                                dataType = dataType.slice(1) || "*";
                                (structure[dataType] = structure[dataType] || []).unshift(func)
                            } else {
                                (structure[dataType] = structure[dataType] || []).push(func)
                            }
                        }
                    }
                }
            }

            function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
                var inspected = {},
                    seekingTransport = (structure === transports);

                function inspect(dataType) {
                    var selected;
                    inspected[dataType] = !0;
                    jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                        var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                        if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                            options.dataTypes.unshift(dataTypeOrTransport);
                            inspect(dataTypeOrTransport);
                            return !1
                        } else if (seekingTransport) {
                            return !(selected = dataTypeOrTransport)
                        }
                    });
                    return selected
                }
                return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*")
            }

            function ajaxExtend(target, src) {
                var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
                for (key in src) {
                    if (src[key] !== undefined) {
                        (flatOptions[key] ? target : (deep || (deep = {})))[key] = src[key]
                    }
                }
                if (deep) {
                    jQuery.extend(!0, target, deep)
                }
                return target
            }

            function ajaxHandleResponses(s, jqXHR, responses) {
                var ct, type, finalDataType, firstDataType, contents = s.contents,
                    dataTypes = s.dataTypes;
                while (dataTypes[0] === "*") {
                    dataTypes.shift();
                    if (ct === undefined) {
                        ct = s.mimeType || jqXHR.getResponseHeader("Content-Type")
                    }
                }
                if (ct) {
                    for (type in contents) {
                        if (contents[type] && contents[type].test(ct)) {
                            dataTypes.unshift(type);
                            break
                        }
                    }
                }
                if (dataTypes[0] in responses) {
                    finalDataType = dataTypes[0]
                } else {
                    for (type in responses) {
                        if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                            finalDataType = type;
                            break
                        }
                        if (!firstDataType) {
                            firstDataType = type
                        }
                    }
                    finalDataType = finalDataType || firstDataType
                }
                if (finalDataType) {
                    if (finalDataType !== dataTypes[0]) {
                        dataTypes.unshift(finalDataType)
                    }
                    return responses[finalDataType]
                }
            }

            function ajaxConvert(s, response, jqXHR, isSuccess) {
                var conv2, current, conv, tmp, prev, converters = {},
                    dataTypes = s.dataTypes.slice();
                if (dataTypes[1]) {
                    for (conv in s.converters) {
                        converters[conv.toLowerCase()] = s.converters[conv]
                    }
                }
                current = dataTypes.shift();
                while (current) {
                    if (s.responseFields[current]) {
                        jqXHR[s.responseFields[current]] = response
                    }
                    if (!prev && isSuccess && s.dataFilter) {
                        response = s.dataFilter(response, s.dataType)
                    }
                    prev = current;
                    current = dataTypes.shift();
                    if (current) {
                        if (current === "*") {
                            current = prev
                        } else if (prev !== "*" && prev !== current) {
                            conv = converters[prev + " " + current] || converters["* " + current];
                            if (!conv) {
                                for (conv2 in converters) {
                                    tmp = conv2.split(" ");
                                    if (tmp[1] === current) {
                                        conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                                        if (conv) {
                                            if (conv === !0) {
                                                conv = converters[conv2]
                                            } else if (converters[conv2] !== !0) {
                                                current = tmp[0];
                                                dataTypes.unshift(tmp[1])
                                            }
                                            break
                                        }
                                    }
                                }
                            }
                            if (conv !== !0) {
                                if (conv && s.throws) {
                                    response = conv(response)
                                } else {
                                    try {
                                        response = conv(response)
                                    } catch (e) {
                                        return {
                                            state: "parsererror",
                                            error: conv ? e : "No conversion from " + prev + " to " + current
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                return {
                    state: "success",
                    data: response
                }
            }
            jQuery.extend({
                active: 0,
                lastModified: {},
                etag: {},
                ajaxSettings: {
                    url: location.href,
                    type: "GET",
                    isLocal: rlocalProtocol.test(location.protocol),
                    global: !0,
                    processData: !0,
                    async: !0,
                    contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                    accepts: {
                        "*": allTypes,
                        text: "text/plain",
                        html: "text/html",
                        xml: "application/xml, text/xml",
                        json: "application/json, text/javascript"
                    },
                    contents: {
                        xml: /\bxml\b/,
                        html: /\bhtml/,
                        json: /\bjson\b/
                    },
                    responseFields: {
                        xml: "responseXML",
                        text: "responseText",
                        json: "responseJSON"
                    },
                    converters: {
                        "* text": String,
                        "text html": !0,
                        "text json": JSON.parse,
                        "text xml": jQuery.parseXML
                    },
                    flatOptions: {
                        url: !0,
                        context: !0
                    }
                },
                ajaxSetup: function(target, settings) {
                    return settings ? ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : ajaxExtend(jQuery.ajaxSettings, target)
                },
                ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
                ajaxTransport: addToPrefiltersOrTransports(transports),
                ajax: function(url, options) {
                    if (typeof url === "object") {
                        options = url;
                        url = undefined
                    }
                    options = options || {};
                    var transport, cacheURL, responseHeadersString, responseHeaders, timeoutTimer, urlAnchor, completed, fireGlobals, i, uncached, s = jQuery.ajaxSetup({}, options),
                        callbackContext = s.context || s,
                        globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event,
                        deferred = jQuery.Deferred(),
                        completeDeferred = jQuery.Callbacks("once memory"),
                        statusCode = s.statusCode || {},
                        requestHeaders = {},
                        requestHeadersNames = {},
                        strAbort = "canceled",
                        jqXHR = {
                            readyState: 0,
                            getResponseHeader: function(key) {
                                var match;
                                if (completed) {
                                    if (!responseHeaders) {
                                        responseHeaders = {};
                                        while ((match = rheaders.exec(responseHeadersString))) {
                                            responseHeaders[match[1].toLowerCase()] = match[2]
                                        }
                                    }
                                    match = responseHeaders[key.toLowerCase()]
                                }
                                return match == null ? null : match
                            },
                            getAllResponseHeaders: function() {
                                return completed ? responseHeadersString : null
                            },
                            setRequestHeader: function(name, value) {
                                if (completed == null) {
                                    name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                                    requestHeaders[name] = value
                                }
                                return this
                            },
                            overrideMimeType: function(type) {
                                if (completed == null) {
                                    s.mimeType = type
                                }
                                return this
                            },
                            statusCode: function(map) {
                                var code;
                                if (map) {
                                    if (completed) {
                                        jqXHR.always(map[jqXHR.status])
                                    } else {
                                        for (code in map) {
                                            statusCode[code] = [statusCode[code], map[code]]
                                        }
                                    }
                                }
                                return this
                            },
                            abort: function(statusText) {
                                var finalText = statusText || strAbort;
                                if (transport) {
                                    transport.abort(finalText)
                                }
                                done(0, finalText);
                                return this
                            }
                        };
                    deferred.promise(jqXHR);
                    s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
                    s.type = options.method || options.type || s.method || s.type;
                    s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [""];
                    if (s.crossDomain == null) {
                        urlAnchor = document.createElement("a");
                        try {
                            urlAnchor.href = s.url;
                            urlAnchor.href = urlAnchor.href;
                            s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host
                        } catch (e) {
                            s.crossDomain = !0
                        }
                    }
                    if (s.data && s.processData && typeof s.data !== "string") {
                        s.data = jQuery.param(s.data, s.traditional)
                    }
                    inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
                    if (completed) {
                        return jqXHR
                    }
                    fireGlobals = jQuery.event && s.global;
                    if (fireGlobals && jQuery.active++ === 0) {
                        jQuery.event.trigger("ajaxStart")
                    }
                    s.type = s.type.toUpperCase();
                    s.hasContent = !rnoContent.test(s.type);
                    cacheURL = s.url.replace(rhash, "");
                    if (!s.hasContent) {
                        uncached = s.url.slice(cacheURL.length);
                        if (s.data && (s.processData || typeof s.data === "string")) {
                            cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                            delete s.data
                        }
                        if (s.cache === !1) {
                            cacheURL = cacheURL.replace(rantiCache, "$1");
                            uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + (nonce++) + uncached
                        }
                        s.url = cacheURL + uncached
                    } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) {
                        s.data = s.data.replace(r20, "+")
                    }
                    if (s.ifModified) {
                        if (jQuery.lastModified[cacheURL]) {
                            jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL])
                        }
                        if (jQuery.etag[cacheURL]) {
                            jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL])
                        }
                    }
                    if (s.data && s.hasContent && s.contentType !== !1 || options.contentType) {
                        jqXHR.setRequestHeader("Content-Type", s.contentType)
                    }
                    jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
                    for (i in s.headers) {
                        jqXHR.setRequestHeader(i, s.headers[i])
                    }
                    if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === !1 || completed)) {
                        return jqXHR.abort()
                    }
                    strAbort = "abort";
                    completeDeferred.add(s.complete);
                    jqXHR.done(s.success);
                    jqXHR.fail(s.error);
                    transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
                    if (!transport) {
                        done(-1, "No Transport")
                    } else {
                        jqXHR.readyState = 1;
                        if (fireGlobals) {
                            globalEventContext.trigger("ajaxSend", [jqXHR, s])
                        }
                        if (completed) {
                            return jqXHR
                        }
                        if (s.async && s.timeout > 0) {
                            timeoutTimer = window.setTimeout(function() {
                                jqXHR.abort("timeout")
                            }, s.timeout)
                        }
                        try {
                            completed = !1;
                            transport.send(requestHeaders, done)
                        } catch (e) {
                            if (completed) {
                                throw e
                            }
                            done(-1, e)
                        }
                    }

                    function done(status, nativeStatusText, responses, headers) {
                        var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                        if (completed) {
                            return
                        }
                        completed = !0;
                        if (timeoutTimer) {
                            window.clearTimeout(timeoutTimer)
                        }
                        transport = undefined;
                        responseHeadersString = headers || "";
                        jqXHR.readyState = status > 0 ? 4 : 0;
                        isSuccess = status >= 200 && status < 300 || status === 304;
                        if (responses) {
                            response = ajaxHandleResponses(s, jqXHR, responses)
                        }
                        response = ajaxConvert(s, response, jqXHR, isSuccess);
                        if (isSuccess) {
                            if (s.ifModified) {
                                modified = jqXHR.getResponseHeader("Last-Modified");
                                if (modified) {
                                    jQuery.lastModified[cacheURL] = modified
                                }
                                modified = jqXHR.getResponseHeader("etag");
                                if (modified) {
                                    jQuery.etag[cacheURL] = modified
                                }
                            }
                            if (status === 204 || s.type === "HEAD") {
                                statusText = "nocontent"
                            } else if (status === 304) {
                                statusText = "notmodified"
                            } else {
                                statusText = response.state;
                                success = response.data;
                                error = response.error;
                                isSuccess = !error
                            }
                        } else {
                            error = statusText;
                            if (status || !statusText) {
                                statusText = "error";
                                if (status < 0) {
                                    status = 0
                                }
                            }
                        }
                        jqXHR.status = status;
                        jqXHR.statusText = (nativeStatusText || statusText) + "";
                        if (isSuccess) {
                            deferred.resolveWith(callbackContext, [success, statusText, jqXHR])
                        } else {
                            deferred.rejectWith(callbackContext, [jqXHR, statusText, error])
                        }
                        jqXHR.statusCode(statusCode);
                        statusCode = undefined;
                        if (fireGlobals) {
                            globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [jqXHR, s, isSuccess ? success : error])
                        }
                        completeDeferred.fireWith(callbackContext, [jqXHR, statusText]);
                        if (fireGlobals) {
                            globalEventContext.trigger("ajaxComplete", [jqXHR, s]);
                            if (!(--jQuery.active)) {
                                jQuery.event.trigger("ajaxStop")
                            }
                        }
                    }
                    return jqXHR
                },
                getJSON: function(url, data, callback) {
                    return jQuery.get(url, data, callback, "json")
                },
                getScript: function(url, callback) {
                    return jQuery.get(url, undefined, callback, "script")
                }
            });
            jQuery.each(["get", "post"], function(i, method) {
                jQuery[method] = function(url, data, callback, type) {
                    if (isFunction(data)) {
                        type = type || callback;
                        callback = data;
                        data = undefined
                    }
                    return jQuery.ajax(jQuery.extend({
                        url: url,
                        type: method,
                        dataType: type,
                        data: data,
                        success: callback
                    }, jQuery.isPlainObject(url) && url))
                }
            });
            jQuery._evalUrl = function(url) {
                return jQuery.ajax({
                    url: url,
                    type: "GET",
                    dataType: "script",
                    cache: !0,
                    async: !1,
                    global: !1,
                    "throws": !0
                })
            };
            jQuery.fn.extend({
                wrapAll: function(html) {
                    var wrap;
                    if (this[0]) {
                        if (isFunction(html)) {
                            html = html.call(this[0])
                        }
                        wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(!0);
                        if (this[0].parentNode) {
                            wrap.insertBefore(this[0])
                        }
                        wrap.map(function() {
                            var elem = this;
                            while (elem.firstElementChild) {
                                elem = elem.firstElementChild
                            }
                            return elem
                        }).append(this)
                    }
                    return this
                },
                wrapInner: function(html) {
                    if (isFunction(html)) {
                        return this.each(function(i) {
                            jQuery(this).wrapInner(html.call(this, i))
                        })
                    }
                    return this.each(function() {
                        var self = jQuery(this),
                            contents = self.contents();
                        if (contents.length) {
                            contents.wrapAll(html)
                        } else {
                            self.append(html)
                        }
                    })
                },
                wrap: function(html) {
                    var htmlIsFunction = isFunction(html);
                    return this.each(function(i) {
                        jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html)
                    })
                },
                unwrap: function(selector) {
                    this.parent(selector).not("body").each(function() {
                        jQuery(this).replaceWith(this.childNodes)
                    });
                    return this
                }
            });
            jQuery.expr.pseudos.hidden = function(elem) {
                return !jQuery.expr.pseudos.visible(elem)
            };
            jQuery.expr.pseudos.visible = function(elem) {
                return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length)
            };
            jQuery.ajaxSettings.xhr = function() {
                try {
                    return new window.XMLHttpRequest()
                } catch (e) {}
            };
            var xhrSuccessStatus = {
                    0: 200,
                    1223: 204
                },
                xhrSupported = jQuery.ajaxSettings.xhr();
            support.cors = !!xhrSupported && ("withCredentials" in xhrSupported);
            support.ajax = xhrSupported = !!xhrSupported;
            jQuery.ajaxTransport(function(options) {
                var callback, errorCallback;
                if (support.cors || xhrSupported && !options.crossDomain) {
                    return {
                        send: function(headers, complete) {
                            var i, xhr = options.xhr();
                            xhr.open(options.type, options.url, options.async, options.username, options.password);
                            if (options.xhrFields) {
                                for (i in options.xhrFields) {
                                    xhr[i] = options.xhrFields[i]
                                }
                            }
                            if (options.mimeType && xhr.overrideMimeType) {
                                xhr.overrideMimeType(options.mimeType)
                            }
                            if (!options.crossDomain && !headers["X-Requested-With"]) {
                                headers["X-Requested-With"] = "XMLHttpRequest"
                            }
                            for (i in headers) {
                                xhr.setRequestHeader(i, headers[i])
                            }
                            callback = function(type) {
                                return function() {
                                    if (callback) {
                                        callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                                        if (type === "abort") {
                                            xhr.abort()
                                        } else if (type === "error") {
                                            if (typeof xhr.status !== "number") {
                                                complete(0, "error")
                                            } else {
                                                complete(xhr.status, xhr.statusText)
                                            }
                                        } else {
                                            complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                                binary: xhr.response
                                            } : {
                                                text: xhr.responseText
                                            }, xhr.getAllResponseHeaders())
                                        }
                                    }
                                }
                            };
                            xhr.onload = callback();
                            errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                            if (xhr.onabort !== undefined) {
                                xhr.onabort = errorCallback
                            } else {
                                xhr.onreadystatechange = function() {
                                    if (xhr.readyState === 4) {
                                        window.setTimeout(function() {
                                            if (callback) {
                                                errorCallback()
                                            }
                                        })
                                    }
                                }
                            }
                            callback = callback("abort");
                            try {
                                xhr.send(options.hasContent && options.data || null)
                            } catch (e) {
                                if (callback) {
                                    throw e
                                }
                            }
                        },
                        abort: function() {
                            if (callback) {
                                callback()
                            }
                        }
                    }
                }
            });
            jQuery.ajaxPrefilter(function(s) {
                if (s.crossDomain) {
                    s.contents.script = !1
                }
            });
            jQuery.ajaxSetup({
                accepts: {
                    script: "text/javascript, application/javascript, " + "application/ecmascript, application/x-ecmascript"
                },
                contents: {
                    script: /\b(?:java|ecma)script\b/
                },
                converters: {
                    "text script": function(text) {
                        jQuery.globalEval(text);
                        return text
                    }
                }
            });
            jQuery.ajaxPrefilter("script", function(s) {
                if (s.cache === undefined) {
                    s.cache = !1
                }
                if (s.crossDomain) {
                    s.type = "GET"
                }
            });
            jQuery.ajaxTransport("script", function(s) {
                if (s.crossDomain) {
                    var script, callback;
                    return {
                        send: function(_, complete) {
                            script = jQuery("<script>").prop({
                                charset: s.scriptCharset,
                                src: s.url
                            }).on("load error", callback = function(evt) {
                                script.remove();
                                callback = null;
                                if (evt) {
                                    complete(evt.type === "error" ? 404 : 200, evt.type)
                                }
                            });
                            document.head.appendChild(script[0])
                        },
                        abort: function() {
                            if (callback) {
                                callback()
                            }
                        }
                    }
                }
            });
            var oldCallbacks = [],
                rjsonp = /(=)\?(?=&|$)|\?\?/;
            jQuery.ajaxSetup({
                jsonp: "callback",
                jsonpCallback: function() {
                    var callback = oldCallbacks.pop() || (jQuery.expando + "_" + (nonce++));
                    this[callback] = !0;
                    return callback
                }
            });
            jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
                var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== !1 && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
                if (jsonProp || s.dataTypes[0] === "jsonp") {
                    callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
                    if (jsonProp) {
                        s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName)
                    } else if (s.jsonp !== !1) {
                        s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName
                    }
                    s.converters["script json"] = function() {
                        if (!responseContainer) {
                            jQuery.error(callbackName + " was not called")
                        }
                        return responseContainer[0]
                    };
                    s.dataTypes[0] = "json";
                    overwritten = window[callbackName];
                    window[callbackName] = function() {
                        responseContainer = arguments
                    };
                    jqXHR.always(function() {
                        if (overwritten === undefined) {
                            jQuery(window).removeProp(callbackName)
                        } else {
                            window[callbackName] = overwritten
                        }
                        if (s[callbackName]) {
                            s.jsonpCallback = originalSettings.jsonpCallback;
                            oldCallbacks.push(callbackName)
                        }
                        if (responseContainer && isFunction(overwritten)) {
                            overwritten(responseContainer[0])
                        }
                        responseContainer = overwritten = undefined
                    });
                    return "script"
                }
            });
            support.createHTMLDocument = (function() {
                var body = document.implementation.createHTMLDocument("").body;
                body.innerHTML = "<form></form><form></form>";
                return body.childNodes.length === 2
            })();
            jQuery.parseHTML = function(data, context, keepScripts) {
                if (typeof data !== "string") {
                    return []
                }
                if (typeof context === "boolean") {
                    keepScripts = context;
                    context = !1
                }
                var base, parsed, scripts;
                if (!context) {
                    if (support.createHTMLDocument) {
                        context = document.implementation.createHTMLDocument("");
                        base = context.createElement("base");
                        base.href = document.location.href;
                        context.head.appendChild(base)
                    } else {
                        context = document
                    }
                }
                parsed = rsingleTag.exec(data);
                scripts = !keepScripts && [];
                if (parsed) {
                    return [context.createElement(parsed[1])]
                }
                parsed = buildFragment([data], context, scripts);
                if (scripts && scripts.length) {
                    jQuery(scripts).remove()
                }
                return jQuery.merge([], parsed.childNodes)
            };
            jQuery.fn.load = function(url, params, callback) {
                var selector, type, response, self = this,
                    off = url.indexOf(" ");
                if (off > -1) {
                    selector = stripAndCollapse(url.slice(off));
                    url = url.slice(0, off)
                }
                if (isFunction(params)) {
                    callback = params;
                    params = undefined
                } else if (params && typeof params === "object") {
                    type = "POST"
                }
                if (self.length > 0) {
                    jQuery.ajax({
                        url: url,
                        type: type || "GET",
                        dataType: "html",
                        data: params
                    }).done(function(responseText) {
                        response = arguments;
                        self.html(selector ? jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : responseText)
                    }).always(callback && function(jqXHR, status) {
                        self.each(function() {
                            callback.apply(this, response || [jqXHR.responseText, status, jqXHR])
                        })
                    })
                }
                return this
            };
            jQuery.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(i, type) {
                jQuery.fn[type] = function(fn) {
                    return this.on(type, fn)
                }
            });
            jQuery.expr.pseudos.animated = function(elem) {
                return jQuery.grep(jQuery.timers, function(fn) {
                    return elem === fn.elem
                }).length
            };
            jQuery.offset = {
                setOffset: function(elem, options, i) {
                    var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"),
                        curElem = jQuery(elem),
                        props = {};
                    if (position === "static") {
                        elem.style.position = "relative"
                    }
                    curOffset = curElem.offset();
                    curCSSTop = jQuery.css(elem, "top");
                    curCSSLeft = jQuery.css(elem, "left");
                    calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
                    if (calculatePosition) {
                        curPosition = curElem.position();
                        curTop = curPosition.top;
                        curLeft = curPosition.left
                    } else {
                        curTop = parseFloat(curCSSTop) || 0;
                        curLeft = parseFloat(curCSSLeft) || 0
                    }
                    if (isFunction(options)) {
                        options = options.call(elem, i, jQuery.extend({}, curOffset))
                    }
                    if (options.top != null) {
                        props.top = (options.top - curOffset.top) + curTop
                    }
                    if (options.left != null) {
                        props.left = (options.left - curOffset.left) + curLeft
                    }
                    if ("using" in options) {
                        options.using.call(elem, props)
                    } else {
                        curElem.css(props)
                    }
                }
            };
            jQuery.fn.extend({
                offset: function(options) {
                    if (arguments.length) {
                        return options === undefined ? this : this.each(function(i) {
                            jQuery.offset.setOffset(this, options, i)
                        })
                    }
                    var rect, win, elem = this[0];
                    if (!elem) {
                        return
                    }
                    if (!elem.getClientRects().length) {
                        return {
                            top: 0,
                            left: 0
                        }
                    }
                    rect = elem.getBoundingClientRect();
                    win = elem.ownerDocument.defaultView;
                    return {
                        top: rect.top + win.pageYOffset,
                        left: rect.left + win.pageXOffset
                    }
                },
                position: function() {
                    if (!this[0]) {
                        return
                    }
                    var offsetParent, offset, doc, elem = this[0],
                        parentOffset = {
                            top: 0,
                            left: 0
                        };
                    if (jQuery.css(elem, "position") === "fixed") {
                        offset = elem.getBoundingClientRect()
                    } else {
                        offset = this.offset();
                        doc = elem.ownerDocument;
                        offsetParent = elem.offsetParent || doc.documentElement;
                        while (offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static") {
                            offsetParent = offsetParent.parentNode
                        }
                        if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                            parentOffset = jQuery(offsetParent).offset();
                            parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", !0);
                            parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", !0)
                        }
                    }
                    return {
                        top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", !0),
                        left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", !0)
                    }
                },
                offsetParent: function() {
                    return this.map(function() {
                        var offsetParent = this.offsetParent;
                        while (offsetParent && jQuery.css(offsetParent, "position") === "static") {
                            offsetParent = offsetParent.offsetParent
                        }
                        return offsetParent || documentElement
                    })
                }
            });
            jQuery.each({
                scrollLeft: "pageXOffset",
                scrollTop: "pageYOffset"
            }, function(method, prop) {
                var top = "pageYOffset" === prop;
                jQuery.fn[method] = function(val) {
                    return access(this, function(elem, method, val) {
                        var win;
                        if (isWindow(elem)) {
                            win = elem
                        } else if (elem.nodeType === 9) {
                            win = elem.defaultView
                        }
                        if (val === undefined) {
                            return win ? win[prop] : elem[method]
                        }
                        if (win) {
                            win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset)
                        } else {
                            elem[method] = val
                        }
                    }, method, val, arguments.length)
                }
            });
            jQuery.each(["top", "left"], function(i, prop) {
                jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
                    if (computed) {
                        computed = curCSS(elem, prop);
                        return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed
                    }
                })
            });
            jQuery.each({
                Height: "height",
                Width: "width"
            }, function(name, type) {
                jQuery.each({
                    padding: "inner" + name,
                    content: type,
                    "": "outer" + name
                }, function(defaultExtra, funcName) {
                    jQuery.fn[funcName] = function(margin, value) {
                        var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"),
                            extra = defaultExtra || (margin === !0 || value === !0 ? "margin" : "border");
                        return access(this, function(elem, type, value) {
                            var doc;
                            if (isWindow(elem)) {
                                return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name]
                            }
                            if (elem.nodeType === 9) {
                                doc = elem.documentElement;
                                return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name])
                            }
                            return value === undefined ? jQuery.css(elem, type, extra) : jQuery.style(elem, type, value, extra)
                        }, type, chainable ? margin : undefined, chainable)
                    }
                })
            });
            jQuery.each(("blur focus focusin focusout resize scroll click dblclick " + "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " + "change select submit keydown keypress keyup contextmenu").split(" "), function(i, name) {
                jQuery.fn[name] = function(data, fn) {
                    return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name)
                }
            });
            jQuery.fn.extend({
                hover: function(fnOver, fnOut) {
                    return this.mouseenter(fnOver).mouseleave(fnOut || fnOver)
                }
            });
            jQuery.fn.extend({
                bind: function(types, data, fn) {
                    return this.on(types, null, data, fn)
                },
                unbind: function(types, fn) {
                    return this.off(types, null, fn)
                },
                delegate: function(selector, types, data, fn) {
                    return this.on(types, selector, data, fn)
                },
                undelegate: function(selector, types, fn) {
                    return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn)
                }
            });
            jQuery.proxy = function(fn, context) {
                var tmp, args, proxy;
                if (typeof context === "string") {
                    tmp = fn[context];
                    context = fn;
                    fn = tmp
                }
                if (!isFunction(fn)) {
                    return undefined
                }
                args = slice.call(arguments, 2);
                proxy = function() {
                    return fn.apply(context || this, args.concat(slice.call(arguments)))
                };
                proxy.guid = fn.guid = fn.guid || jQuery.guid++;
                return proxy
            };
            jQuery.holdReady = function(hold) {
                if (hold) {
                    jQuery.readyWait++
                } else {
                    jQuery.ready(!0)
                }
            };
            jQuery.isArray = Array.isArray;
            jQuery.parseJSON = JSON.parse;
            jQuery.nodeName = nodeName;
            jQuery.isFunction = isFunction;
            jQuery.isWindow = isWindow;
            jQuery.camelCase = camelCase;
            jQuery.type = toType;
            jQuery.now = Date.now;
            jQuery.isNumeric = function(obj) {
                var type = jQuery.type(obj);
                return (type === "number" || type === "string") && !isNaN(obj - parseFloat(obj))
            };
            if (!0) {
                !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
                    return jQuery
                }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
            }
            var _jQuery = window.jQuery,
                _$ = window.$;
            jQuery.noConflict = function(deep) {
                if (window.$ === jQuery) {
                    window.$ = _$
                }
                if (deep && window.jQuery === jQuery) {
                    window.jQuery = _jQuery
                }
                return jQuery
            };
            if (!noGlobal) {
                window.jQuery = window.$ = jQuery
            }
            return jQuery
        })
    }),
    "../node_modules/jquery/dist/jquery.js-exposed": (function(module, exports, __webpack_require__) {
        (function(global) {
            module.exports = global.jQuery = __webpack_require__("../node_modules/jquery/dist/jquery.js")
        }.call(this, __webpack_require__("../node_modules/webpack/buildin/global.js")))
    }),
    "../node_modules/slick-carousel/slick/slick.js": (function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        (function(factory) {
            'use strict';
            if (!0) {
                !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/jquery/dist/jquery.js-exposed")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
            } else {}
        }(function($) {
            'use strict';
            var Slick = window.Slick || {};
            Slick = (function() {
                var instanceUid = 0;

                function Slick(element, settings) {
                    var _ = this,
                        dataSettings;
                    _.defaults = {
                        accessibility: !0,
                        adaptiveHeight: !1,
                        appendArrows: $(element),
                        appendDots: $(element),
                        arrows: !0,
                        asNavFor: null,
                        prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                        nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                        autoplay: !1,
                        autoplaySpeed: 3000,
                        centerMode: !1,
                        centerPadding: '50px',
                        cssEase: 'ease',
                        customPaging: function(slider, i) {
                            return $('<button type="button" />').text(i + 1)
                        },
                        dots: !1,
                        dotsClass: 'slick-dots',
                        draggable: !0,
                        easing: 'linear',
                        edgeFriction: 0.35,
                        fade: !1,
                        focusOnSelect: !1,
                        focusOnChange: !1,
                        infinite: !0,
                        initialSlide: 0,
                        lazyLoad: 'ondemand',
                        mobileFirst: !1,
                        pauseOnHover: !0,
                        pauseOnFocus: !0,
                        pauseOnDotsHover: !1,
                        respondTo: 'window',
                        responsive: null,
                        rows: 1,
                        rtl: !1,
                        slide: '',
                        slidesPerRow: 1,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        speed: 500,
                        swipe: !0,
                        swipeToSlide: !1,
                        touchMove: !0,
                        touchThreshold: 5,
                        useCSS: !0,
                        useTransform: !0,
                        variableWidth: !1,
                        vertical: !1,
                        verticalSwiping: !1,
                        waitForAnimate: !0,
                        zIndex: 1000
                    };
                    _.initials = {
                        animating: !1,
                        dragging: !1,
                        autoPlayTimer: null,
                        currentDirection: 0,
                        currentLeft: null,
                        currentSlide: 0,
                        direction: 1,
                        $dots: null,
                        listWidth: null,
                        listHeight: null,
                        loadIndex: 0,
                        $nextArrow: null,
                        $prevArrow: null,
                        scrolling: !1,
                        slideCount: null,
                        slideWidth: null,
                        $slideTrack: null,
                        $slides: null,
                        sliding: !1,
                        slideOffset: 0,
                        swipeLeft: null,
                        swiping: !1,
                        $list: null,
                        touchObject: {},
                        transformsEnabled: !1,
                        unslicked: !1
                    };
                    $.extend(_, _.initials);
                    _.activeBreakpoint = null;
                    _.animType = null;
                    _.animProp = null;
                    _.breakpoints = [];
                    _.breakpointSettings = [];
                    _.cssTransitions = !1;
                    _.focussed = !1;
                    _.interrupted = !1;
                    _.hidden = 'hidden';
                    _.paused = !0;
                    _.positionProp = null;
                    _.respondTo = null;
                    _.rowCount = 1;
                    _.shouldClick = !0;
                    _.$slider = $(element);
                    _.$slidesCache = null;
                    _.transformType = null;
                    _.transitionType = null;
                    _.visibilityChange = 'visibilitychange';
                    _.windowWidth = 0;
                    _.windowTimer = null;
                    dataSettings = $(element).data('slick') || {};
                    _.options = $.extend({}, _.defaults, settings, dataSettings);
                    _.currentSlide = _.options.initialSlide;
                    _.originalSettings = _.options;
                    if (typeof document.mozHidden !== 'undefined') {
                        _.hidden = 'mozHidden';
                        _.visibilityChange = 'mozvisibilitychange'
                    } else if (typeof document.webkitHidden !== 'undefined') {
                        _.hidden = 'webkitHidden';
                        _.visibilityChange = 'webkitvisibilitychange'
                    }
                    _.autoPlay = $.proxy(_.autoPlay, _);
                    _.autoPlayClear = $.proxy(_.autoPlayClear, _);
                    _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
                    _.changeSlide = $.proxy(_.changeSlide, _);
                    _.clickHandler = $.proxy(_.clickHandler, _);
                    _.selectHandler = $.proxy(_.selectHandler, _);
                    _.setPosition = $.proxy(_.setPosition, _);
                    _.swipeHandler = $.proxy(_.swipeHandler, _);
                    _.dragHandler = $.proxy(_.dragHandler, _);
                    _.keyHandler = $.proxy(_.keyHandler, _);
                    _.instanceUid = instanceUid++;
                    _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;
                    _.registerBreakpoints();
                    _.init(!0)
                }
                return Slick
            }());
            Slick.prototype.activateADA = function() {
                var _ = this;
                _.$slideTrack.find('.slick-active').attr({
                    'aria-hidden': 'false'
                }).find('a, input, button, select').attr({
                    'tabindex': '0'
                })
            };
            Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {
                var _ = this;
                if (typeof(index) === 'boolean') {
                    addBefore = index;
                    index = null
                } else if (index < 0 || (index >= _.slideCount)) {
                    return !1
                }
                _.unload();
                if (typeof(index) === 'number') {
                    if (index === 0 && _.$slides.length === 0) {
                        $(markup).appendTo(_.$slideTrack)
                    } else if (addBefore) {
                        $(markup).insertBefore(_.$slides.eq(index))
                    } else {
                        $(markup).insertAfter(_.$slides.eq(index))
                    }
                } else {
                    if (addBefore === !0) {
                        $(markup).prependTo(_.$slideTrack)
                    } else {
                        $(markup).appendTo(_.$slideTrack)
                    }
                }
                _.$slides = _.$slideTrack.children(this.options.slide);
                _.$slideTrack.children(this.options.slide).detach();
                _.$slideTrack.append(_.$slides);
                _.$slides.each(function(index, element) {
                    $(element).attr('data-slick-index', index)
                });
                _.$slidesCache = _.$slides;
                _.reinit()
            };
            Slick.prototype.animateHeight = function() {
                var _ = this;
                if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === !0 && _.options.vertical === !1) {
                    var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(!0);
                    _.$list.animate({
                        height: targetHeight
                    }, _.options.speed)
                }
            };
            Slick.prototype.animateSlide = function(targetLeft, callback) {
                var animProps = {},
                    _ = this;
                _.animateHeight();
                if (_.options.rtl === !0 && _.options.vertical === !1) {
                    targetLeft = -targetLeft
                }
                if (_.transformsEnabled === !1) {
                    if (_.options.vertical === !1) {
                        _.$slideTrack.animate({
                            left: targetLeft
                        }, _.options.speed, _.options.easing, callback)
                    } else {
                        _.$slideTrack.animate({
                            top: targetLeft
                        }, _.options.speed, _.options.easing, callback)
                    }
                } else {
                    if (_.cssTransitions === !1) {
                        if (_.options.rtl === !0) {
                            _.currentLeft = -(_.currentLeft)
                        }
                        $({
                            animStart: _.currentLeft
                        }).animate({
                            animStart: targetLeft
                        }, {
                            duration: _.options.speed,
                            easing: _.options.easing,
                            step: function(now) {
                                now = Math.ceil(now);
                                if (_.options.vertical === !1) {
                                    animProps[_.animType] = 'translate(' + now + 'px, 0px)';
                                    _.$slideTrack.css(animProps)
                                } else {
                                    animProps[_.animType] = 'translate(0px,' + now + 'px)';
                                    _.$slideTrack.css(animProps)
                                }
                            },
                            complete: function() {
                                if (callback) {
                                    callback.call()
                                }
                            }
                        })
                    } else {
                        _.applyTransition();
                        targetLeft = Math.ceil(targetLeft);
                        if (_.options.vertical === !1) {
                            animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)'
                        } else {
                            animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)'
                        }
                        _.$slideTrack.css(animProps);
                        if (callback) {
                            setTimeout(function() {
                                _.disableTransition();
                                callback.call()
                            }, _.options.speed)
                        }
                    }
                }
            };
            Slick.prototype.getNavTarget = function() {
                var _ = this,
                    asNavFor = _.options.asNavFor;
                if (asNavFor && asNavFor !== null) {
                    asNavFor = $(asNavFor).not(_.$slider)
                }
                return asNavFor
            };
            Slick.prototype.asNavFor = function(index) {
                var _ = this,
                    asNavFor = _.getNavTarget();
                if (asNavFor !== null && typeof asNavFor === 'object') {
                    asNavFor.each(function() {
                        var target = $(this).slick('getSlick');
                        if (!target.unslicked) {
                            target.slideHandler(index, !0)
                        }
                    })
                }
            };
            Slick.prototype.applyTransition = function(slide) {
                var _ = this,
                    transition = {};
                if (_.options.fade === !1) {
                    transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase
                } else {
                    transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase
                }
                if (_.options.fade === !1) {
                    _.$slideTrack.css(transition)
                } else {
                    _.$slides.eq(slide).css(transition)
                }
            };
            Slick.prototype.autoPlay = function() {
                var _ = this;
                _.autoPlayClear();
                if (_.slideCount > _.options.slidesToShow) {
                    _.autoPlayTimer = setInterval(_.autoPlayIterator, _.options.autoplaySpeed)
                }
            };
            Slick.prototype.autoPlayClear = function() {
                var _ = this;
                if (_.autoPlayTimer) {
                    clearInterval(_.autoPlayTimer)
                }
            };
            Slick.prototype.autoPlayIterator = function() {
                var _ = this,
                    slideTo = _.currentSlide + _.options.slidesToScroll;
                if (!_.paused && !_.interrupted && !_.focussed) {
                    if (_.options.infinite === !1) {
                        if (_.direction === 1 && (_.currentSlide + 1) === (_.slideCount - 1)) {
                            _.direction = 0
                        } else if (_.direction === 0) {
                            slideTo = _.currentSlide - _.options.slidesToScroll;
                            if (_.currentSlide - 1 === 0) {
                                _.direction = 1
                            }
                        }
                    }
                    _.slideHandler(slideTo)
                }
            };
            Slick.prototype.buildArrows = function() {
                var _ = this;
                if (_.options.arrows === !0) {
                    _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
                    _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');
                    if (_.slideCount > _.options.slidesToShow) {
                        _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                        _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                        if (_.htmlExpr.test(_.options.prevArrow)) {
                            _.$prevArrow.prependTo(_.options.appendArrows)
                        }
                        if (_.htmlExpr.test(_.options.nextArrow)) {
                            _.$nextArrow.appendTo(_.options.appendArrows)
                        }
                        if (_.options.infinite !== !0) {
                            _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true')
                        }
                    } else {
                        _.$prevArrow.add(_.$nextArrow).addClass('slick-hidden').attr({
                            'aria-disabled': 'true',
                            'tabindex': '-1'
                        })
                    }
                }
            };
            Slick.prototype.buildDots = function() {
                var _ = this,
                    i, dot;
                if (_.options.dots === !0 && _.slideCount > _.options.slidesToShow) {
                    _.$slider.addClass('slick-dotted');
                    dot = $('<ul />').addClass(_.options.dotsClass);
                    for (i = 0; i <= _.getDotCount(); i += 1) {
                        dot.append($('<li />').append(_.options.customPaging.call(this, _, i)))
                    }
                    _.$dots = dot.appendTo(_.options.appendDots);
                    _.$dots.find('li').first().addClass('slick-active')
                }
            };
            Slick.prototype.buildOut = function() {
                var _ = this;
                _.$slides = _.$slider.children(_.options.slide + ':not(.slick-cloned)').addClass('slick-slide');
                _.slideCount = _.$slides.length;
                _.$slides.each(function(index, element) {
                    $(element).attr('data-slick-index', index).data('originalStyling', $(element).attr('style') || '')
                });
                _.$slider.addClass('slick-slider');
                _.$slideTrack = (_.slideCount === 0) ? $('<div class="slick-track"/>').appendTo(_.$slider) : _.$slides.wrapAll('<div class="slick-track"/>').parent();
                _.$list = _.$slideTrack.wrap('<div class="slick-list"/>').parent();
                _.$slideTrack.css('opacity', 0);
                if (_.options.centerMode === !0 || _.options.swipeToSlide === !0) {
                    _.options.slidesToScroll = 1
                }
                $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');
                _.setupInfinite();
                _.buildArrows();
                _.buildDots();
                _.updateDots();
                _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
                if (_.options.draggable === !0) {
                    _.$list.addClass('draggable')
                }
            };
            Slick.prototype.buildRows = function() {
                var _ = this,
                    a, b, c, newSlides, numOfSlides, originalSlides, slidesPerSection;
                newSlides = document.createDocumentFragment();
                originalSlides = _.$slider.children();
                if (_.options.rows > 0) {
                    slidesPerSection = _.options.slidesPerRow * _.options.rows;
                    numOfSlides = Math.ceil(originalSlides.length / slidesPerSection);
                    for (a = 0; a < numOfSlides; a++) {
                        var slide = document.createElement('div');
                        for (b = 0; b < _.options.rows; b++) {
                            var row = document.createElement('div');
                            for (c = 0; c < _.options.slidesPerRow; c++) {
                                var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));
                                if (originalSlides.get(target)) {
                                    row.appendChild(originalSlides.get(target))
                                }
                            }
                            slide.appendChild(row)
                        }
                        newSlides.appendChild(slide)
                    }
                    _.$slider.empty().append(newSlides);
                    _.$slider.children().children().children().css({
                        'width': (100 / _.options.slidesPerRow) + '%',
                        'display': 'inline-block'
                    })
                }
            };
            Slick.prototype.checkResponsive = function(initial, forceUpdate) {
                var _ = this,
                    breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = !1;
                var sliderWidth = _.$slider.width();
                var windowWidth = window.innerWidth || $(window).width();
                if (_.respondTo === 'window') {
                    respondToWidth = windowWidth
                } else if (_.respondTo === 'slider') {
                    respondToWidth = sliderWidth
                } else if (_.respondTo === 'min') {
                    respondToWidth = Math.min(windowWidth, sliderWidth)
                }
                if (_.options.responsive && _.options.responsive.length && _.options.responsive !== null) {
                    targetBreakpoint = null;
                    for (breakpoint in _.breakpoints) {
                        if (_.breakpoints.hasOwnProperty(breakpoint)) {
                            if (_.originalSettings.mobileFirst === !1) {
                                if (respondToWidth < _.breakpoints[breakpoint]) {
                                    targetBreakpoint = _.breakpoints[breakpoint]
                                }
                            } else {
                                if (respondToWidth > _.breakpoints[breakpoint]) {
                                    targetBreakpoint = _.breakpoints[breakpoint]
                                }
                            }
                        }
                    }
                    if (targetBreakpoint !== null) {
                        if (_.activeBreakpoint !== null) {
                            if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                                _.activeBreakpoint = targetBreakpoint;
                                if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                                    _.unslick(targetBreakpoint)
                                } else {
                                    _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
                                    if (initial === !0) {
                                        _.currentSlide = _.options.initialSlide
                                    }
                                    _.refresh(initial)
                                }
                                triggerBreakpoint = targetBreakpoint
                            }
                        } else {
                            _.activeBreakpoint = targetBreakpoint;
                            if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                                _.unslick(targetBreakpoint)
                            } else {
                                _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
                                if (initial === !0) {
                                    _.currentSlide = _.options.initialSlide
                                }
                                _.refresh(initial)
                            }
                            triggerBreakpoint = targetBreakpoint
                        }
                    } else {
                        if (_.activeBreakpoint !== null) {
                            _.activeBreakpoint = null;
                            _.options = _.originalSettings;
                            if (initial === !0) {
                                _.currentSlide = _.options.initialSlide
                            }
                            _.refresh(initial);
                            triggerBreakpoint = targetBreakpoint
                        }
                    }
                    if (!initial && triggerBreakpoint !== !1) {
                        _.$slider.trigger('breakpoint', [_, triggerBreakpoint])
                    }
                }
            };
            Slick.prototype.changeSlide = function(event, dontAnimate) {
                var _ = this,
                    $target = $(event.currentTarget),
                    indexOffset, slideOffset, unevenOffset;
                if ($target.is('a')) {
                    event.preventDefault()
                }
                if (!$target.is('li')) {
                    $target = $target.closest('li')
                }
                unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
                indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;
                switch (event.data.message) {
                    case 'previous':
                        slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                        if (_.slideCount > _.options.slidesToShow) {
                            _.slideHandler(_.currentSlide - slideOffset, !1, dontAnimate)
                        }
                        break;
                    case 'next':
                        slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                        if (_.slideCount > _.options.slidesToShow) {
                            _.slideHandler(_.currentSlide + slideOffset, !1, dontAnimate)
                        }
                        break;
                    case 'index':
                        var index = event.data.index === 0 ? 0 : event.data.index || $target.index() * _.options.slidesToScroll;
                        _.slideHandler(_.checkNavigable(index), !1, dontAnimate);
                        $target.children().trigger('focus');
                        break;
                    default:
                        return
                }
            };
            Slick.prototype.checkNavigable = function(index) {
                var _ = this,
                    navigables, prevNavigable;
                navigables = _.getNavigableIndexes();
                prevNavigable = 0;
                if (index > navigables[navigables.length - 1]) {
                    index = navigables[navigables.length - 1]
                } else {
                    for (var n in navigables) {
                        if (index < navigables[n]) {
                            index = prevNavigable;
                            break
                        }
                        prevNavigable = navigables[n]
                    }
                }
                return index
            };
            Slick.prototype.cleanUpEvents = function() {
                var _ = this;
                if (_.options.dots && _.$dots !== null) {
                    $('li', _.$dots).off('click.slick', _.changeSlide).off('mouseenter.slick', $.proxy(_.interrupt, _, !0)).off('mouseleave.slick', $.proxy(_.interrupt, _, !1));
                    if (_.options.accessibility === !0) {
                        _.$dots.off('keydown.slick', _.keyHandler)
                    }
                }
                _.$slider.off('focus.slick blur.slick');
                if (_.options.arrows === !0 && _.slideCount > _.options.slidesToShow) {
                    _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
                    _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);
                    if (_.options.accessibility === !0) {
                        _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
                        _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler)
                    }
                }
                _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
                _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
                _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
                _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);
                _.$list.off('click.slick', _.clickHandler);
                $(document).off(_.visibilityChange, _.visibility);
                _.cleanUpSlideEvents();
                if (_.options.accessibility === !0) {
                    _.$list.off('keydown.slick', _.keyHandler)
                }
                if (_.options.focusOnSelect === !0) {
                    $(_.$slideTrack).children().off('click.slick', _.selectHandler)
                }
                $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);
                $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);
                $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);
                $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition)
            };
            Slick.prototype.cleanUpSlideEvents = function() {
                var _ = this;
                _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, !0));
                _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, !1))
            };
            Slick.prototype.cleanUpRows = function() {
                var _ = this,
                    originalSlides;
                if (_.options.rows > 0) {
                    originalSlides = _.$slides.children().children();
                    originalSlides.removeAttr('style');
                    _.$slider.empty().append(originalSlides)
                }
            };
            Slick.prototype.clickHandler = function(event) {
                var _ = this;
                if (_.shouldClick === !1) {
                    event.stopImmediatePropagation();
                    event.stopPropagation();
                    event.preventDefault()
                }
            };
            Slick.prototype.destroy = function(refresh) {
                var _ = this;
                _.autoPlayClear();
                _.touchObject = {};
                _.cleanUpEvents();
                $('.slick-cloned', _.$slider).detach();
                if (_.$dots) {
                    _.$dots.remove()
                }
                if (_.$prevArrow && _.$prevArrow.length) {
                    _.$prevArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');
                    if (_.htmlExpr.test(_.options.prevArrow)) {
                        _.$prevArrow.remove()
                    }
                }
                if (_.$nextArrow && _.$nextArrow.length) {
                    _.$nextArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');
                    if (_.htmlExpr.test(_.options.nextArrow)) {
                        _.$nextArrow.remove()
                    }
                }
                if (_.$slides) {
                    _.$slides.removeClass('slick-slide slick-active slick-center slick-visible slick-current').removeAttr('aria-hidden').removeAttr('data-slick-index').each(function() {
                        $(this).attr('style', $(this).data('originalStyling'))
                    });
                    _.$slideTrack.children(this.options.slide).detach();
                    _.$slideTrack.detach();
                    _.$list.detach();
                    _.$slider.append(_.$slides)
                }
                _.cleanUpRows();
                _.$slider.removeClass('slick-slider');
                _.$slider.removeClass('slick-initialized');
                _.$slider.removeClass('slick-dotted');
                _.unslicked = !0;
                if (!refresh) {
                    _.$slider.trigger('destroy', [_])
                }
            };
            Slick.prototype.disableTransition = function(slide) {
                var _ = this,
                    transition = {};
                transition[_.transitionType] = '';
                if (_.options.fade === !1) {
                    _.$slideTrack.css(transition)
                } else {
                    _.$slides.eq(slide).css(transition)
                }
            };
            Slick.prototype.fadeSlide = function(slideIndex, callback) {
                var _ = this;
                if (_.cssTransitions === !1) {
                    _.$slides.eq(slideIndex).css({
                        zIndex: _.options.zIndex
                    });
                    _.$slides.eq(slideIndex).animate({
                        opacity: 1
                    }, _.options.speed, _.options.easing, callback)
                } else {
                    _.applyTransition(slideIndex);
                    _.$slides.eq(slideIndex).css({
                        opacity: 1,
                        zIndex: _.options.zIndex
                    });
                    if (callback) {
                        setTimeout(function() {
                            _.disableTransition(slideIndex);
                            callback.call()
                        }, _.options.speed)
                    }
                }
            };
            Slick.prototype.fadeSlideOut = function(slideIndex) {
                var _ = this;
                if (_.cssTransitions === !1) {
                    _.$slides.eq(slideIndex).animate({
                        opacity: 0,
                        zIndex: _.options.zIndex - 2
                    }, _.options.speed, _.options.easing)
                } else {
                    _.applyTransition(slideIndex);
                    _.$slides.eq(slideIndex).css({
                        opacity: 0,
                        zIndex: _.options.zIndex - 2
                    })
                }
            };
            Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {
                var _ = this;
                if (filter !== null) {
                    _.$slidesCache = _.$slides;
                    _.unload();
                    _.$slideTrack.children(this.options.slide).detach();
                    _.$slidesCache.filter(filter).appendTo(_.$slideTrack);
                    _.reinit()
                }
            };
            Slick.prototype.focusHandler = function() {
                var _ = this;
                _.$slider.off('focus.slick blur.slick').on('focus.slick blur.slick', '*', function(event) {
                    event.stopImmediatePropagation();
                    var $sf = $(this);
                    setTimeout(function() {
                        if (_.options.pauseOnFocus) {
                            _.focussed = $sf.is(':focus');
                            _.autoPlay()
                        }
                    }, 0)
                })
            };
            Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {
                var _ = this;
                return _.currentSlide
            };
            Slick.prototype.getDotCount = function() {
                var _ = this;
                var breakPoint = 0;
                var counter = 0;
                var pagerQty = 0;
                if (_.options.infinite === !0) {
                    if (_.slideCount <= _.options.slidesToShow) {
                        ++pagerQty
                    } else {
                        while (breakPoint < _.slideCount) {
                            ++pagerQty;
                            breakPoint = counter + _.options.slidesToScroll;
                            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow
                        }
                    }
                } else if (_.options.centerMode === !0) {
                    pagerQty = _.slideCount
                } else if (!_.options.asNavFor) {
                    pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll)
                } else {
                    while (breakPoint < _.slideCount) {
                        ++pagerQty;
                        breakPoint = counter + _.options.slidesToScroll;
                        counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow
                    }
                }
                return pagerQty - 1
            };
            Slick.prototype.getLeft = function(slideIndex) {
                var _ = this,
                    targetLeft, verticalHeight, verticalOffset = 0,
                    targetSlide, coef;
                _.slideOffset = 0;
                verticalHeight = _.$slides.first().outerHeight(!0);
                if (_.options.infinite === !0) {
                    if (_.slideCount > _.options.slidesToShow) {
                        _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
                        coef = -1
                        if (_.options.vertical === !0 && _.options.centerMode === !0) {
                            if (_.options.slidesToShow === 2) {
                                coef = -1.5
                            } else if (_.options.slidesToShow === 1) {
                                coef = -2
                            }
                        }
                        verticalOffset = (verticalHeight * _.options.slidesToShow) * coef
                    }
                    if (_.slideCount % _.options.slidesToScroll !== 0) {
                        if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                            if (slideIndex > _.slideCount) {
                                _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
                                verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1
                            } else {
                                _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
                                verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1
                            }
                        }
                    }
                } else {
                    if (slideIndex + _.options.slidesToShow > _.slideCount) {
                        _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
                        verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight
                    }
                }
                if (_.slideCount <= _.options.slidesToShow) {
                    _.slideOffset = 0;
                    verticalOffset = 0
                }
                if (_.options.centerMode === !0 && _.slideCount <= _.options.slidesToShow) {
                    _.slideOffset = ((_.slideWidth * Math.floor(_.options.slidesToShow)) / 2) - ((_.slideWidth * _.slideCount) / 2)
                } else if (_.options.centerMode === !0 && _.options.infinite === !0) {
                    _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth
                } else if (_.options.centerMode === !0) {
                    _.slideOffset = 0;
                    _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2)
                }
                if (_.options.vertical === !1) {
                    targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset
                } else {
                    targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset
                }
                if (_.options.variableWidth === !0) {
                    if (_.slideCount <= _.options.slidesToShow || _.options.infinite === !1) {
                        targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex)
                    } else {
                        targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow)
                    }
                    if (_.options.rtl === !0) {
                        if (targetSlide[0]) {
                            targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1
                        } else {
                            targetLeft = 0
                        }
                    } else {
                        targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0
                    }
                    if (_.options.centerMode === !0) {
                        if (_.slideCount <= _.options.slidesToShow || _.options.infinite === !1) {
                            targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex)
                        } else {
                            targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1)
                        }
                        if (_.options.rtl === !0) {
                            if (targetSlide[0]) {
                                targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1
                            } else {
                                targetLeft = 0
                            }
                        } else {
                            targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0
                        }
                        targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2
                    }
                }
                return targetLeft
            };
            Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {
                var _ = this;
                return _.options[option]
            };
            Slick.prototype.getNavigableIndexes = function() {
                var _ = this,
                    breakPoint = 0,
                    counter = 0,
                    indexes = [],
                    max;
                if (_.options.infinite === !1) {
                    max = _.slideCount
                } else {
                    breakPoint = _.options.slidesToScroll * -1;
                    counter = _.options.slidesToScroll * -1;
                    max = _.slideCount * 2
                }
                while (breakPoint < max) {
                    indexes.push(breakPoint);
                    breakPoint = counter + _.options.slidesToScroll;
                    counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow
                }
                return indexes
            };
            Slick.prototype.getSlick = function() {
                return this
            };
            Slick.prototype.getSlideCount = function() {
                var _ = this,
                    slidesTraversed, swipedSlide, centerOffset;
                centerOffset = _.options.centerMode === !0 ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;
                if (_.options.swipeToSlide === !0) {
                    _.$slideTrack.find('.slick-slide').each(function(index, slide) {
                        if (slide.offsetLeft - centerOffset + ($(slide).outerWidth() / 2) > (_.swipeLeft * -1)) {
                            swipedSlide = slide;
                            return !1
                        }
                    });
                    slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;
                    return slidesTraversed
                } else {
                    return _.options.slidesToScroll
                }
            };
            Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {
                var _ = this;
                _.changeSlide({
                    data: {
                        message: 'index',
                        index: parseInt(slide)
                    }
                }, dontAnimate)
            };
            Slick.prototype.init = function(creation) {
                var _ = this;
                if (!$(_.$slider).hasClass('slick-initialized')) {
                    $(_.$slider).addClass('slick-initialized');
                    _.buildRows();
                    _.buildOut();
                    _.setProps();
                    _.startLoad();
                    _.loadSlider();
                    _.initializeEvents();
                    _.updateArrows();
                    _.updateDots();
                    _.checkResponsive(!0);
                    _.focusHandler()
                }
                if (creation) {
                    _.$slider.trigger('init', [_])
                }
                if (_.options.accessibility === !0) {
                    _.initADA()
                }
                if (_.options.autoplay) {
                    _.paused = !1;
                    _.autoPlay()
                }
            };
            Slick.prototype.initADA = function() {
                var _ = this,
                    numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow),
                    tabControlIndexes = _.getNavigableIndexes().filter(function(val) {
                        return (val >= 0) && (val < _.slideCount)
                    });
                _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
                    'aria-hidden': 'true',
                    'tabindex': '-1'
                }).find('a, input, button, select').attr({
                    'tabindex': '-1'
                });
                if (_.$dots !== null) {
                    _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {
                        var slideControlIndex = tabControlIndexes.indexOf(i);
                        $(this).attr({
                            'role': 'tabpanel',
                            'id': 'slick-slide' + _.instanceUid + i,
                            'tabindex': -1
                        });
                        if (slideControlIndex !== -1) {
                            var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex
                            if ($('#' + ariaButtonControl).length) {
                                $(this).attr({
                                    'aria-describedby': ariaButtonControl
                                })
                            }
                        }
                    });
                    _.$dots.attr('role', 'tablist').find('li').each(function(i) {
                        var mappedSlideIndex = tabControlIndexes[i];
                        $(this).attr({
                            'role': 'presentation'
                        });
                        $(this).find('button').first().attr({
                            'role': 'tab',
                            'id': 'slick-slide-control' + _.instanceUid + i,
                            'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
                            'aria-label': (i + 1) + ' of ' + numDotGroups,
                            'aria-selected': null,
                            'tabindex': '-1'
                        })
                    }).eq(_.currentSlide).find('button').attr({
                        'aria-selected': 'true',
                        'tabindex': '0'
                    }).end()
                }
                for (var i = _.currentSlide, max = i + _.options.slidesToShow; i < max; i++) {
                    if (_.options.focusOnChange) {
                        _.$slides.eq(i).attr({
                            'tabindex': '0'
                        })
                    } else {
                        _.$slides.eq(i).removeAttr('tabindex')
                    }
                }
                _.activateADA()
            };
            Slick.prototype.initArrowEvents = function() {
                var _ = this;
                if (_.options.arrows === !0 && _.slideCount > _.options.slidesToShow) {
                    _.$prevArrow.off('click.slick').on('click.slick', {
                        message: 'previous'
                    }, _.changeSlide);
                    _.$nextArrow.off('click.slick').on('click.slick', {
                        message: 'next'
                    }, _.changeSlide);
                    if (_.options.accessibility === !0) {
                        _.$prevArrow.on('keydown.slick', _.keyHandler);
                        _.$nextArrow.on('keydown.slick', _.keyHandler)
                    }
                }
            };
            Slick.prototype.initDotEvents = function() {
                var _ = this;
                if (_.options.dots === !0 && _.slideCount > _.options.slidesToShow) {
                    $('li', _.$dots).on('click.slick', {
                        message: 'index'
                    }, _.changeSlide);
                    if (_.options.accessibility === !0) {
                        _.$dots.on('keydown.slick', _.keyHandler)
                    }
                }
                if (_.options.dots === !0 && _.options.pauseOnDotsHover === !0 && _.slideCount > _.options.slidesToShow) {
                    $('li', _.$dots).on('mouseenter.slick', $.proxy(_.interrupt, _, !0)).on('mouseleave.slick', $.proxy(_.interrupt, _, !1))
                }
            };
            Slick.prototype.initSlideEvents = function() {
                var _ = this;
                if (_.options.pauseOnHover) {
                    _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, !0));
                    _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, !1))
                }
            };
            Slick.prototype.initializeEvents = function() {
                var _ = this;
                _.initArrowEvents();
                _.initDotEvents();
                _.initSlideEvents();
                _.$list.on('touchstart.slick mousedown.slick', {
                    action: 'start'
                }, _.swipeHandler);
                _.$list.on('touchmove.slick mousemove.slick', {
                    action: 'move'
                }, _.swipeHandler);
                _.$list.on('touchend.slick mouseup.slick', {
                    action: 'end'
                }, _.swipeHandler);
                _.$list.on('touchcancel.slick mouseleave.slick', {
                    action: 'end'
                }, _.swipeHandler);
                _.$list.on('click.slick', _.clickHandler);
                $(document).on(_.visibilityChange, $.proxy(_.visibility, _));
                if (_.options.accessibility === !0) {
                    _.$list.on('keydown.slick', _.keyHandler)
                }
                if (_.options.focusOnSelect === !0) {
                    $(_.$slideTrack).children().on('click.slick', _.selectHandler)
                }
                $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));
                $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));
                $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);
                $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
                $(_.setPosition)
            };
            Slick.prototype.initUI = function() {
                var _ = this;
                if (_.options.arrows === !0 && _.slideCount > _.options.slidesToShow) {
                    _.$prevArrow.show();
                    _.$nextArrow.show()
                }
                if (_.options.dots === !0 && _.slideCount > _.options.slidesToShow) {
                    _.$dots.show()
                }
            };
            Slick.prototype.keyHandler = function(event) {
                var _ = this;
                if (!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
                    if (event.keyCode === 37 && _.options.accessibility === !0) {
                        _.changeSlide({
                            data: {
                                message: _.options.rtl === !0 ? 'next' : 'previous'
                            }
                        })
                    } else if (event.keyCode === 39 && _.options.accessibility === !0) {
                        _.changeSlide({
                            data: {
                                message: _.options.rtl === !0 ? 'previous' : 'next'
                            }
                        })
                    }
                }
            };
            Slick.prototype.lazyLoad = function() {
                var _ = this,
                    loadRange, cloneRange, rangeStart, rangeEnd;

                function loadImages(imagesScope) {
                    $('img[data-lazy]', imagesScope).each(function() {
                        var image = $(this),
                            imageSource = $(this).attr('data-lazy'),
                            imageSrcSet = $(this).attr('data-srcset'),
                            imageSizes = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
                            imageToLoad = document.createElement('img');
                        imageToLoad.onload = function() {
                            image.animate({
                                opacity: 0
                            }, 100, function() {
                                if (imageSrcSet) {
                                    image.attr('srcset', imageSrcSet);
                                    if (imageSizes) {
                                        image.attr('sizes', imageSizes)
                                    }
                                }
                                image.attr('src', imageSource).animate({
                                    opacity: 1
                                }, 200, function() {
                                    image.removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading')
                                });
                                _.$slider.trigger('lazyLoaded', [_, image, imageSource])
                            })
                        };
                        imageToLoad.onerror = function() {
                            image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');
                            _.$slider.trigger('lazyLoadError', [_, image, imageSource])
                        };
                        imageToLoad.src = imageSource
                    })
                }
                if (_.options.centerMode === !0) {
                    if (_.options.infinite === !0) {
                        rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                        rangeEnd = rangeStart + _.options.slidesToShow + 2
                    } else {
                        rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                        rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide
                    }
                } else {
                    rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
                    rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
                    if (_.options.fade === !0) {
                        if (rangeStart > 0) rangeStart--;
                        if (rangeEnd <= _.slideCount) rangeEnd++
                    }
                }
                loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);
                if (_.options.lazyLoad === 'anticipated') {
                    var prevSlide = rangeStart - 1,
                        nextSlide = rangeEnd,
                        $slides = _.$slider.find('.slick-slide');
                    for (var i = 0; i < _.options.slidesToScroll; i++) {
                        if (prevSlide < 0) prevSlide = _.slideCount - 1;
                        loadRange = loadRange.add($slides.eq(prevSlide));
                        loadRange = loadRange.add($slides.eq(nextSlide));
                        prevSlide--;
                        nextSlide++
                    }
                }
                loadImages(loadRange);
                if (_.slideCount <= _.options.slidesToShow) {
                    cloneRange = _.$slider.find('.slick-slide');
                    loadImages(cloneRange)
                } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
                    cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
                    loadImages(cloneRange)
                } else if (_.currentSlide === 0) {
                    cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
                    loadImages(cloneRange)
                }
            };
            Slick.prototype.loadSlider = function() {
                var _ = this;
                _.setPosition();
                _.$slideTrack.css({
                    opacity: 1
                });
                _.$slider.removeClass('slick-loading');
                _.initUI();
                if (_.options.lazyLoad === 'progressive') {
                    _.progressiveLazyLoad()
                }
            };
            Slick.prototype.next = Slick.prototype.slickNext = function() {
                var _ = this;
                _.changeSlide({
                    data: {
                        message: 'next'
                    }
                })
            };
            Slick.prototype.orientationChange = function() {
                var _ = this;
                _.checkResponsive();
                _.setPosition()
            };
            Slick.prototype.pause = Slick.prototype.slickPause = function() {
                var _ = this;
                _.autoPlayClear();
                _.paused = !0
            };
            Slick.prototype.play = Slick.prototype.slickPlay = function() {
                var _ = this;
                _.autoPlay();
                _.options.autoplay = !0;
                _.paused = !1;
                _.focussed = !1;
                _.interrupted = !1
            };
            Slick.prototype.postSlide = function(index) {
                var _ = this;
                if (!_.unslicked) {
                    _.$slider.trigger('afterChange', [_, index]);
                    _.animating = !1;
                    if (_.slideCount > _.options.slidesToShow) {
                        _.setPosition()
                    }
                    _.swipeLeft = null;
                    if (_.options.autoplay) {
                        _.autoPlay()
                    }
                    if (_.options.accessibility === !0) {
                        _.initADA();
                        if (_.options.focusOnChange) {
                            var $currentSlide = $(_.$slides.get(_.currentSlide));
                            $currentSlide.attr('tabindex', 0).focus()
                        }
                    }
                }
            };
            Slick.prototype.prev = Slick.prototype.slickPrev = function() {
                var _ = this;
                _.changeSlide({
                    data: {
                        message: 'previous'
                    }
                })
            };
            Slick.prototype.preventDefault = function(event) {
                event.preventDefault()
            };
            Slick.prototype.progressiveLazyLoad = function(tryCount) {
                tryCount = tryCount || 1;
                var _ = this,
                    $imgsToLoad = $('img[data-lazy]', _.$slider),
                    image, imageSource, imageSrcSet, imageSizes, imageToLoad;
                if ($imgsToLoad.length) {
                    image = $imgsToLoad.first();
                    imageSource = image.attr('data-lazy');
                    imageSrcSet = image.attr('data-srcset');
                    imageSizes = image.attr('data-sizes') || _.$slider.attr('data-sizes');
                    imageToLoad = document.createElement('img');
                    imageToLoad.onload = function() {
                        if (imageSrcSet) {
                            image.attr('srcset', imageSrcSet);
                            if (imageSizes) {
                                image.attr('sizes', imageSizes)
                            }
                        }
                        image.attr('src', imageSource).removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
                        if (_.options.adaptiveHeight === !0) {
                            _.setPosition()
                        }
                        _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                        _.progressiveLazyLoad()
                    };
                    imageToLoad.onerror = function() {
                        if (tryCount < 3) {
                            setTimeout(function() {
                                _.progressiveLazyLoad(tryCount + 1)
                            }, 500)
                        } else {
                            image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');
                            _.$slider.trigger('lazyLoadError', [_, image, imageSource]);
                            _.progressiveLazyLoad()
                        }
                    };
                    imageToLoad.src = imageSource
                } else {
                    _.$slider.trigger('allImagesLoaded', [_])
                }
            };
            Slick.prototype.refresh = function(initializing) {
                var _ = this,
                    currentSlide, lastVisibleIndex;
                lastVisibleIndex = _.slideCount - _.options.slidesToShow;
                if (!_.options.infinite && (_.currentSlide > lastVisibleIndex)) {
                    _.currentSlide = lastVisibleIndex
                }
                if (_.slideCount <= _.options.slidesToShow) {
                    _.currentSlide = 0
                }
                currentSlide = _.currentSlide;
                _.destroy(!0);
                $.extend(_, _.initials, {
                    currentSlide: currentSlide
                });
                _.init();
                if (!initializing) {
                    _.changeSlide({
                        data: {
                            message: 'index',
                            index: currentSlide
                        }
                    }, !1)
                }
            };
            Slick.prototype.registerBreakpoints = function() {
                var _ = this,
                    breakpoint, currentBreakpoint, l, responsiveSettings = _.options.responsive || null;
                if ($.type(responsiveSettings) === 'array' && responsiveSettings.length) {
                    _.respondTo = _.options.respondTo || 'window';
                    for (breakpoint in responsiveSettings) {
                        l = _.breakpoints.length - 1;
                        if (responsiveSettings.hasOwnProperty(breakpoint)) {
                            currentBreakpoint = responsiveSettings[breakpoint].breakpoint;
                            while (l >= 0) {
                                if (_.breakpoints[l] && _.breakpoints[l] === currentBreakpoint) {
                                    _.breakpoints.splice(l, 1)
                                }
                                l--
                            }
                            _.breakpoints.push(currentBreakpoint);
                            _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings
                        }
                    }
                    _.breakpoints.sort(function(a, b) {
                        return (_.options.mobileFirst) ? a - b : b - a
                    })
                }
            };
            Slick.prototype.reinit = function() {
                var _ = this;
                _.$slides = _.$slideTrack.children(_.options.slide).addClass('slick-slide');
                _.slideCount = _.$slides.length;
                if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
                    _.currentSlide = _.currentSlide - _.options.slidesToScroll
                }
                if (_.slideCount <= _.options.slidesToShow) {
                    _.currentSlide = 0
                }
                _.registerBreakpoints();
                _.setProps();
                _.setupInfinite();
                _.buildArrows();
                _.updateArrows();
                _.initArrowEvents();
                _.buildDots();
                _.updateDots();
                _.initDotEvents();
                _.cleanUpSlideEvents();
                _.initSlideEvents();
                _.checkResponsive(!1, !0);
                if (_.options.focusOnSelect === !0) {
                    $(_.$slideTrack).children().on('click.slick', _.selectHandler)
                }
                _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
                _.setPosition();
                _.focusHandler();
                _.paused = !_.options.autoplay;
                _.autoPlay();
                _.$slider.trigger('reInit', [_])
            };
            Slick.prototype.resize = function() {
                var _ = this;
                if ($(window).width() !== _.windowWidth) {
                    clearTimeout(_.windowDelay);
                    _.windowDelay = window.setTimeout(function() {
                        _.windowWidth = $(window).width();
                        _.checkResponsive();
                        if (!_.unslicked) {
                            _.setPosition()
                        }
                    }, 50)
                }
            };
            Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {
                var _ = this;
                if (typeof(index) === 'boolean') {
                    removeBefore = index;
                    index = removeBefore === !0 ? 0 : _.slideCount - 1
                } else {
                    index = removeBefore === !0 ? --index : index
                }
                if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
                    return !1
                }
                _.unload();
                if (removeAll === !0) {
                    _.$slideTrack.children().remove()
                } else {
                    _.$slideTrack.children(this.options.slide).eq(index).remove()
                }
                _.$slides = _.$slideTrack.children(this.options.slide);
                _.$slideTrack.children(this.options.slide).detach();
                _.$slideTrack.append(_.$slides);
                _.$slidesCache = _.$slides;
                _.reinit()
            };
            Slick.prototype.setCSS = function(position) {
                var _ = this,
                    positionProps = {},
                    x, y;
                if (_.options.rtl === !0) {
                    position = -position
                }
                x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
                y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';
                positionProps[_.positionProp] = position;
                if (_.transformsEnabled === !1) {
                    _.$slideTrack.css(positionProps)
                } else {
                    positionProps = {};
                    if (_.cssTransitions === !1) {
                        positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
                        _.$slideTrack.css(positionProps)
                    } else {
                        positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
                        _.$slideTrack.css(positionProps)
                    }
                }
            };
            Slick.prototype.setDimensions = function() {
                var _ = this;
                if (_.options.vertical === !1) {
                    if (_.options.centerMode === !0) {
                        _.$list.css({
                            padding: ('0px ' + _.options.centerPadding)
                        })
                    }
                } else {
                    _.$list.height(_.$slides.first().outerHeight(!0) * _.options.slidesToShow);
                    if (_.options.centerMode === !0) {
                        _.$list.css({
                            padding: (_.options.centerPadding + ' 0px')
                        })
                    }
                }
                _.listWidth = _.$list.width();
                _.listHeight = _.$list.height();
                if (_.options.vertical === !1 && _.options.variableWidth === !1) {
                    _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
                    _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)))
                } else if (_.options.variableWidth === !0) {
                    _.$slideTrack.width(5000 * _.slideCount)
                } else {
                    _.slideWidth = Math.ceil(_.listWidth);
                    _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(!0) * _.$slideTrack.children('.slick-slide').length)))
                }
                var offset = _.$slides.first().outerWidth(!0) - _.$slides.first().width();
                if (_.options.variableWidth === !1) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset)
            };
            Slick.prototype.setFade = function() {
                var _ = this,
                    targetLeft;
                _.$slides.each(function(index, element) {
                    targetLeft = (_.slideWidth * index) * -1;
                    if (_.options.rtl === !0) {
                        $(element).css({
                            position: 'relative',
                            right: targetLeft,
                            top: 0,
                            zIndex: _.options.zIndex - 2,
                            opacity: 0
                        })
                    } else {
                        $(element).css({
                            position: 'relative',
                            left: targetLeft,
                            top: 0,
                            zIndex: _.options.zIndex - 2,
                            opacity: 0
                        })
                    }
                });
                _.$slides.eq(_.currentSlide).css({
                    zIndex: _.options.zIndex - 1,
                    opacity: 1
                })
            };
            Slick.prototype.setHeight = function() {
                var _ = this;
                if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === !0 && _.options.vertical === !1) {
                    var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(!0);
                    _.$list.css('height', targetHeight)
                }
            };
            Slick.prototype.setOption = Slick.prototype.slickSetOption = function() {
                var _ = this,
                    l, item, option, value, refresh = !1,
                    type;
                if ($.type(arguments[0]) === 'object') {
                    option = arguments[0];
                    refresh = arguments[1];
                    type = 'multiple'
                } else if ($.type(arguments[0]) === 'string') {
                    option = arguments[0];
                    value = arguments[1];
                    refresh = arguments[2];
                    if (arguments[0] === 'responsive' && $.type(arguments[1]) === 'array') {
                        type = 'responsive'
                    } else if (typeof arguments[1] !== 'undefined') {
                        type = 'single'
                    }
                }
                if (type === 'single') {
                    _.options[option] = value
                } else if (type === 'multiple') {
                    $.each(option, function(opt, val) {
                        _.options[opt] = val
                    })
                } else if (type === 'responsive') {
                    for (item in value) {
                        if ($.type(_.options.responsive) !== 'array') {
                            _.options.responsive = [value[item]]
                        } else {
                            l = _.options.responsive.length - 1;
                            while (l >= 0) {
                                if (_.options.responsive[l].breakpoint === value[item].breakpoint) {
                                    _.options.responsive.splice(l, 1)
                                }
                                l--
                            }
                            _.options.responsive.push(value[item])
                        }
                    }
                }
                if (refresh) {
                    _.unload();
                    _.reinit()
                }
            };
            Slick.prototype.setPosition = function() {
                var _ = this;
                _.setDimensions();
                _.setHeight();
                if (_.options.fade === !1) {
                    _.setCSS(_.getLeft(_.currentSlide))
                } else {
                    _.setFade()
                }
                _.$slider.trigger('setPosition', [_])
            };
            Slick.prototype.setProps = function() {
                var _ = this,
                    bodyStyle = document.body.style;
                _.positionProp = _.options.vertical === !0 ? 'top' : 'left';
                if (_.positionProp === 'top') {
                    _.$slider.addClass('slick-vertical')
                } else {
                    _.$slider.removeClass('slick-vertical')
                }
                if (bodyStyle.WebkitTransition !== undefined || bodyStyle.MozTransition !== undefined || bodyStyle.msTransition !== undefined) {
                    if (_.options.useCSS === !0) {
                        _.cssTransitions = !0
                    }
                }
                if (_.options.fade) {
                    if (typeof _.options.zIndex === 'number') {
                        if (_.options.zIndex < 3) {
                            _.options.zIndex = 3
                        }
                    } else {
                        _.options.zIndex = _.defaults.zIndex
                    }
                }
                if (bodyStyle.OTransform !== undefined) {
                    _.animType = 'OTransform';
                    _.transformType = '-o-transform';
                    _.transitionType = 'OTransition';
                    if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = !1
                }
                if (bodyStyle.MozTransform !== undefined) {
                    _.animType = 'MozTransform';
                    _.transformType = '-moz-transform';
                    _.transitionType = 'MozTransition';
                    if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = !1
                }
                if (bodyStyle.webkitTransform !== undefined) {
                    _.animType = 'webkitTransform';
                    _.transformType = '-webkit-transform';
                    _.transitionType = 'webkitTransition';
                    if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = !1
                }
                if (bodyStyle.msTransform !== undefined) {
                    _.animType = 'msTransform';
                    _.transformType = '-ms-transform';
                    _.transitionType = 'msTransition';
                    if (bodyStyle.msTransform === undefined) _.animType = !1
                }
                if (bodyStyle.transform !== undefined && _.animType !== !1) {
                    _.animType = 'transform';
                    _.transformType = 'transform';
                    _.transitionType = 'transition'
                }
                _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== !1)
            };
            Slick.prototype.setSlideClasses = function(index) {
                var _ = this,
                    centerOffset, allSlides, indexOffset, remainder;
                allSlides = _.$slider.find('.slick-slide').removeClass('slick-active slick-center slick-current').attr('aria-hidden', 'true');
                _.$slides.eq(index).addClass('slick-current');
                if (_.options.centerMode === !0) {
                    var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;
                    centerOffset = Math.floor(_.options.slidesToShow / 2);
                    if (_.options.infinite === !0) {
                        if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {
                            _.$slides.slice(index - centerOffset + evenCoef, index + centerOffset + 1).addClass('slick-active').attr('aria-hidden', 'false')
                        } else {
                            indexOffset = _.options.slidesToShow + index;
                            allSlides.slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2).addClass('slick-active').attr('aria-hidden', 'false')
                        }
                        if (index === 0) {
                            allSlides.eq(allSlides.length - 1 - _.options.slidesToShow).addClass('slick-center')
                        } else if (index === _.slideCount - 1) {
                            allSlides.eq(_.options.slidesToShow).addClass('slick-center')
                        }
                    }
                    _.$slides.eq(index).addClass('slick-center')
                } else {
                    if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {
                        _.$slides.slice(index, index + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false')
                    } else if (allSlides.length <= _.options.slidesToShow) {
                        allSlides.addClass('slick-active').attr('aria-hidden', 'false')
                    } else {
                        remainder = _.slideCount % _.options.slidesToShow;
                        indexOffset = _.options.infinite === !0 ? _.options.slidesToShow + index : index;
                        if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {
                            allSlides.slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder).addClass('slick-active').attr('aria-hidden', 'false')
                        } else {
                            allSlides.slice(indexOffset, indexOffset + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false')
                        }
                    }
                }
                if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
                    _.lazyLoad()
                }
            };
            Slick.prototype.setupInfinite = function() {
                var _ = this,
                    i, slideIndex, infiniteCount;
                if (_.options.fade === !0) {
                    _.options.centerMode = !1
                }
                if (_.options.infinite === !0 && _.options.fade === !1) {
                    slideIndex = null;
                    if (_.slideCount > _.options.slidesToShow) {
                        if (_.options.centerMode === !0) {
                            infiniteCount = _.options.slidesToShow + 1
                        } else {
                            infiniteCount = _.options.slidesToShow
                        }
                        for (i = _.slideCount; i > (_.slideCount - infiniteCount); i -= 1) {
                            slideIndex = i - 1;
                            $(_.$slides[slideIndex]).clone(!0).attr('id', '').attr('data-slick-index', slideIndex - _.slideCount).prependTo(_.$slideTrack).addClass('slick-cloned')
                        }
                        for (i = 0; i < infiniteCount + _.slideCount; i += 1) {
                            slideIndex = i;
                            $(_.$slides[slideIndex]).clone(!0).attr('id', '').attr('data-slick-index', slideIndex + _.slideCount).appendTo(_.$slideTrack).addClass('slick-cloned')
                        }
                        _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
                            $(this).attr('id', '')
                        })
                    }
                }
            };
            Slick.prototype.interrupt = function(toggle) {
                var _ = this;
                if (!toggle) {
                    _.autoPlay()
                }
                _.interrupted = toggle
            };
            Slick.prototype.selectHandler = function(event) {
                var _ = this;
                var targetElement = $(event.target).is('.slick-slide') ? $(event.target) : $(event.target).parents('.slick-slide');
                var index = parseInt(targetElement.attr('data-slick-index'));
                if (!index) index = 0;
                if (_.slideCount <= _.options.slidesToShow) {
                    _.slideHandler(index, !1, !0);
                    return
                }
                _.slideHandler(index)
            };
            Slick.prototype.slideHandler = function(index, sync, dontAnimate) {
                var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,
                    _ = this,
                    navTarget;
                sync = sync || !1;
                if (_.animating === !0 && _.options.waitForAnimate === !0) {
                    return
                }
                if (_.options.fade === !0 && _.currentSlide === index) {
                    return
                }
                if (sync === !1) {
                    _.asNavFor(index)
                }
                targetSlide = index;
                targetLeft = _.getLeft(targetSlide);
                slideLeft = _.getLeft(_.currentSlide);
                _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;
                if (_.options.infinite === !1 && _.options.centerMode === !1 && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
                    if (_.options.fade === !1) {
                        targetSlide = _.currentSlide;
                        if (dontAnimate !== !0 && _.slideCount > _.options.slidesToShow) {
                            _.animateSlide(slideLeft, function() {
                                _.postSlide(targetSlide)
                            })
                        } else {
                            _.postSlide(targetSlide)
                        }
                    }
                    return
                } else if (_.options.infinite === !1 && _.options.centerMode === !0 && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
                    if (_.options.fade === !1) {
                        targetSlide = _.currentSlide;
                        if (dontAnimate !== !0 && _.slideCount > _.options.slidesToShow) {
                            _.animateSlide(slideLeft, function() {
                                _.postSlide(targetSlide)
                            })
                        } else {
                            _.postSlide(targetSlide)
                        }
                    }
                    return
                }
                if (_.options.autoplay) {
                    clearInterval(_.autoPlayTimer)
                }
                if (targetSlide < 0) {
                    if (_.slideCount % _.options.slidesToScroll !== 0) {
                        animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll)
                    } else {
                        animSlide = _.slideCount + targetSlide
                    }
                } else if (targetSlide >= _.slideCount) {
                    if (_.slideCount % _.options.slidesToScroll !== 0) {
                        animSlide = 0
                    } else {
                        animSlide = targetSlide - _.slideCount
                    }
                } else {
                    animSlide = targetSlide
                }
                _.animating = !0;
                _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);
                oldSlide = _.currentSlide;
                _.currentSlide = animSlide;
                _.setSlideClasses(_.currentSlide);
                if (_.options.asNavFor) {
                    navTarget = _.getNavTarget();
                    navTarget = navTarget.slick('getSlick');
                    if (navTarget.slideCount <= navTarget.options.slidesToShow) {
                        navTarget.setSlideClasses(_.currentSlide)
                    }
                }
                _.updateDots();
                _.updateArrows();
                if (_.options.fade === !0) {
                    if (dontAnimate !== !0) {
                        _.fadeSlideOut(oldSlide);
                        _.fadeSlide(animSlide, function() {
                            _.postSlide(animSlide)
                        })
                    } else {
                        _.postSlide(animSlide)
                    }
                    _.animateHeight();
                    return
                }
                if (dontAnimate !== !0 && _.slideCount > _.options.slidesToShow) {
                    _.animateSlide(targetLeft, function() {
                        _.postSlide(animSlide)
                    })
                } else {
                    _.postSlide(animSlide)
                }
            };
            Slick.prototype.startLoad = function() {
                var _ = this;
                if (_.options.arrows === !0 && _.slideCount > _.options.slidesToShow) {
                    _.$prevArrow.hide();
                    _.$nextArrow.hide()
                }
                if (_.options.dots === !0 && _.slideCount > _.options.slidesToShow) {
                    _.$dots.hide()
                }
                _.$slider.addClass('slick-loading')
            };
            Slick.prototype.swipeDirection = function() {
                var xDist, yDist, r, swipeAngle, _ = this;
                xDist = _.touchObject.startX - _.touchObject.curX;
                yDist = _.touchObject.startY - _.touchObject.curY;
                r = Math.atan2(yDist, xDist);
                swipeAngle = Math.round(r * 180 / Math.PI);
                if (swipeAngle < 0) {
                    swipeAngle = 360 - Math.abs(swipeAngle)
                }
                if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
                    return (_.options.rtl === !1 ? 'left' : 'right')
                }
                if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
                    return (_.options.rtl === !1 ? 'left' : 'right')
                }
                if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
                    return (_.options.rtl === !1 ? 'right' : 'left')
                }
                if (_.options.verticalSwiping === !0) {
                    if ((swipeAngle >= 35) && (swipeAngle <= 135)) {
                        return 'down'
                    } else {
                        return 'up'
                    }
                }
                return 'vertical'
            };
            Slick.prototype.swipeEnd = function(event) {
                var _ = this,
                    slideCount, direction;
                _.dragging = !1;
                _.swiping = !1;
                if (_.scrolling) {
                    _.scrolling = !1;
                    return !1
                }
                _.interrupted = !1;
                _.shouldClick = (_.touchObject.swipeLength > 10) ? !1 : !0;
                if (_.touchObject.curX === undefined) {
                    return !1
                }
                if (_.touchObject.edgeHit === !0) {
                    _.$slider.trigger('edge', [_, _.swipeDirection()])
                }
                if (_.touchObject.swipeLength >= _.touchObject.minSwipe) {
                    direction = _.swipeDirection();
                    switch (direction) {
                        case 'left':
                        case 'down':
                            slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide + _.getSlideCount()) : _.currentSlide + _.getSlideCount();
                            _.currentDirection = 0;
                            break;
                        case 'right':
                        case 'up':
                            slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide - _.getSlideCount()) : _.currentSlide - _.getSlideCount();
                            _.currentDirection = 1;
                            break;
                        default:
                    }
                    if (direction != 'vertical') {
                        _.slideHandler(slideCount);
                        _.touchObject = {};
                        _.$slider.trigger('swipe', [_, direction])
                    }
                } else {
                    if (_.touchObject.startX !== _.touchObject.curX) {
                        _.slideHandler(_.currentSlide);
                        _.touchObject = {}
                    }
                }
            };
            Slick.prototype.swipeHandler = function(event) {
                var _ = this;
                if ((_.options.swipe === !1) || ('ontouchend' in document && _.options.swipe === !1)) {
                    return
                } else if (_.options.draggable === !1 && event.type.indexOf('mouse') !== -1) {
                    return
                }
                _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ? event.originalEvent.touches.length : 1;
                _.touchObject.minSwipe = _.listWidth / _.options.touchThreshold;
                if (_.options.verticalSwiping === !0) {
                    _.touchObject.minSwipe = _.listHeight / _.options.touchThreshold
                }
                switch (event.data.action) {
                    case 'start':
                        _.swipeStart(event);
                        break;
                    case 'move':
                        _.swipeMove(event);
                        break;
                    case 'end':
                        _.swipeEnd(event);
                        break
                }
            };
            Slick.prototype.swipeMove = function(event) {
                var _ = this,
                    edgeWasHit = !1,
                    curLeft, swipeDirection, swipeLength, positionOffset, touches, verticalSwipeLength;
                touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;
                if (!_.dragging || _.scrolling || touches && touches.length !== 1) {
                    return !1
                }
                curLeft = _.getLeft(_.currentSlide);
                _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
                _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;
                _.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));
                verticalSwipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));
                if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
                    _.scrolling = !0;
                    return !1
                }
                if (_.options.verticalSwiping === !0) {
                    _.touchObject.swipeLength = verticalSwipeLength
                }
                swipeDirection = _.swipeDirection();
                if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
                    _.swiping = !0;
                    event.preventDefault()
                }
                positionOffset = (_.options.rtl === !1 ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
                if (_.options.verticalSwiping === !0) {
                    positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1
                }
                swipeLength = _.touchObject.swipeLength;
                _.touchObject.edgeHit = !1;
                if (_.options.infinite === !1) {
                    if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {
                        swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                        _.touchObject.edgeHit = !0
                    }
                }
                if (_.options.vertical === !1) {
                    _.swipeLeft = curLeft + swipeLength * positionOffset
                } else {
                    _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset
                }
                if (_.options.verticalSwiping === !0) {
                    _.swipeLeft = curLeft + swipeLength * positionOffset
                }
                if (_.options.fade === !0 || _.options.touchMove === !1) {
                    return !1
                }
                if (_.animating === !0) {
                    _.swipeLeft = null;
                    return !1
                }
                _.setCSS(_.swipeLeft)
            };
            Slick.prototype.swipeStart = function(event) {
                var _ = this,
                    touches;
                _.interrupted = !0;
                if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
                    _.touchObject = {};
                    return !1
                }
                if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
                    touches = event.originalEvent.touches[0]
                }
                _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
                _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;
                _.dragging = !0
            };
            Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {
                var _ = this;
                if (_.$slidesCache !== null) {
                    _.unload();
                    _.$slideTrack.children(this.options.slide).detach();
                    _.$slidesCache.appendTo(_.$slideTrack);
                    _.reinit()
                }
            };
            Slick.prototype.unload = function() {
                var _ = this;
                $('.slick-cloned', _.$slider).remove();
                if (_.$dots) {
                    _.$dots.remove()
                }
                if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
                    _.$prevArrow.remove()
                }
                if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
                    _.$nextArrow.remove()
                }
                _.$slides.removeClass('slick-slide slick-active slick-visible slick-current').attr('aria-hidden', 'true').css('width', '')
            };
            Slick.prototype.unslick = function(fromBreakpoint) {
                var _ = this;
                _.$slider.trigger('unslick', [_, fromBreakpoint]);
                _.destroy()
            };
            Slick.prototype.updateArrows = function() {
                var _ = this,
                    centerOffset;
                centerOffset = Math.floor(_.options.slidesToShow / 2);
                if (_.options.arrows === !0 && _.slideCount > _.options.slidesToShow && !_.options.infinite) {
                    _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
                    _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
                    if (_.currentSlide === 0) {
                        _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                        _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false')
                    } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === !1) {
                        _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                        _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false')
                    } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === !0) {
                        _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                        _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false')
                    }
                }
            };
            Slick.prototype.updateDots = function() {
                var _ = this;
                if (_.$dots !== null) {
                    _.$dots.find('li').removeClass('slick-active').end();
                    _.$dots.find('li').eq(Math.floor(_.currentSlide / _.options.slidesToScroll)).addClass('slick-active')
                }
            };
            Slick.prototype.visibility = function() {
                var _ = this;
                if (_.options.autoplay) {
                    if (document[_.hidden]) {
                        _.interrupted = !0
                    } else {
                        _.interrupted = !1
                    }
                }
            };
            $.fn.slick = function() {
                var _ = this,
                    opt = arguments[0],
                    args = Array.prototype.slice.call(arguments, 1),
                    l = _.length,
                    i, ret;
                for (i = 0; i < l; i++) {
                    if (typeof opt == 'object' || typeof opt == 'undefined')
                        _[i].slick = new Slick(_[i], opt);
                    else ret = _[i].slick[opt].apply(_[i].slick, args);
                    if (typeof ret != 'undefined') return ret
                }
                return _
            }
        }))
    }),
    "../node_modules/sticky-kit/dist/sticky-kit.js": (function(module, exports, __webpack_require__) {
        (function(__webpack_provided_window_dot_jQuery) {}.call(this, __webpack_require__("../node_modules/jquery/dist/jquery.js-exposed")))
    }),
    "../node_modules/webpack/buildin/global.js": (function(module, exports) {
        var g;
        g = (function() {
            return this
        })();
        try {
            g = g || new Function("return this")()
        } catch (e) {
            if (typeof window === "object") g = window
        }
        module.exports = g
    }),
    "../src/assets/js/base/index.js": (function(module, exports, __webpack_require__) {
        "use strict";
        (function($, jQuery) {
            $('.forgotten-pass, .loginfrom-link').on('click', function(e) {
                e.preventDefault();
                var $this = $(this);
                var targetString = $this.attr('href').replace('#', '');
                $('.' + targetString).show();
                $this.closest('form').parent().hide()
            });
            $('.addresses__actions .btn--new, .form--address-new .btn--cancel').on('click', function(e) {
                e.preventDefault();
                var $this = $(this);
                var targetString = $this.attr('href').replace('#', '');
                $('.' + targetString).toggle()
            });
            $('#sortBy').on('change', function() {
                Shopify.queryParams = {};
                var $this = $(this);
                var thisVal = $this.val();
                if (location.search) {
                    var getArgumentsArray = location.search.substr(1).split('&');
                    getArgumentsArray.map(function(ele) {
                        var eleArray = ele.split('=');
                        Shopify.queryParams[decodeURIComponent(eleArray[0])] = decodeURIComponent(eleArray[1])
                    })
                }
                Shopify.queryParams.sort_by = thisVal;
                location.search = jQuery.param(Shopify.queryParams)
            });
            $('.product-single__variants').on('change', function() {
                var $this = $(this);
                var thisPrice = $this.find('option:selected').data('price');
                $('.product__price').html(thisPrice)
            });
            $('select[name="address[country]"]').each(function() {
                var $this = $(this);
                var thisID = $this.attr('id');
                var province = $this.closest('form').find('select[name="address[province]"]');
                var provinceID = province.attr('id');
                var provinceHolderID = province.closest('.form__row').attr('id');
                new Shopify.CountryProvinceSelector(thisID, provinceID, {
                    hideElement: provinceHolderID
                })
            })
        }.call(this, __webpack_require__("../node_modules/jquery/dist/jquery.js-exposed"), __webpack_require__("../node_modules/jquery/dist/jquery.js-exposed")))
    }),
    "../src/assets/js/cart.js": (function(module, exports, __webpack_require__) {
        "use strict";
        (function($) {
            var $doc = $(document);
            var $wrapper = $('.wrapper');
            var $cartTooltipHolder = $('.nav-utilities .link-cart').closest('li');          	
          	$cartTooltipHolder.on('touchend mouseenter mouseleave', function(e) {	
                if (e.type === 'mouseenter' || e.type === 'touchend') {	
                    $wrapper.addClass('tooltip-opened')  
                if (typeof Harper !== 'undefined') {
                    if (!document.querySelector('.harper-minicart-cta #hcxminicart-checkoutcta') && document.querySelector('.harper-minicart-cta')) {
                        new Harper(harperMiniCartConfig);
                    }
                }
                    $('.close-cart').click( function() {	
               			$wrapper.removeClass('tooltip-opened');      		
           			 });	
                } else {	
                    $wrapper.removeClass('tooltip-opened')	
                }	
            });	
            $doc.on("click", '.ajax_close', function(e) {	
                e.preventDefault();	
                $wrapper.removeClass('tooltip-opened');	
            });	
         	$('.close-cart').click( function() {	
                $wrapper.removeClass('tooltip-opened');              		
            });	
            $('.wrapper__overlay').on('click', function() {	
                $wrapper.removeClass('tooltip-opened');              		
            });
            $doc.on('click', '.cart-item .cart-item__remove', function(e) {
                e.preventDefault();
                var $this = $(this);
                $.ajax({
                    url: $this.attr('href')
                }).done(function(data) {
                    var $data = $(data);
                    $('.nav-utilities .link-cart').closest('li').html($data.find('.nav-utilities .link-cart').closest('li').html())
                    if (typeof Harper !== 'undefined') {
                        if (!document.querySelector('.harper-minicart-cta #hcxminicart-checkoutcta') && document.querySelector('.harper-minicart-cta')) {
                            new Harper(harperMiniCartConfig);
                        }
                    }
                    if (typeof affirm !== 'undefined') {
                        affirm.ui.refresh();
                    }
                    if (document.getElementsByTagName("klarna-placement")[0]) {
                        fetch('/cart.js')
                        .then(response => response.json())
                        .then(cart => {
                            let cartTotalPrice = cart.total_price;
                            document.getElementsByTagName("klarna-placement")[0].setAttribute("data-purchase-amount", cartTotalPrice);
                            window.KlarnaOnsiteService = window.KlarnaOnsiteService || []
                            window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' })
                        })
                        .catch(error => console.error('Error:', error));
                    }
                }).fail(function(error) {
                    console.log('error')
                })
                if (typeof Harper !== 'undefined') {
                    if (!document.querySelector('.harper-minicart-cta #hcxminicart-checkoutcta') && document.querySelector('.harper-minicart-cta')) {
                        new Harper(harperMiniCartConfig);
                    } 
                }
            })
        }.call(this, __webpack_require__("../node_modules/jquery/dist/jquery.js-exposed")))
    }),
    "../src/assets/js/click-events.js": (function(module, exports, __webpack_require__) {
        "use strict";
        (function($) {
            var $doc = $(document);
            var $wrapper = $('.wrapper');
            var $nav = $('.nav');
            var $navTrigger = $('.nav-trigger');
            var $navOverlay = $('.nav__overlay');
            var $navDropdown = $('.nav .nav__wrapper .nav__dropdown');
            var $searchSm = $('.search.search--sm');
            var $lookbookPopup = $('.popup-lookbook');
            $('.tabs .tabs__nav a').on('click', function(event) {
                event.preventDefault();
                var $this = $(this);
                var link = $this.attr('href');
                var $linkParent = $this.parent();
                var $tab = $(link);
                var activeClass = 'current';
                $tab.add($linkParent).addClass(activeClass).siblings().removeClass(activeClass)
            });
            $('.accordion .accordion__head h2').click(function(event) {
                event.preventDefault();
                var $win = $(window);
                if ($win.width() < 768) {
                    var $this = $(this);
                    var $thisParent = $this.parent().closest('.accordion__section');
                    var activeClass = 'current';
                    var $this = $(this);
                    if ($thisParent.hasClass(activeClass)) {
                        $thisParent.removeClass(activeClass).find('.accordion__body').removeClass(activeClass).slideUp(350)
                    } else {
                        $thisParent.toggleClass(activeClass).find('.accordion__body').toggleClass(activeClass).slideDown(350);
                        $thisParent.siblings().removeClass(activeClass).find('.accordion__body').removeClass(activeClass).slideUp(350)
                    }
                }
            });
            $navTrigger.on('click', function(event) {
                event.preventDefault();
                $(this).toggleClass('nav-trigger--active');
                $nav.toggleClass('is-active');
                $navDropdown.removeClass('is-active');
                $navOverlay.toggleClass('is-active');
                $searchSm.toggleClass('is-active');
            });
            $('.nav').children('ul').children('li').each(function() {
                $(this).find('.link-back:first').addClass('firstAnchorClass')
            })
            $('.link-back').on('click', function(event) {
                event.preventDefault();
                var $this = $(this);
                var findClassNames = $(this).attr('class');
                if (findClassNames.indexOf('firstAnchorClass') == -1) $this.closest('.nav__dropdown').removeClass('is-active').removeClass('get1');
                else $('.nav__dropdown').removeClass('is-active').removeClass('get1')
            });
            $('.nav__overlay').on('click', function(event) {
                var $this = $(this);
                $(this).removeClass('is-active');
                $navDropdown.removeClass('is-active');
                $navDropdown.removeClass('get1');
                $nav.removeClass('is-active');
                $navTrigger.removeClass('nav-trigger--active');
                $searchSm.removeClass('is-active')
            });
            $('.lookbook-product__overlay, .lookbook-product__image').on('click', function(e) {
                e.preventDefault();
                var $this = $(this);
                var elementIndex = $this.closest('.lookbook-product').data('index');
                var slideIndex = $('.slider-lookbook .slider__slide[data-index="' + elementIndex + '"]').closest('.slick-slide').data('slick-index');
                $('.slider-lookbook .slider__slides').slick('slickGoTo', slideIndex);
                $lookbookPopup.addClass('visible');
                $('body').addClass('popup-opened')
            });
            $('.popup-lookbook .popup__close').on('click', function(e) {
                e.preventDefault();
                $lookbookPopup.removeClass('visible');
                $('body').removeClass('popup-opened')
            });
            $('.lookbook-product__actions a').on('click', function(e) {
                e.stopPropagation()
            });
            const width  = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            if (width > 767) {
              $('.filter-group h4').eq(1).addClass('clicked');
            }
            $('.has_selected').parent().prev().addClass('clicked');
            $('.collection-filters .filter-group h4').on('click', function() {
                var $this = $(this);
                $this.toggleClass('clicked').next('.scroll-content').slideToggle()
            });
            $('.link-collapse').on('click', function(e) {
                e.preventDefault();
                $wrapper.removeClass('filter-opened');
                $wrapper.removeClass('sorting-opened')
            })
        }.call(this, __webpack_require__("../node_modules/jquery/dist/jquery.js-exposed")))
    }),
    "../src/assets/js/is-mobile.js": (function(module, exports, __webpack_require__) {
        "use strict";
        var isMobile = !1;
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) isMobile = !0;
        module.exports = isMobile
    }),
    "../src/assets/js/main.js": (function(module, exports, __webpack_require__) {
        "use strict";
        (function($) {
            __webpack_require__("../node_modules/sticky-kit/dist/sticky-kit.js");
            __webpack_require__("../src/assets/js/base/index.js");
            __webpack_require__("../src/assets/js/sliders.js");
            __webpack_require__("../src/assets/js/product.js");
            __webpack_require__("../src/assets/js/cart.js");
            __webpack_require__("../src/assets/js/click-events.js");
            var _isMobile = __webpack_require__("../src/assets/js/is-mobile.js");
            var _isMobile2 = _interopRequireDefault(_isMobile);

            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                }
            }
            var $win = $(window);
            var $doc = $(document);
            var $body = $('body');
            var $nav = $('.nav');
            var $navDropdown = $('.nav .nav__dropdown');
            var $navOverlay = $('.nav__overlay');
            var $navTrigger = $('.nav-trigger');
            var $searchSm = $('.search.search--sm');
            var mobileLayoutLoaded = false;

            function closeAccordion() {
                $('.accordion .accordion__section').not('.current').find('.accordion__body').not('.current').slideUp(300)
            }
            if (_isMobile2.default) {
                $body.addClass('is_touch')
            } else {
                $body.addClass('no_touch')
            }
            if ($nav.find('li > .nav__dropdown').length) {
                $('.nav__dropdown').closest('li').addClass('has-dd')
            }
          
            $win.resize(function(){
                if ($win.width() <= 1023 && !mobileLayoutLoaded) {
                   $(".nav .nav-secondary").remove();
                   loadnav();	
                }else if ($win.width() > 1023){
                  $(".nav .nav-secondary").remove();
                }
              });
            loadnav();
            function loadnav(){
              if ($win.width() <= 1023) {
                  mobileLayoutLoaded = true;
                  closeAccordion();
                  $('.nav-secondary').clone().appendTo('.nav').removeClass('hidden-xs').removeClass("desktop-up").removeClass("hidden-sm").addClass("mobile-up");
                        $('<div class="weglot-mobile-container"></div>').appendTo('.nav');

                  $('<li/>', {
                      append: $('.header .link-profile, .header .link-wishlist').clone().appendTo('<li></li>').removeClass('hidden-xs').removeClass("hidden-sm"),
                      appendTo: '.nav .nav-secondary ul'
                  });
                  $('.nav .has-dd > a').on('click', function(event) {
                      event.preventDefault();
                      var $this = $(this);
                      var getfinalClass = ($(this).siblings().attr('class'))
                      if (getfinalClass.indexOf('nav__wrapper') != -1) {
                          $this.next('.nav__wrapper').children('.nav__dropdown').addClass('is-active');
                          $this.next('.nav__wrapper').children('.nav__dropdown').addClass('get1')
                      } else {
                          $this.next('.nav__dropdown').addClass('is-active');
                          $this.next('.nav__dropdown').addClass('get1')
                      }
                      $('.get1 div:first').addClass('is-active');
                      if (!$navOverlay.hasClass('nav--first-level')) {
                          $navOverlay.addClass('nav--first-level')
                      } else {
                          $navOverlay.addClass('nav--second-level')
                      }
                  });
              }
              
              return true;
            }
             var headerbarContent = $('.header__bar ul li').length;
             if(headerbarContent!=0){
              $('.header__bar').clone().appendTo('.section-intro:not(.section-intro--alt)').removeClass('hidden-xs')
             }
            
            if ($('.tabs .tab .btn').length) {
                $('.tabs .tab').each(function() {
                    var $this = $(this);
                    var $thisBtn = $this.find('.btn');
                    var $btnCloned = $thisBtn.clone();
                    var $tabContent = $this.find('.tab__content');
                    $('<div/>', {
                        class: 'tab__actions visible-xs-block',
                        append: $btnCloned.removeClass('hidden-xs'),
                        appendTo: $tabContent
                    })
                })
            }
            if ($body.hasClass('is_touch')) {
                $('.tabs .tabs__nav a').on('click', function() {
                    var $this = $(this);
                    var $thisUl = $this.closest('.tabs__nav ul');
                    var $li = $this.closest('li');
                    var liWidth = $li.width();
                    var liPosition = $li.offset().left;
                    var $navWidth = $thisUl.width();
                    var currentScroll = $thisUl.scrollLeft();
                    var offset = 50;
                    if (liPosition + liWidth > $navWidth || liPosition < 0) {
                        $thisUl.animate({
                            scrollLeft: currentScroll + liPosition - offset
                        }, 500)
                    }
                })
            }
        }.call(this, __webpack_require__("../node_modules/jquery/dist/jquery.js-exposed")))
    }),
    "../src/assets/js/product.js": (function(module, exports, __webpack_require__) {
        "use strict";
        (function($) {
            var $doc = $(document);
            var $win = $(window);
          	var $selectNumber = $('.product-select').data('id'); 
          	var $productSelect = $('.product-select[data-id="' + $selectNumber +'"]');
            $doc.on('click', '.product-single__quantity .qty', function(e) {
                e.preventDefault();
                var $this = $(this);
                var $quantityField = $('.product-single__quantity .qty-value');
                var quantityValue = Number($quantityField.val());
                if ($this.hasClass('qty--minus')) {
                    if (quantityValue > 1) {
                        quantityValue -= 1
                    }
                } else {
                    quantityValue += 1
                }
                $quantityField.val(quantityValue)
            });
            $('.product-single__accordions .accordion__head a').on('click', function(e) {
                e.preventDefault();
                var $this = $(this);
                $this.closest('.accordion__section').toggleClass('active').find('.accordion__body').slideToggle().closest('.accordion__section').siblings().removeClass('active').find('.accordion__body').slideUp();
                // Check if any accordian sections have an active class
                if ($('.accordion__section.active').length > 0 && window.innerWidth > 768) {
                    // If they do, add the padding bottom
                    $('.section--product .section__inner').css('padding-bottom', '250px');
                } else {
                    $('.section--product .section__inner').css('padding-bottom','0px');
                }
                setTimeout(function() {
                    // Check if any accordian sections have an active class
                if ($('.accordion__section.active').length > 0 && window.innerWidth > 768) {
                    // If they do, add the padding bottom
                    $('.section--product .section__inner').css('padding-bottom', $('.accordion__section.active').height() + 'px');
                } else {
                    $('.section--product .section__inner').css('padding-bottom','0px');
                }
                    $win.trigger('scroll')
                }, 500)
            });
            $doc.on('click', '.add-to-bag-modal-open', function(e) {
                var $this = $(this);
                $this.siblings().find('.product-single__variant input[type="radio"]').trigger('change')
            })
            $doc.on('change','.product-single__variant input[type="radio"]', function() {
                var $this = $(this);
              	$selectNumber = $this.closest('.product-single__variants').siblings('.product-select').data('id');
                var $selectedVariants = $this.closest('.product-single__variants').find('input:checked');
                var selector = '';
                $productSelect = $('.product-select[data-id="' + $selectNumber +'"]');
                $selectedVariants.each(function() {
                    var $input = $(this);
                    var option = $input.closest('.product-single__variant').data('option');
                    selector += '[data-' + option + '="' + $input.val() + '"]'
                });
                $productSelect.find('option' + selector).prop('selected', !0).trigger('change')
            });

            $('.add-to-bag-modal-open').on('click', function() {
                $(this).siblings('.add-to-bag-modal').addClass('modal-open');
                $(this).closest('.product__info').find('.dropdownbox-selected-variant').text('Please Select')
                $(this).siblings('.add-to-bag-modal').find('.notify-me-a').hide()
                $(this).siblings('.add-to-bag-modal').find('.collection_add')
                $(this).siblings('.add-to-bag-modal').find('.collection_add').val('Add To Bag')
                $(this).siblings('.add-to-bag-modal').find('.collection_add').show()
              });
              $('.add-to-bag-modal-close').on('click', function() {
                $(this).closest('.add-to-bag-modal').removeClass('modal-open');
                $(this).siblings('form').find('.main-list-variants').removeClass('showMenu');
                $('.main-list-variants').removeClass('showMenu');
              });	

            $('.product-single__variant .wrapper-select .size-option').on('click', function(event){
                var sizeOption = $('.size-option');
                sizeOption.removeClass('active')
                event.target.classList.add('active')
                // Get the data value and the label of the selected option
                var value = $(event.currentTarget).data('value');
                var rawValue = $(event.currentTarget).data('raw-value');
                var optionName = $(event.currentTarget).text();
                var notifyIdx = optionName.indexOf('NOTIFY',0)
                var markUp = `
                    <div style="display: flex;">
                        <div>${notifyIdx != -1 ? optionName.substr(0,notifyIdx) : optionName }</div>
                        <div class="selected-size-notify-text">${optionName.substr(notifyIdx)}</div>
                    </div>
                `;
                
                // Set the hidden input
                $('.wrapper-select input').val(value);
                var hiddenInput = document.querySelector(".wrapper-select input");
                hiddenInput.dataset.size = value;
                hiddenInput.dataset.rawSize = rawValue;
                
                // Set the label of the dropdown
                $('.wrapper-select .selected-size')[0].innerHTML = markUp; 
                
                // Remove the active class
                $('.size-options, .wrapper-select').removeClass('active');
                var $this = $('.product-single__variant .wrapper-select input');
                var $selectedVariants = $this.closest('.product-single__variants').find('input:checked');
                var selector = '';
                $selectedVariants.each(function() {
                    var $input = $(this);
                    var option = $input.closest('.product-single__variant').data('option');
                    selector += '[data-' + option + '="' + $input.val() + '"]'
                });

                selector += '[data-size' + '="' + $this.val() + '"]';
                $productSelect.find('option' + selector).prop('selected', !0).trigger('change');
            });

            $('.product-single__variant .wrapper-select .size-option').on('keypress', function  (event) {
                if (event.which == 13) {
                    var sizeOption = $('.size-option');
                    sizeOption.removeClass('active')
                    event.target.classList.add('active')
                    // Get the data value and the label of the selected option
                    var value = $(event.target).data('value');
                    var optionName = $(event.target).text();
                    var notifyIdx = optionName.indexOf('NOTIFY',0)
                    var markUp = `
                        <div style="display: flex;">
                            <div>${notifyIdx != -1 ? optionName.substr(0,notifyIdx) : optionName }</div>
                            <div class="selected-size-notify-text">${optionName.substr(notifyIdx)}</div>
                        </div>
                    `
                    
                    // Set the hidden input
                    $('.wrapper-select input').val(value);
                    $('.wrapper-select input').data("size", value);
                    
                    // Set the label of the dropdown
                    $('.wrapper-select .selected-size')[0].innerHTML = markUp; 
                    
                    // Remove the active class
                    $('.size-options, .wrapper-select').removeClass('active');
                    var $this = $('.product-single__variant .wrapper-select input');
                    var $selectedVariants = $this.closest('.product-single__variants').find('input:checked');
                    var selector = '';
                    $selectedVariants.each(function() {
                        var $input = $(this);
                        var option = $input.closest('.product-single__variant').data('option');
                        selector += '[data-' + option + '="' + $input.val() + '"]'
                    });
    
                    selector += '[data-size' + '="' + $this.val() + '"]';
                    $productSelect.find('option' + selector).prop('selected', !0).trigger('change');
                }
            });

            $doc.on('change', $productSelect, function() {
                var $selectedOption = $productSelect.find('option:selected');
                const $dropdownboxSelectedVariant = $productSelect.closest('form').find('.dropdownbox-selected-variant');
                let dropdownOptionSelected = false
                if ($dropdownboxSelectedVariant.length && $dropdownboxSelectedVariant[0].getAttribute('data-number-of-options') == 1) {
                    var dataSize = $selectedOption[0].getAttribute('data-size');
                    var dataPrice = $selectedOption[0].getAttribute('data-price');
                    if (dataSize) {
                        dataSize = dataSize
                            .split('-')
                            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                            .join(' '); // <-- space instead of dash
                        $dropdownboxSelectedVariant.text(dataPrice ? dataSize + ' - ' + dataPrice : dataSize);
                    }
                }
                if ($dropdownboxSelectedVariant.length && $dropdownboxSelectedVariant[0]) {
                    if ($dropdownboxSelectedVariant[0].innerText == 'Please Select') {
                        dropdownOptionSelected = false;
                    } else {
                        dropdownOptionSelected = true;
                    }
                }
                var $addToCartButton = $('.product-single__actions input[type="submit"]');
                var $priceSelector = $('.product-single__price .product__price-actual');
                var $selectedId = $selectedOption.attr('value'); 
                var $selectedHandle = $selectedOption.attr('handle'); 
                var $oosButton = $addToCartButton.siblings('.notify-me-a');
                if (selectedStore === 'US' || selectedStore === 'UK') {
                if ($('#swym-variant-id')) {
                    $('#swym-variant-id').attr('value', $selectedId);
                    swymCallbackFn();
                }
                }
              
                if (!$selectedOption.data('compared_price')) {
                    // $priceSelector.html($selectedOption.data('price'));
                }
                if ($selectedOption.prop('disabled')) {
                    $addToCartButton.addClass('notify');
                    $addToCartButton.val('Notify Me When Available').prop('disabled', !1)
                    if($('.template-collection')[0] || $('.template-search')[0]){
                        $addToCartButton.hide();
                        $oosButton.show();
                        $oosButton.attr("href", `${$selectedHandle}&oos=1`)
                    }
                } else if ($selectedOption.data('preorder') == 'preorder') {
                    $addToCartButton.removeClass('notify');
                    $addToCartButton.val('Pre-Order').prop('disabled', !1);
                    if($('.template-collection')[0] || $('.template-search')[0]){
                        $addToCartButton.show();
                        $addToCartButton.removeClass('notify')
                        $oosButton.hide();
                    }
                } else {
                    if($('.template-collection')[0] || $('.template-search')[0]){
                        $addToCartButton.show();
                        $addToCartButton.removeClass('notify')
                        $oosButton.hide();
                    }
                  
                    if ($addToCartButton.hasClass('is-rental')) {
                        $addToCartButton.val($addToCartButton.data('rental')).prop('disabled', !1)
                    } else {
                        if (dropdownOptionSelected) {
                            $addToCartButton.val(Shopify.theme.locale.products.product.add_to_cart).prop('disabled', !1)
                            $addToCartButton.removeClass('notify')
                        } else {
                            $addToCartButton.val(Shopify.theme.locale.products.product.add_to_cart).prop('disabled', 1)
                        }
                    }
                }
            });

            if (selectedStore === 'US' || selectedStore === 'UK') {
            function swymCallbackFn(swat) {
                // your API calls go here
                //get the current selected variant here from your page
                var $selectedOption = $productSelect.find('option:selected');
                var $selectedId = $selectedOption.attr('value'); 
                var currentSelectedVariantID = $selectedId;
                if (window.triggerSwymVariantEvent) {
                  triggerSwymVariantEvent(currentSelectedVariantID);
                }
                // Override  wishlist notification to custom wishlist page url.
                if(SwymUtils) {
                    SwymUtils.getHostedURL = function() {
                        return "/pages/wishlist";
                    }
                }
              }
              if (!window.SwymCallbacks) {
                window.SwymCallbacks = [];
              }
              window.SwymCallbacks.push(swymCallbackFn);
            }
          
            $doc.on('submit','.product-single form', function(e) {
                e.preventDefault();
                if ($('.submit_btn').hasClass('notify')) {
                    $(".klaviyo-bis-trigger")[0].click();
                    return !1
                }

                var $selectedOption = $productSelect.find('option:selected');
                var $form = $(this);
                var $addToCartButton = $form.find('.product-single__actions input[type="submit"]');
                $addToCartButton.val(Shopify.theme.locale.products.product.adding).prop('disabled', !0);
                var formserialdata = ($form.serialize()).concat('&quantity=1');

                $.ajax({
                    url: '/cart/add.js',
                    type: 'post',
                    dataType: 'json',
                    data: formserialdata
                }).done(function() {
                    const originalBoostTemplateClass = document.getElementsByClassName('template-collection--boost-pfs-original')
                    originalBoostTemplateClass.length <= 0 ? trackAddToCart(formserialdata, e) : '';
                    $.ajax({
                        url: '/cart'
                    }).done(function(data) {
                      	$('.add-to-bag-modal').removeClass('modal-open');
                          if (typeof Harper !== 'undefined') {
                            harperMiniCart ? harperMiniCart = new Harper(harperMiniCartConfig) : '';
                        }
                      	$('.wrapper').addClass('tooltip-opened');
                      	$('.wrapper').addClass('added');
                        var $data = $(data);
                        $('.nav-utilities .link-cart').closest('li').html($data.find('.nav-utilities .link-cart').closest('li').html());
                        $addToCartButton.val(Shopify.theme.locale.products.product.added).prop('disabled', !1);
                        if ($selectedOption.data('preorder') == 'preorder') {
                        setTimeout(function() {
                        $addToCartButton.val('Pre-order').prop('disabled', !1)
                         }, 1000)
                      } else if ($addToCartButton.hasClass('is-rental')) {
                        setTimeout(function() {
                           $addToCartButton.val($addToCartButton.data('rental')).prop('disabled', !1)
                         }, 1000)
                      } else {
                         setTimeout(function() {
                            $addToCartButton.val(Shopify.theme.locale.products.product.add_to_cart).prop('disabled', !1)
                        }, 1000)
                      };
                        if (typeof affirm !== 'undefined') {
                            affirm.ui.refresh();
                        }
                        if (document.getElementsByTagName("klarna-placement")[0]) {
                        fetch('/cart.js')
                        .then(response => response.json())
                        .then(cart => {
                            let cartTotalPrice = cart.total_price;
                            document.getElementsByTagName("klarna-placement")[0].setAttribute("data-purchase-amount", cartTotalPrice);
                            window.KlarnaOnsiteService = window.KlarnaOnsiteService || []
                            window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' })
                        })
                        .catch(error => console.error('Error:', error));
                        }
                        if (typeof Harper !== 'undefined') {
                            harperMiniCart = new Harper(harperMiniCartConfig);
                        }
                    }).fail(function(error) {
                        console.log('error')
                    })
                }).fail(function(error) {
                    alert(error.responseJSON.description);
                    if ($addToCartButton.hasClass('is-rental')) {
                        $addToCartButton.val($addToCartButton.data('rental')).prop('disabled', !1)
                    } else {
                        $addToCartButton.val(Shopify.theme.locale.products.product.add_to_cart).prop('disabled', !1)
                    }
                })
            });
            $('.product-single__variant[data-option="color"] input').on('change', function() {
                var $this = $(this);
                var $otherOptions = $('.product-single__variant:not([data-option="color"]) input');
                var $selectOptions = $productSelect.find('option[data-color="' + $this.val() + '"]');
                if ($selectOptions.length === 0) {
                    $selectOptions = $productSelect.find('option[data-colour="' + $this.val() + '"]')
                }
                $selectOptions.each(function() {
                    var $option = $(this);
                    var sizeValue = $option.data('size');
                    if ($option.prop('disabled')) {
                        $('.product-single__variant[data-option="size"] input[value="' + sizeValue + '"]').prop('disabled', !0)
                    } else {
                        $('.product-single__variant[data-option="size"] input[value="' + sizeValue + '"]').prop('disabled', !1)
                    }
                })
            });
            $win.on('load', function() {
                var current_url = new URL(window.location.href);
                var current_variant_id = current_url.searchParams.get('variant');
                var $variantOption = $productSelect.find('option[value="' + current_variant_id + '"]');
                var options = [];
                var optionValues = [];                
                $('.product-single__variant').each(function() {
                    var $this = $(this);
                    options.push($this.data('option'))
                });
                options.forEach(function(option) {
                    optionValues.push($variantOption.data(option))
                });
                optionValues.forEach(function(value) {
                    $('.product-single__variant input[value=' + value + ']').prop('checked', !0).siblings().prop('checked', !1)
                });
              
                /** Wishlist addtocart button hide and select size text insert this code **/
              
                   var body = $('body').attr("class");
                   if(body.indexOf("template- no_touch")!=-1 || body.indexOf("template- is_touch")!=-1){
                       $(".addsingleproduct").each(function(){         
                         var varid = $(this).attr("data-variantid");
                         $(this).addClass("single_product_"+varid);
                       });
                       $(".product_title").each(function(){
                         var link = $(this).find("a").attr("href");		
                         var link_split = link.split("variant=");                  
                         $(".single_product_"+link_split[1]).after('<a href="'+link+'" class="btn btn-warning removebutton">SELECT SIZE</a>');
                       });
                   }    
              
                    var body = $('body').attr("class");
                    if(body.indexOf("template- no_touch")!=-1){      
                    }else{
                        if($('.section--product .section__content').length > 0){
                            $('.section--product .section__content').stick_in_parent({
                                offset_top: 130,
                                recalc_every: 1
                            });
                        }
                    }
              
                $variantOption.prop('selected', !0).trigger('change')
            })
        }.call(this, __webpack_require__("../node_modules/jquery/dist/jquery.js-exposed")))
    }),
    "../src/assets/js/sliders.js": (function(module, exports, __webpack_require__) {
        "use strict";
        (function($) {
            __webpack_require__("../node_modules/slick-carousel/slick/slick.js");
            var $win = $(window);

            function initSlider() {
                var sliderProps = {};
                if ($('.slider--products').hasClass('slider--products-alt')) {
                    sliderProps = {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        responsive: [{
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 3
                            }
                        }, {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 2
                            }
                        }]
                    }
                }
                else if ($('.slider--products').hasClass('slider--products-new_in')){
                    sliderProps = {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        responsive: [{
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1,
                                variableWidth: true
                            }
                        }]
                    }
                }
                else {
                    sliderProps = {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        responsive: [{
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 2
                            }
                        }]
                    }
                }
                $('.slider--products .slider__slides').slick(sliderProps)
            }
           
            $(".slider--center .slider__slides").slick({
                slidesToShow: 1,
                centerMode: !0,
                centerPadding: "200px",
                slidesToScroll: 1,
                responsive: [{
                    breakpoint: 1024,
                    settings: {
                        centerPadding: "100px"
                    }
                }, {
                    breakpoint: 768,
                    settings: {
                        centerPadding: "30px"
                    }
                }]
            });
            $(".slider--five .slider__slides").slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                responsive: [{
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3
                    }
                }, {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2
                    }
                }]
            });
            
            if ($win.width() < 768) {
                $('.section--product .section__images ul').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: !0,
                    adaptiveHeight: !0
                })
            }
          
            // Whenever the page resizes, check if we need to re-initialise the slick slider
            const initialiseTest002Slide = function () {
                $('.test002-wrapper:not(.slick-initialized)').slick({
                    infinite: true,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    autoplay: false,
                    mobileFirst: true,
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 3
                            }
                        },
                        {
                            breakpoint: 960,
                            settings: {
                                slidesToShow: 4
                            }
                        },
                        {
                            breakpoint: 1024,
                            settings: 'unslick'
                        }
                    ]
                });
            }
            window.addEventListener('load', function () {
                window.requestAnimationFrame(function () {
                    initialiseTest002Slide()
                });
                $(window).on('resize', function () {
                    initialiseTest002Slide()
                });
            })

            if ($(".review-carousel review js-review-carousel")) {
                $(".review-carousel review js-review-carousel").slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                });
            }
          	
            // Fire the resize event on the window on page load
          	// $win.trigger('resize');
          
            $(".slider--world_of_nt_charity").slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: true,
                cssEase: 'linear',
                responsive: [
                    {
                        breakpoint: 510,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
            }
                    },
                    {
                        breakpoint: 500,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
          
           
            
          
            $('.slider-lookbook .slider__slides').slick({
                slidesToShow: 1,
                slidesToScroll: 1
            });
          
            $('.products .product__image .list-sizes').slick({
                slidesToShow: 3,
                slidesToScroll: 1
            });
          
            window.gravitycallback =  function(collectionPageNr, productIds) {
                  
                var slickSettings = {
                  slidesToShow: 3,
                  slidesToScroll: 1
                };
                var slickSettingsCollection = {
                  dots: true,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  arrows: false,
                  infinite: false
                }
                

                  $('.list-sizes').not('.slick-initialized').slick(slickSettings);

                  if ($('#single-product-layout').is(':checked')) {
                    $('.product.fakea').addClass('single');
                    $('.product.fakea .product__image').css('background-size', '0');
                    $('.product.fakea .product__image-hover').css('background-size', '0');

                    setTimeout(function() { 
                      $('.collection-slider').not('.slick-initialized').slick(slickSettingsCollection);
                    }, 200);       
                  } else {
                    $('.product.fakea').removeClass('single');

                    $('.product.fakea .product__image').css('background-size', 'contain');
                    $('.product.fakea .product__image-hover').css('background-size', 'contain');
                  }
                  // Start of Ajaxinate Infinite load Integration.
                  var event = new Event("swym:collections-loaded");
                  document.dispatchEvent(event);
                  // End of Ajaxinate Infinite load Integration.

                $('.add-to-bag-modal-open').on('click', function() {
                  $(this).siblings('.add-to-bag-modal').addClass('modal-open');
                })
                $('.add-to-bag-modal-close').on('click', function() {
                  $(this).closest('.add-to-bag-modal').removeClass('modal-open');
                  $(this).siblings('form').find('.main-list-variants').removeClass('showMenu');
                  $('.main-list-variants').removeClass('showMenu');
                })
            };

            
            
            $(window).on('load', function(){
              var speed = $('.slideshow_seconds').val();
              if (speed != undefined) {
                  $('.slider--intro .slider__slides').slick({
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      dots: !1,
                      arrows: !0,
                      autoplay: !0,
                      autoplaySpeed: speed,
                      responsive: [{
                          breakpoint: 768,
                          settings: {
                              autoplay: !0,
                              autoplaySpeed: speed,
                              dots: !1
                          }
                      }]
                  })
              } else {
                  $('.slider--intro .slider__slides').slick({
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      dots: !1,
                      arrows: !0,
                      responsive: [{
                          breakpoint: 768,
                          settings: {
                              autoplay: !0,
                              autoplaySpeed: 3500,
                              dots: !1
                          }
                      }]
                  })
              }
              $('.slider--intro').fadeIn();
              
              setTimeout(function(){
              	var height_val = $('.section-intro').find(".slider__slide").height();
                $('.section-intro').find(".section__content").css({ 'height': height_val + "px" });               
              },1000);
              
              
              $(".tab__content").fadeIn();
              $('.section--related-products .slider--products').fadeIn();
              initSlider();
              
              
              $(".section--styles").find(".slider__clip").fadeIn();
              $('.slider--styles .slider__slides').slick({
                  slidesToShow: 4,
                  slidesToScroll: 1,
                  responsive: [{
                      breakpoint: 1024,
                      settings: {
                          slidesToShow: 3
                      }
                  }, {
                      breakpoint: 768,
                      settings: {
                          slidesToShow: 1
                      }
                  }]
              });
              
              $('.slider--collections .slider__slides').fadeIn();
              $('.slider--collections .slider__slides').slick({
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  responsive: [{
                      breakpoint: 768,
                      settings: {
                          slidesToShow: 1
                      }
                  }]
              });
             
              $('.section-lookbook').find('.lookbook__products ul').slick({
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  responsive: [{
                      breakpoint: 1024,
                      settings: {
                          slidesToShow: 2
                      }
                  }, {
                      breakpoint: 768,
                      settings: {
                          slidesToShow: 1
                      }
                  }]
              }); 
              $(".section-lookbook .lookbook__products").fadeIn();              
              
              $('.section-bridal_lookbook').find('.lookbook__products ul').slick({
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  responsive: [{
                      breakpoint: 1024,
                      settings: {
                          slidesToShow: 2
                      }
                  }, {
                      breakpoint: 768,
                      settings: {
                          slidesToShow: 1
                      }
                  }]
              });
              $(".section-bridal_lookbook .lookbook__products").fadeIn();
              
              // Feature in section bridal page
               $('.bridal_brand_slide, .kids_brand_slide').slick({
                  slidesToShow: 5,
                  slidesToScroll: 1,
                  responsive: [{
                    breakpoint: 1024,
                    settings: {
                      slidesToShow: 3
                    }
                  }, {
                    breakpoint: 768,
                    settings: {
                      slidesToShow: 1
                    }
                 }]
             });
              
              
            });
          
              $(window).on('resize', function () {     
                setTimeout(function(){
 				var height_val = $('.section-intro').find(".slider__slide").height();
                 $('.section-intro').find(".section__content").css({ 'height': height_val + "px" });
                }, 1000);
              });
            
        }.call(this, __webpack_require__("../node_modules/jquery/dist/jquery.js-exposed")))
    })
});
! function(a, b) {
    var c = function(d) {
        b(a.lazySizes, d), a.removeEventListener("lazyunveilread", c, !0)
    };
    b = b.bind(null, a, a.document), "object" == typeof module && module.exports ? b(require("lazysizes")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, !0)
}(window, function(a, b, c, d) {
    "use strict";

    function e(a) {
        var b = getComputedStyle(a, null) || {},
            c = b.fontFamily || "",
            d = c.match(j) || "",
            e = d && c.match(k) || "";
        return e && (e = e[1]), {
            fit: d && d[1] || "",
            position: n[e] || e || "center"
        }
    }

    function f(a, b) {
        var d, e, f = c.cfg,
            g = a.cloneNode(!1),
            h = g.style,
            i = function() {
                var b = a.currentSrc || a.src;
                b && e !== b && (e = b, h.backgroundImage = "url(" + (m.test(b) ? JSON.stringify(b) : b) + ")", d || (d = !0, c.rC(g, f.loadingClass), c.aC(g, f.loadedClass)))
            },
            j = function() {
                c.rAF(i)
            };
        a._lazysizesParentFit = b.fit, a.addEventListener("lazyloaded", j, !0), a.addEventListener("load", j, !0), g.addEventListener("load", function() {
            var a = g.currentSrc || g.src;
            a && a != l && (g.src = l, g.srcset = "")
        }), c.rAF(function() {
            var d = a,
                e = a.parentNode;
            "PICTURE" == e.nodeName.toUpperCase() && (d = e, e = e.parentNode), c.rC(g, f.loadedClass), c.rC(g, f.lazyClass), c.aC(g, f.loadingClass), c.aC(g, f.objectFitClass || "lazysizes-display-clone"), g.getAttribute(f.srcsetAttr) && g.setAttribute(f.srcsetAttr, ""), g.getAttribute(f.srcAttr) && g.setAttribute(f.srcAttr, ""), g.src = l, g.srcset = "", h.backgroundRepeat = "no-repeat", h.backgroundPosition = b.position, h.backgroundSize = b.fit, d.style.display = "none", a.setAttribute("data-parent-fit", b.fit), a.setAttribute("data-parent-container", "prev"), e.insertBefore(g, d), a._lazysizesParentFit && delete a._lazysizesParentFit, a.complete && i()
        })
    }
    var g = b.createElement("a").style,
        h = "objectFit" in g,
        i = h && "objectPosition" in g,
        j = /object-fit["']*\s*:\s*["']*(contain|cover)/,
        k = /object-position["']*\s*:\s*["']*(.+?)(?=($|,|'|"|;))/,
        l = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
        m = /\(|\)|'/,
        n = {
            center: "center",
            "50% 50%": "center"
        };
    if (!h || !i) {
        var o = function(a) {
            if (a.detail.instance == c) {
                var b = a.target,
                    d = e(b);
                !d.fit || h && "center" == d.position || f(b, d)
            }
        };
        a.addEventListener("lazyunveilread", o, !0), d && d.detail && o(d)
    }
});
! function(a, b) {
    var c = function() {
        b(a.lazySizes), a.removeEventListener("lazyunveilread", c, !0)
    };
    b = b.bind(null, a, a.document), "object" == typeof module && module.exports ? b(require("lazysizes")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, !0)
}(window, function(a, b, c) {
    "use strict";

    function d(b, c) {
        var d, e, f, g, h = a.getComputedStyle(b);
        e = b.parentNode, g = {
            isPicture: !(!e || !m.test(e.nodeName || ""))
        }, f = function(a, c) {
            var d = b.getAttribute("data-" + a);
            if (!d) {
                var e = h.getPropertyValue("--ls-" + a);
                e && (d = e.trim())
            }
            if (d) {
                if ("true" == d) d = !0;
                else if ("false" == d) d = !1;
                else if (l.test(d)) d = parseFloat(d);
                else if ("function" == typeof j[a]) d = j[a](b, d);
                else if (q.test(d)) try {
                    d = JSON.parse(d)
                } catch (a) {}
                g[a] = d
            } else a in j && "function" != typeof j[a] ? g[a] = j[a] : c && "function" == typeof j[a] && (g[a] = j[a](b, d))
        };
        for (d in j) f(d);
        return c.replace(p, function(a, b) {
            b in g || f(b, !0)
        }), g
    }

    function e(a, b) {
        var c = [],
            d = function(a, c) {
                return k[typeof b[c]] ? b[c] : a
            };
        return c.srcset = [], b.absUrl && (s.setAttribute("href", a), a = s.href), a = ((b.prefix || "") + a + (b.postfix || "")).replace(p, d), b.widths.forEach(function(d) {
            var e = b.widthmap[d] || d,
                f = b.aspectratio || b.ratio,
                g = !b.aspectratio && j.traditionalRatio,
                h = {
                    u: a.replace(n, e).replace(o, f ? g ? Math.round(d * f) : Math.round(d / f) : ""),
                    w: d
                };
            c.push(h), c.srcset.push(h.c = h.u + " " + d + "w")
        }), c
    }

    function f(a, c, d) {
        var f = 0,
            g = 0,
            h = d;
        if (a) {
            if ("container" === c.ratio) {
                for (f = h.scrollWidth, g = h.scrollHeight; !(f && g || h === b);) h = h.parentNode, f = h.scrollWidth, g = h.scrollHeight;
                f && g && (c.ratio = g / f)
            }
            a = e(a, c), a.isPicture = c.isPicture, u && "IMG" == d.nodeName.toUpperCase() ? d.removeAttribute(i.srcsetAttr) : d.setAttribute(i.srcsetAttr, a.srcset.join(", ")), Object.defineProperty(d, "_lazyrias", {
                value: a,
                writable: !0
            })
        }
    }

    function g(a, b) {
        var e = d(a, b);
        return j.modifyOptions.call(a, {
            target: a,
            details: e,
            detail: e
        }), c.fire(a, "lazyriasmodifyoptions", e), e
    }

    function h(a) {
        return a.getAttribute(a.getAttribute("data-srcattr") || j.srcAttr) || a.getAttribute(i.srcsetAttr) || a.getAttribute(i.srcAttr) || a.getAttribute("data-pfsrcset") || ""
    }
    var i, j, k = {
            string: 1,
            number: 1
        },
        l = /^\-*\+*\d+\.*\d*$/,
        m = /^picture$/i,
        n = /\s*\{\s*width\s*\}\s*/i,
        o = /\s*\{\s*height\s*\}\s*/i,
        p = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,
        q = /^\[.*\]|\{.*\}$/,
        r = /^(?:auto|\d+(px)?)$/,
        s = b.createElement("a"),
        t = b.createElement("img"),
        u = "srcset" in t && !("sizes" in t),
        v = !!a.HTMLPictureElement && !u;
    ! function() {
        var b, d = function() {},
            e = {
                prefix: "",
                postfix: "",
                srcAttr: "data-src",
                absUrl: !1,
                modifyOptions: d,
                widthmap: {},
                ratio: !1,
                traditionalRatio: !1,
                aspectratio: !1
            };
        i = c && c.cfg || a.lazySizesConfig, i || (i = {}, a.lazySizesConfig = i), i.supportsType || (i.supportsType = function(a) {
            return !a
        }), i.rias || (i.rias = {}), "widths" in (j = i.rias) || (j.widths = [], function(a) {
            for (var b, c = 0; !b || b < 3e3;) c += 5, c > 30 && (c += 1), b = 36 * c, a.push(b)
        }(j.widths));
        for (b in e) b in j || (j[b] = e[b])
    }(), addEventListener("lazybeforesizes", function(a) {
        if (a.detail.instance == c) {
            var b, d, e, k, l, m, o, p, q, s, t, u, x;
            if (b = a.target, a.detail.dataAttr && !a.defaultPrevented && !j.disabled && (q = b.getAttribute(i.sizesAttr) || b.getAttribute("sizes")) && r.test(q)) {
                if (d = h(b), e = g(b, d), t = n.test(e.prefix) || n.test(e.postfix), e.isPicture && (k = b.parentNode))
                    for (l = k.getElementsByTagName("source"), m = 0, o = l.length; m < o; m++)(t || n.test(p = h(l[m]))) && (f(p, e, l[m]), u = !0);
                t || n.test(d) ? (f(d, e, b), u = !0) : u && (x = [], x.srcset = [], x.isPicture = !0, Object.defineProperty(b, "_lazyrias", {
                    value: x,
                    writable: !0
                })), u && (v ? b.removeAttribute(i.srcAttr) : "auto" != q && (s = {
                    width: parseInt(q, 10)
                }, w({
                    target: b,
                    detail: s
                })))
            }
        }
    }, !0);
    var w = function() {
        var d = function(a, b) {
                return a.w - b.w
            },
            e = function(a) {
                var b, c, d = a.length,
                    e = a[d - 1],
                    f = 0;
                for (f; f < d; f++)
                    if (e = a[f], e.d = e.w / a.w, e.d >= a.d) {
                        !e.cached && (b = a[f - 1]) && b.d > a.d - .13 * Math.pow(a.d, 2.2) && (c = Math.pow(b.d - .6, 1.6), b.cached && (b.d += .15 * c), b.d + (e.d - a.d) * c > a.d && (e = b));
                        break
                    } return e
            },
            f = function(a, b) {
                var d;
                return !a._lazyrias && c.pWS && (d = c.pWS(a.getAttribute(i.srcsetAttr || ""))).length && (Object.defineProperty(a, "_lazyrias", {
                    value: d,
                    writable: !0
                }), b && a.parentNode && (d.isPicture = "PICTURE" == a.parentNode.nodeName.toUpperCase())), a._lazyrias
            },
            g = function(b) {
                var d = a.devicePixelRatio || 1,
                    e = c.getX && c.getX(b);
                return Math.min(e || d, 2.4, d)
            },
            h = function(b, c) {
                var h, i, j, k, l, m;
                if (l = b._lazyrias, l.isPicture && a.matchMedia)
                    for (i = 0, h = b.parentNode.getElementsByTagName("source"), j = h.length; i < j; i++)
                        if (f(h[i]) && !h[i].getAttribute("type") && (!(k = h[i].getAttribute("media")) || (matchMedia(k) || {}).matches)) {
                            l = h[i]._lazyrias;
                            break
                        } return (!l.w || l.w < c) && (l.w = c, l.d = g(b), m = e(l.sort(d))), m
            },
            j = function(d) {
                if (d.detail.instance == c) {
                    var e, g = d.target;
                    if (!u && (a.respimage || a.picturefill || lazySizesConfig.pf)) return void b.removeEventListener("lazybeforesizes", j);
                    ("_lazyrias" in g || d.detail.dataAttr && f(g, !0)) && (e = h(g, d.detail.width)) && e.u && g._lazyrias.cur != e.u && (g._lazyrias.cur = e.u, e.cached = !0, c.rAF(function() {
                        g.setAttribute(i.srcAttr, e.u), g.setAttribute("src", e.u)
                    }))
                }
            };
        return v ? j = function() {} : addEventListener("lazybeforesizes", j), j
    }()
});
! function(a, b) {
    var c = b(a, a.document);
    a.lazySizes = c, "object" == typeof module && module.exports && (module.exports = c)
}(window, function(a, b) {
    "use strict";
    if (b.getElementsByClassName) {
        var c, d, e = b.documentElement,
            f = a.Date,
            g = a.HTMLPictureElement,
            h = "addEventListener",
            i = "getAttribute",
            j = a[h],
            k = a.setTimeout,
            l = a.requestAnimationFrame || k,
            m = a.requestIdleCallback,
            n = /^picture$/i,
            o = ["load", "error", "lazyincluded", "_lazyloaded"],
            p = {},
            q = Array.prototype.forEach,
            r = function(a, b) {
                return p[b] || (p[b] = new RegExp("(\\s|^)" + b + "(\\s|$)")), p[b].test(a[i]("class") || "") && p[b]
            },
            s = function(a, b) {
                r(a, b) || a.setAttribute("class", (a[i]("class") || "").trim() + " " + b)
            },
            t = function(a, b) {
                var c;
                (c = r(a, b)) && a.setAttribute("class", (a[i]("class") || "").replace(c, " "))
            },
            u = function(a, b, c) {
                var d = c ? h : "removeEventListener";
                c && u(a, b), o.forEach(function(c) {
                    a[d](c, b)
                })
            },
            v = function(a, d, e, f, g) {
                var h = b.createEvent("Event");
                return e || (e = {}), e.instance = c, h.initEvent(d, !f, !g), h.detail = e, a.dispatchEvent(h), h
            },
            w = function(b, c) {
                var e;
                !g && (e = a.picturefill || d.pf) ? (c && c.src && !b[i]("srcset") && b.setAttribute("srcset", c.src), e({
                    reevaluate: !0,
                    elements: [b]
                })) : c && c.src && (b.src = c.src)
            },
            x = function(a, b) {
                return (getComputedStyle(a, null) || {})[b]
            },
            y = function(a, b, c) {
                for (c = c || a.offsetWidth; c < d.minSize && b && !a._lazysizesWidth;) c = b.offsetWidth, b = b.parentNode;
                return c
            },
            z = function() {
                var a, c, d = [],
                    e = [],
                    f = d,
                    g = function() {
                        var b = f;
                        for (f = d.length ? e : d, a = !0, c = !1; b.length;) b.shift()();
                        a = !1
                    },
                    h = function(d, e) {
                        a && !e ? d.apply(this, arguments) : (f.push(d), c || (c = !0, (b.hidden ? k : l)(g)))
                    };
                return h._lsFlush = g, h
            }(),
            A = function(a, b) {
                return b ? function() {
                    z(a)
                } : function() {
                    var b = this,
                        c = arguments;
                    z(function() {
                        a.apply(b, c)
                    })
                }
            },
            B = function(a) {
                var b, c = 0,
                    e = d.throttleDelay,
                    g = d.ricTimeout,
                    h = function() {
                        b = !1, c = f.now(), a()
                    },
                    i = m && g > 49 ? function() {
                        m(h, {
                            timeout: g
                        }), g !== d.ricTimeout && (g = d.ricTimeout)
                    } : A(function() {
                        k(h)
                    }, !0);
                return function(a) {
                    var d;
                    (a = !0 === a) && (g = 33), b || (b = !0, d = e - (f.now() - c), d < 0 && (d = 0), a || d < 9 ? i() : k(i, d))
                }
            },
            C = function(a) {
                var b, c, d = 99,
                    e = function() {
                        b = null, a()
                    },
                    g = function() {
                        var a = f.now() - c;
                        a < d ? k(g, d - a) : (m || e)(e)
                    };
                return function() {
                    c = f.now(), b || (b = k(g, d))
                }
            };
        ! function() {
            var b, c = {
                lazyClass: "lazyload",
                loadedClass: "lazyloaded",
                loadingClass: "lazyloading",
                preloadClass: "lazypreload",
                errorClass: "lazyerror",
                autosizesClass: "lazyautosizes",
                srcAttr: "data-src",
                srcsetAttr: "data-srcset",
                sizesAttr: "data-sizes",
                minSize: 40,
                customMedia: {},
                init: !0,
                expFactor: 1.5,
                hFac: .8,
                loadMode: 2,
                loadHidden: !0,
                ricTimeout: 0,
                throttleDelay: 125
            };
            d = a.lazySizesConfig || a.lazysizesConfig || {};
            for (b in c) b in d || (d[b] = c[b]);
            a.lazySizesConfig = d, k(function() {
                d.init && F()
            })
        }();
        var D = function() {
                var g, l, m, o, p, y, D, F, G, H, I, J, K = /^img$/i,
                    L = /^iframe$/i,
                    M = "onscroll" in a && !/(gle|ing)bot/.test(navigator.userAgent),
                    N = 0,
                    O = 0,
                    P = 0,
                    Q = -1,
                    R = function(a) {
                        P--, (!a || P < 0 || !a.target) && (P = 0)
                    },
                    S = function(a) {
                        return null == J && (J = "hidden" == x(b.body, "visibility")), J || "hidden" != x(a.parentNode, "visibility") && "hidden" != x(a, "visibility")
                    },
                    T = function(a, c) {
                        var d, f = a,
                            g = S(a);
                        for (F -= c, I += c, G -= c, H += c; g && (f = f.offsetParent) && f != b.body && f != e;)(g = (x(f, "opacity") || 1) > 0) && "visible" != x(f, "overflow") && (d = f.getBoundingClientRect(), g = H > d.left && G < d.right && I > d.top - 1 && F < d.bottom + 1);
                        return g
                    },
                    U = function() {
                        var a, f, h, j, k, m, n, p, q, r, s, t, u = c.elements;
                        if ((o = d.loadMode) && P < 8 && (a = u.length)) {
                            for (f = 0, Q++; f < a; f++)
                                if (u[f] && !u[f]._lazyRace)
                                    if (!M || c.prematureUnveil && c.prematureUnveil(u[f])) aa(u[f]);
                                    else if ((p = u[f][i]("data-expand")) && (m = 1 * p) || (m = O), r || (r = !d.expand || d.expand < 1 ? e.clientHeight > 500 && e.clientWidth > 500 ? 500 : 370 : d.expand, c._defEx = r, s = r * d.expFactor, t = d.hFac, J = null, O < s && P < 1 && Q > 2 && o > 2 && !b.hidden ? (O = s, Q = 0) : O = o > 1 && Q > 1 && P < 6 ? r : N), q !== m && (y = innerWidth + m * t, D = innerHeight + m, n = -1 * m, q = m), h = u[f].getBoundingClientRect(), (I = h.bottom) >= n && (F = h.top) <= D && (H = h.right) >= n * t && (G = h.left) <= y && (I || H || G || F) && (d.loadHidden || S(u[f])) && (l && P < 3 && !p && (o < 3 || Q < 4) || T(u[f], m))) {
                                if (aa(u[f]), k = !0, P > 9) break
                            } else !k && l && !j && P < 4 && Q < 4 && o > 2 && (g[0] || d.preloadAfterLoad) && (g[0] || !p && (I || H || G || F || "auto" != u[f][i](d.sizesAttr))) && (j = g[0] || u[f]);
                            j && !k && aa(j)
                        }
                    },
                    V = B(U),
                    W = function(a) {
                        var b = a.target;
                        if (b._lazyCache) return void delete b._lazyCache;
                        R(a), s(b, d.loadedClass), t(b, d.loadingClass), u(b, Y), v(b, "lazyloaded")
                    },
                    X = A(W),
                    Y = function(a) {
                        X({
                            target: a.target
                        })
                    },
                    Z = function(a, b) {
                        try {
                            a.contentWindow.location.replace(b)
                        } catch (c) {
                            a.src = b
                        }
                    },
                    $ = function(a) {
                        var b, c = a[i](d.srcsetAttr);
                        (b = d.customMedia[a[i]("data-media") || a[i]("media")]) && a.setAttribute("media", b), c && a.setAttribute("srcset", c)
                    },
                    _ = A(function(a, b, c, e, f) {
                        var g, h, j, l, o, p;
                        (o = v(a, "lazybeforeunveil", b)).defaultPrevented || (e && (c ? s(a, d.autosizesClass) : a.setAttribute("sizes", e)), h = a[i](d.srcsetAttr), g = a[i](d.srcAttr), f && (j = a.parentNode, l = j && n.test(j.nodeName || "")), p = b.firesLoad || "src" in a && (h || g || l), o = {
                            target: a
                        }, s(a, d.loadingClass), p && (clearTimeout(m), m = k(R, 2500), u(a, Y, !0)), l && q.call(j.getElementsByTagName("source"), $), h ? a.setAttribute("srcset", h) : g && !l && (L.test(a.nodeName) ? Z(a, g) : a.src = g), f && (h || l) && w(a, {
                            src: g
                        })), a._lazyRace && delete a._lazyRace, t(a, d.lazyClass), z(function() {
                            var b = a.complete && a.naturalWidth > 1;
                            p && !b || (b && s(a, "ls-is-cached"), W(o), a._lazyCache = !0, k(function() {
                                "_lazyCache" in a && delete a._lazyCache
                            }, 9)), "lazy" == a.loading && P--
                        }, !0)
                    }),
                    aa = function(a) {
                        if (!a._lazyRace) {
                            var b, c = K.test(a.nodeName),
                                e = c && (a[i](d.sizesAttr) || a[i]("sizes")),
                                f = "auto" == e;
                            (!f && l || !c || !a[i]("src") && !a.srcset || a.complete || r(a, d.errorClass) || !r(a, d.lazyClass)) && (b = v(a, "lazyunveilread").detail, f && E.updateElem(a, !0, a.offsetWidth), a._lazyRace = !0, P++, _(a, b, f, e, c))
                        }
                    },
                    ba = C(function() {
                        d.loadMode = 3, V()
                    }),
                    ca = function() {
                        3 == d.loadMode && (d.loadMode = 2), ba()
                    },
                    da = function() {
                        if (!l) {
                            if (f.now() - p < 999) return void k(da, 999);
                            l = !0, d.loadMode = 3, V(), j("scroll", ca, !0)
                        }
                    };
                return {
                    _: function() {
                        p = f.now(), c.elements = b.getElementsByClassName(d.lazyClass), g = b.getElementsByClassName(d.lazyClass + " " + d.preloadClass), j("scroll", V, !0), j("resize", V, !0), a.MutationObserver ? new MutationObserver(V).observe(e, {
                            childList: !0,
                            subtree: !0,
                            attributes: !0
                        }) : (e[h]("DOMNodeInserted", V, !0), e[h]("DOMAttrModified", V, !0), setInterval(V, 999)), j("hashchange", V, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function(a) {
                            b[h](a, V, !0)
                        }), /d$|^c/.test(b.readyState) ? da() : (j("load", da), b[h]("DOMContentLoaded", V), k(da, 2e4)), c.elements.length ? (U(), z._lsFlush()) : V()
                    },
                    checkElems: V,
                    unveil: aa,
                    _aLSL: ca
                }
            }(),
            E = function() {
                var a, c = A(function(a, b, c, d) {
                        var e, f, g;
                        if (a._lazysizesWidth = d, d += "px", a.setAttribute("sizes", d), n.test(b.nodeName || ""))
                            for (e = b.getElementsByTagName("source"), f = 0, g = e.length; f < g; f++) e[f].setAttribute("sizes", d);
                        c.detail.dataAttr || w(a, c.detail)
                    }),
                    e = function(a, b, d) {
                        var e, f = a.parentNode;
                        f && (d = y(a, f, d), e = v(a, "lazybeforesizes", {
                            width: d,
                            dataAttr: !!b
                        }), e.defaultPrevented || (d = e.detail.width) && d !== a._lazysizesWidth && c(a, f, e, d))
                    },
                    f = function() {
                        var b, c = a.length;
                        if (c)
                            for (b = 0; b < c; b++) e(a[b])
                    },
                    g = C(f);
                return {
                    _: function() {
                        a = b.getElementsByClassName(d.autosizesClass), j("resize", g)
                    },
                    checkElems: g,
                    updateElem: e
                }
            }(),
            F = function() {
                F.i || (F.i = !0, E._(), D._())
            };
        return c = {
            cfg: d,
            autoSizer: E,
            loader: D,
            init: F,
            uP: w,
            aC: s,
            rC: t,
            hC: r,
            fire: v,
            gW: y,
            rAF: z
        }
    }
});
! function(a, b) {
    var c = function() {
        b(a.lazySizes), a.removeEventListener("lazyunveilread", c, !0)
    };
    b = b.bind(null, a, a.document), "object" == typeof module && module.exports ? b(require("lazysizes")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, !0)
}(window, function(a, b, c) {
    "use strict";
    if (a.addEventListener) {
        var d = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
            e = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/,
            f = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/,
            g = /^picture$/i,
            h = function(a) {
                return getComputedStyle(a, null) || {}
            },
            i = {
                getParent: function(b, c) {
                    var d = b,
                        e = b.parentNode;
                    return c && "prev" != c || !e || !g.test(e.nodeName || "") || (e = e.parentNode), "self" != c && (d = "prev" == c ? b.previousElementSibling : c && (e.closest || a.jQuery) ? (e.closest ? e.closest(c) : jQuery(e).closest(c)[0]) || e : e), d
                },
                getFit: function(a) {
                    var b, c, d = h(a),
                        g = d.content || d.fontFamily,
                        j = {
                            fit: a._lazysizesParentFit || a.getAttribute("data-parent-fit")
                        };
                    return !j.fit && g && (b = g.match(e)) && (j.fit = b[1]), j.fit ? (c = a._lazysizesParentContainer || a.getAttribute("data-parent-container"), !c && g && (b = g.match(f)) && (c = b[1]), j.parent = i.getParent(a, c)) : j.fit = d.objectFit, j
                },
                getImageRatio: function(b) {
                    var c, e, f, h, i, j, k, l = b.parentNode,
                        m = l && g.test(l.nodeName || "") ? l.querySelectorAll("source, img") : [b];
                    for (c = 0; c < m.length; c++)
                        if (b = m[c], e = b.getAttribute(lazySizesConfig.srcsetAttr) || b.getAttribute("srcset") || b.getAttribute("data-pfsrcset") || b.getAttribute("data-risrcset") || "", f = b._lsMedia || b.getAttribute("media"), f = lazySizesConfig.customMedia[b.getAttribute("data-media") || f] || f, e && (!f || (a.matchMedia && matchMedia(f) || {}).matches)) {
                            h = parseFloat(b.getAttribute("data-aspectratio")), h || (i = e.match(d), i ? "w" == i[2] ? (j = i[1], k = i[3]) : (j = i[3], k = i[1]) : (j = b.getAttribute("width"), k = b.getAttribute("height")), h = j / k);
                            break
                        } return h
                },
                calculateSize: function(a, b) {
                    var c, d, e, f, g = this.getFit(a),
                        h = g.fit,
                        i = g.parent;
                    return "width" == h || ("contain" == h || "cover" == h) && (e = this.getImageRatio(a)) ? (i ? b = i.clientWidth : i = a, f = b, "width" == h ? f = b : (d = i.clientHeight) > 40 && (c = b / d) && ("cover" == h && c < e || "contain" == h && c > e) && (f = b * (e / c)), f) : b
                }
            };
        c.parentFit = i, b.addEventListener("lazybeforesizes", function(a) {
            if (!a.defaultPrevented && a.detail.instance == c) {
                var b = a.target;
                a.detail.width = i.calculateSize(b, a.detail.width)
            }
        })
    }
});
! function(a, b) {
    var c = function() {
        b(a.lazySizes), a.removeEventListener("lazyunveilread", c, !0)
    };
    b = b.bind(null, a, a.document), "object" == typeof module && module.exports ? b(require("lazysizes")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, !0)
}(window, function(a, b, c) {
    "use strict";
    var d, e = c && c.cfg,
        f = b.createElement("img"),
        g = "sizes" in f && "srcset" in f,
        h = /\s+\d+h/g,
        i = function() {
            var a = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
                d = Array.prototype.forEach;
            return function() {
                var e = b.createElement("img"),
                    f = function(b) {
                        var c, d, e = b.getAttribute(lazySizesConfig.srcsetAttr);
                        e && (d = e.match(a)) && (c = "w" == d[2] ? d[1] / d[3] : d[3] / d[1], c && b.setAttribute("data-aspectratio", c), b.setAttribute(lazySizesConfig.srcsetAttr, e.replace(h, "")))
                    },
                    g = function(a) {
                        if (a.detail.instance == c) {
                            var b = a.target.parentNode;
                            b && "PICTURE" == b.nodeName && d.call(b.getElementsByTagName("source"), f), f(a.target)
                        }
                    },
                    i = function() {
                        e.currentSrc && b.removeEventListener("lazybeforeunveil", g)
                    };
                b.addEventListener("lazybeforeunveil", g), e.onload = i, e.onerror = i, e.srcset = "data:,a 1w 1h", e.complete && i()
            }
        }();
    if (e.supportsType || (e.supportsType = function(a) {
            return !a
        }), a.HTMLPictureElement && g) return void(!c.hasHDescriptorFix && b.msElementsFromPoint && (c.hasHDescriptorFix = !0, i()));
    a.picturefill || e.pf || (e.pf = function(b) {
        var c, e;
        if (!a.picturefill)
            for (c = 0, e = b.elements.length; c < e; c++) d(b.elements[c])
    }, d = function() {
        var f = function(a, b) {
                return a.w - b.w
            },
            i = /^\s*\d+\.*\d*px\s*$/,
            j = function(a) {
                var b, c, d = a.length,
                    e = a[d - 1],
                    f = 0;
                for (f; f < d; f++)
                    if (e = a[f], e.d = e.w / a.w, e.d >= a.d) {
                        !e.cached && (b = a[f - 1]) && b.d > a.d - .13 * Math.pow(a.d, 2.2) && (c = Math.pow(b.d - .6, 1.6), b.cached && (b.d += .15 * c), b.d + (e.d - a.d) * c > a.d && (e = b));
                        break
                    } return e
            },
            k = function() {
                var a, b = /(([^,\s].[^\s]+)\s+(\d+)w)/g,
                    c = /\s/,
                    d = function(b, c, d, e) {
                        a.push({
                            c: c,
                            u: d,
                            w: 1 * e
                        })
                    };
                return function(e) {
                    return a = [], e = e.trim(), e.replace(h, "").replace(b, d), a.length || !e || c.test(e) || a.push({
                        c: e,
                        u: e,
                        w: 99
                    }), a
                }
            }(),
            l = function() {
                l.init || (l.init = !0, addEventListener("resize", function() {
                    var a, c = b.getElementsByClassName("lazymatchmedia"),
                        e = function() {
                            var a, b;
                            for (a = 0, b = c.length; a < b; a++) d(c[a])
                        };
                    return function() {
                        clearTimeout(a), a = setTimeout(e, 66)
                    }
                }()))
            },
            m = function(b, d) {
                var f, g = b.getAttribute("srcset") || b.getAttribute(e.srcsetAttr);
                !g && d && (g = b._lazypolyfill ? b._lazypolyfill._set : b.getAttribute(e.srcAttr) || b.getAttribute("src")), b._lazypolyfill && b._lazypolyfill._set == g || (f = k(g || ""), d && b.parentNode && (f.isPicture = "PICTURE" == b.parentNode.nodeName.toUpperCase(), f.isPicture && a.matchMedia && (c.aC(b, "lazymatchmedia"), l())), f._set = g, Object.defineProperty(b, "_lazypolyfill", {
                    value: f,
                    writable: !0
                }))
            },
            n = function(b) {
                var d = a.devicePixelRatio || 1,
                    e = c.getX && c.getX(b);
                return Math.min(e || d, 2.5, d)
            },
            o = function(b) {
                return a.matchMedia ? (o = function(a) {
                    return !a || (matchMedia(a) || {}).matches
                })(b) : !b
            },
            p = function(a) {
                var b, d, g, h, k, l, p;
                if (h = a, m(h, !0), k = h._lazypolyfill, k.isPicture)
                    for (d = 0, b = a.parentNode.getElementsByTagName("source"), g = b.length; d < g; d++)
                        if (e.supportsType(b[d].getAttribute("type"), a) && o(b[d].getAttribute("media"))) {
                            h = b[d], m(h), k = h._lazypolyfill;
                            break
                        } return k.length > 1 ? (p = h.getAttribute("sizes") || "", p = i.test(p) && parseInt(p, 10) || c.gW(a, a.parentNode), k.d = n(a), !k.src || !k.w || k.w < p ? (k.w = p, l = j(k.sort(f)), k.src = l) : l = k.src) : l = k[0], l
            },
            q = function(a) {
                if (!g || !a.parentNode || "PICTURE" == a.parentNode.nodeName.toUpperCase()) {
                    var b = p(a);
                    b && b.u && a._lazypolyfill.cur != b.u && (a._lazypolyfill.cur = b.u, b.cached = !0, a.setAttribute(e.srcAttr, b.u), a.setAttribute("src", b.u))
                }
            };
        return q.parse = k, q
    }(), e.loadedClass && e.loadingClass && function() {
        var a = [];
        ['img[sizes$="px"][srcset].', "picture > img:not([srcset])."].forEach(function(b) {
            a.push(b + e.loadedClass), a.push(b + e.loadingClass)
        }), e.pf({
            elements: b.querySelectorAll(a.join(", "))
        })
    }())
});
! function(a, b) {
    var c = function() {
        b(a.lazySizes), a.removeEventListener("lazyunveilread", c, !0)
    };
    b = b.bind(null, a, a.document), "object" == typeof module && module.exports ? b(require("lazysizes")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, !0)
}(window, function(a, b, c) {
    "use strict";
    if (a.addEventListener) {
        var d = /\s+/g,
            e = /\s*\|\s+|\s+\|\s*/g,
            f = /^(.+?)(?:\s+\[\s*(.+?)\s*\])(?:\s+\[\s*(.+?)\s*\])?$/,
            g = /^\s*\(*\s*type\s*:\s*(.+?)\s*\)*\s*$/,
            h = /\(|\)|'/,
            i = {
                contain: 1,
                cover: 1
            },
            j = function(a) {
                var b = c.gW(a, a.parentNode);
                return (!a._lazysizesWidth || b > a._lazysizesWidth) && (a._lazysizesWidth = b), a._lazysizesWidth
            },
            k = function(a) {
                var b;
                return b = (getComputedStyle(a) || {
                    getPropertyValue: function() {}
                }).getPropertyValue("background-size"), !i[b] && i[a.style.backgroundSize] && (b = a.style.backgroundSize), b
            },
            l = function(a, b) {
                if (b) {
                    var c = b.match(g);
                    c && c[1] ? a.setAttribute("type", c[1]) : a.setAttribute("media", lazySizesConfig.customMedia[b] || b)
                }
            },
            m = function(a, c, g) {
                var h = b.createElement("picture"),
                    i = c.getAttribute(lazySizesConfig.sizesAttr),
                    j = c.getAttribute("data-ratio"),
                    k = c.getAttribute("data-optimumx");
                c._lazybgset && c._lazybgset.parentNode == c && c.removeChild(c._lazybgset), Object.defineProperty(g, "_lazybgset", {
                    value: c,
                    writable: !0
                }), Object.defineProperty(c, "_lazybgset", {
                    value: h,
                    writable: !0
                }), a = a.replace(d, " ").split(e), h.style.display = "none", g.className = lazySizesConfig.lazyClass, 1 != a.length || i || (i = "auto"), a.forEach(function(a) {
                    var c, d = b.createElement("source");
                    i && "auto" != i && d.setAttribute("sizes", i), (c = a.match(f)) ? (d.setAttribute(lazySizesConfig.srcsetAttr, c[1]), l(d, c[2]), l(d, c[3])) : d.setAttribute(lazySizesConfig.srcsetAttr, a), h.appendChild(d)
                }), i && (g.setAttribute(lazySizesConfig.sizesAttr, i), c.removeAttribute(lazySizesConfig.sizesAttr), c.removeAttribute("sizes")), k && g.setAttribute("data-optimumx", k), j && g.setAttribute("data-ratio", j), h.appendChild(g), c.appendChild(h)
            },
            n = function(a) {
                if (a.target._lazybgset) {
                    var b = a.target,
                        d = b._lazybgset,
                        e = b.currentSrc || b.src;
                    if (e) {
                        var f = c.fire(d, "bgsetproxy", {
                            src: e,
                            useSrc: h.test(e) ? JSON.stringify(e) : e
                        });
                        f.defaultPrevented || (d.style.backgroundImage = "url(" + f.detail.useSrc + ")")
                    }
                    b._lazybgsetLoading && (c.fire(d, "_lazyloaded", {}, !1, !0), delete b._lazybgsetLoading)
                }
            };
        addEventListener("lazybeforeunveil", function(a) {
            var d, e, f;
            !a.defaultPrevented && (d = a.target.getAttribute("data-bgset")) && (f = a.target, e = b.createElement("img"), e.alt = "", e._lazybgsetLoading = !0, a.detail.firesLoad = !0, m(d, f, e), setTimeout(function() {
                c.loader.unveil(e), c.rAF(function() {
                    c.fire(e, "_lazyloaded", {}, !0, !0), e.complete && n({
                        target: e
                    })
                })
            }))
        }), b.addEventListener("load", n, !0), a.addEventListener("lazybeforesizes", function(a) {
            if (a.detail.instance == c && a.target._lazybgset && a.detail.dataAttr) {
                var b = a.target._lazybgset,
                    d = k(b);
                i[d] && (a.target._lazysizesParentFit = d, c.rAF(function() {
                    a.target.setAttribute("data-parent-fit", d), a.target._lazysizesParentFit && delete a.target._lazysizesParentFit
                }))
            }
        }, !0), b.documentElement.addEventListener("lazybeforesizes", function(a) {
            !a.defaultPrevented && a.target._lazybgset && a.detail.instance == c && (a.detail.width = j(a.target._lazybgset))
        })
    }
})

function trackAddToCart(formserialdata, event) {
    const utils = {
        getFormattedPrice: function(price) {
            return `${(price/100).toFixed(2)}`
        },
        getIntegerPrice: function(price) {
            return parseInt(price.slice(1))
        },
        getProductDiscountCollection: function(price, compareAtPrice) {
            const intPrice = this.getIntegerPrice(price);
    
            const intCompareAtPrice = this.getIntegerPrice(compareAtPrice);
            if (intCompareAtPrice === 0) {
                return intCompareAtPrice.toFixed(2)
            }
            return `${(intCompareAtPrice - intPrice).toFixed(2)}`
        },
        getProductPosition: function(productID) {
            const products = [...document.querySelectorAll( '.product[data-id]')];
            const position = products.findIndex(otherProduct => otherProduct.dataset.id === productID)
            return position;
        },
        getProductDiscount: function(product) {
            if (!product.compare_at_price) return this.getFormattedPrice(0)
            return this.getFormattedPrice(product.price - product.compare_at_price);
        }
    }
    const formData = formserialdata.split('&').reduce((acc, item) => {
        const [key, value] = item.split('=');
        return {...acc, [key]: value}
    }, {})
    const trackingData = document.querySelector(`[data-tracking-id]`);
    if (trackingData) {

    
    const selectedVariantID = event.target.querySelector('select').value
    const selectedVariantData = document.querySelector(`[data-tracking-id="${selectedVariantID}"]`)
    const variantData = JSON.parse(selectedVariantData.dataset.trackingVariant);
    const productData = JSON.parse(trackingData.dataset.trackingProduct);
    const collectionData = JSON.parse(trackingData.dataset.trackingCollection);
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
    event: "add_to_cart",
    ecommerce: {
        items: [
            {
                item_id: variantData.sku,
                item_name: productData.title,
                affiliation: Shopify.shop,
                currency: Shopify.currency.active,
                discount: utils.getProductDiscount(productData),
                index: 0,
                item_brand: productData.vendor,
                item_category: productData.type,
                item_list_id: collectionData?.handle || 'all',
                item_list_name: collectionData?.title || 'All',
                item_variant: variantData.title,
                price: utils.getFormattedPrice(productData.price),
                quantity: formData.quantity
            }
        ]
    }
    })
    } else {
        const variantID = formData.id;
        const variantEle = document.querySelector(`[data-variant-id="${variantID}"]`);
        const size = variantEle.innerHTML
        const dataProduct = event.target.parentNode.parentNode.parentNode
        const productID = dataProduct.dataset.id;
        let productData;
        if (dataProduct.dataset.trackingProduct) {
            productData = JSON.parse(dataProduct.dataset.trackingProduct);
        } else {
            productData = JSON.parse(dataProduct.parentNode.dataset.trackingProduct);
        }
        const colour = productData.variant_title.split(' /')[0];
        const variantTitle = colour + " /" + size
        let collectionData = document.querySelector('[data-tracking-collection]');
        if (collectionData != null) {
            collectionData = JSON.parse(collectionData.dataset?.trackingCollection);
        };
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
            items: [
                {
                    item_id: productData.sku,
                    item_name: productData.title,
                    affiliation: Shopify.shop,
                    currency: Shopify.currency.active,
                    discount: utils.getProductDiscountCollection(productData.price, productData.compare_at_price),
                    index: utils.getProductPosition(productID),
                    item_brand: productData.vendor,
                    item_category: productData.type,
                    item_list_id: collectionData?.handle || 'all',
                    item_list_name: collectionData?.title || 'All',
                    item_variant: variantTitle,
                    price: productData.price.slice(1),
                    promotion_id: null,
                    promotion_name: null,
                    quantity: formData.quantity
        
                }
            ]
        }
        })
    }
}

// reset page load state used for packaging options used in the checkout
window.onload = function() {
    localStorage.setItem('pageUpdated', 'false');
    localStorage.setItem('packaging_option_changed', 'false')
}

$(window).on('load', function() {
    if ($(".read-more-button")) {
        $(".read-more-button").click(function() {
            var number = $(this).attr("data-num");
            $('.slider--world_of_nt_charity[data-num="' + number + '"]').toggle();
            $('.slider--world_of_nt_charity[data-num="' + number + '"]').slick("refresh");
            let textContainer = $(this).parents('.charity-text').find('.more-text');
            $(textContainer ).toggle()
            $(this).parents('.charity-text').find('.read-more-button-collapsed').toggle()
            });
    }
  });

function debounce(func, timeout = 300){
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}

function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
  
    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;
  
    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
    summaryElement.focus();
  }

  const trapFocusHandlers = {};

  function getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    );
  }

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

  class MenuDrawer extends HTMLElement {
    constructor() {
      super();
  
      this.mainDetailsToggle = this.querySelector('details');
  
      this.addEventListener('keyup', this.onKeyUp.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.bindEvents();
    }
  
    bindEvents() {
      this.querySelectorAll('summary').forEach((summary) =>
        summary.addEventListener('click', this.onSummaryClick.bind(this))
      );
      this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
        button.addEventListener('click', this.onCloseButtonClick.bind(this))
      );
    }
  
    onKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
  
      const openDetailsElement = event.target.closest('details[open]');
      if (!openDetailsElement) return;
  
      openDetailsElement === this.mainDetailsToggle
        ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
        : this.closeSubmenu(openDetailsElement);
    }
  
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.has-submenu');
      const isOpen = detailsElement.hasAttribute('open');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  
      function addTrapFocus() {
        trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
        summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
      }
  
      if (detailsElement === this.mainDetailsToggle) {
        if (isOpen) event.preventDefault();
        isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
  
        if (window.matchMedia('(max-width: 990px)')) {
          document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
        }
      } else {
        setTimeout(() => {
          detailsElement.classList.add('menu-opening');
          summaryElement.setAttribute('aria-expanded', true);
          parentMenuElement && parentMenuElement.classList.add('submenu-open');
          !reducedMotion || reducedMotion.matches
            ? addTrapFocus()
            : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
        }, 100);
      }
    }
  
    openMenuDrawer(summaryElement) {
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      });
      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(this.mainDetailsToggle, summaryElement);
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
  
    closeMenuDrawer(event, elementToFocus = false) {
      if (event === undefined) return;
  
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
        submenu.classList.remove('submenu-open');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
  
      if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
    }
  
    onFocusOut() {
      setTimeout(() => {
        if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
          this.closeMenuDrawer();
      });
    }
  
    onCloseButtonClick(event) {
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
  
    closeSubmenu(detailsElement) {
      const parentMenuElement = detailsElement.closest('.submenu-open');
      parentMenuElement && parentMenuElement.classList.remove('submenu-open');
      detailsElement.classList.remove('menu-opening');
      detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
      removeTrapFocus(detailsElement.querySelector('summary'));
      this.closeAnimation(detailsElement);
    }
  
    closeAnimation(detailsElement) {
      let animationStart;
  
      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }
  
        const elapsedTime = time - animationStart;
  
        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
          if (detailsElement.closest('details[open]')) {
            trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
          }
        }
      };
  
      window.requestAnimationFrame(handleAnimation);
    }
  }

function removeTrapFocus(elementToFocus = null) {
document.removeEventListener('focusin', trapFocusHandlers.focusin);
document.removeEventListener('focusout', trapFocusHandlers.focusout);
document.removeEventListener('keydown', trapFocusHandlers.keydown);

if (elementToFocus) elementToFocus.focus();
}

customElements.define('menu-drawer', MenuDrawer);

document.addEventListener('click', function (event) {
    const link = event.target.closest('.shop-similar-cta a[href="#"]');
    if (!link) return;
    event.preventDefault();
    const relatedProductsSection = document.getElementById('related-products');
    if (relatedProductsSection) {
        const y = relatedProductsSection.getBoundingClientRect().top + window.scrollY - 130;
        window.scrollTo({top: y, behavior: 'smooth'});
        const firstButton = relatedProductsSection.querySelector('button');
        if (firstButton) {
          firstButton.click();
        }
    }
});